export interface DicaContent {
  icone: string
  texto: string
}
export interface AtencaoContent {
  icone: string
  texto: string
}

export interface ChecklistItemContent {
  id: string
  texto: string
}

export interface MetadadoField {
  campo: string
  label: string
  tipo: 'text' | 'textarea' | 'select' | 'number'
  placeholder?: string
  opcoes?: string[]
}

export interface TopicoContent {
  topicoId: string
  resumo: string[]
  dicasDeOuro: DicaContent[]
  atencao: AtencaoContent[]
  checklistAplicabilidade: ChecklistItemContent[]
  metadados: MetadadoField[]
  temFerramenta: boolean
}

const TOPICOS_CONTENT: TopicoContent[] = [
  {
    topicoId: 'terreno-01',
    resumo: [
      'O terreno é a maior alavanca de custo · pequenos ajustes no lote movem centenas de milhares de reais',
      'Três alavancas movem o orçamento de verdade: terreno, projeto e mão de obra · o resto pesa pouco',
      'O terreno força dimensões, pavimentos, layout, rampas e tipo de fundação · não o contrário',
      'Projeto reativo ao terreno evita o erro mais caro: projetar como se o lote fosse plano',
      'Mão de obra consome ~40% do orçamento; fundação ~6% dos materiais · ambas moldadas pelo lote',
    ],
    dicasDeOuro: [
      {
        icone: '🎯',
        texto:
          'Avalie o terreno antes de fechar o projeto · ele vai ditar pavimentos, metragem e sistema construtivo',
      },
      {
        icone: '💰',
        texto:
          'Se o terreno for inviável para o orçamento, trocar o lote pode ser mais econômico que tentar adaptar a obra',
      },
      {
        icone: '📊',
        texto:
          'Use terreno, projeto e mão de obra como filtro: qualquer corte grande de custo virá dessas três áreas',
      },
    ],
    atencao: [
      {
        icone: '🚨',
        texto:
          'Comprar sem análise de topografia expõe a perdas de R$100k–R$450k · casos reais documentados',
      },
      {
        icone: '💸',
        texto:
          'Ignorar o terreno no projeto gera pavimentos, rampas e metragem forçados que inflam o custo sem perceber',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'terreno-01-cl1',
        texto: 'Analisei a topografia e inclinação do lote antes de fechar o projeto',
      },
      {
        id: 'terreno-01-cl2',
        texto: 'Avaliei o impacto do terreno nos pavimentos, metragem e layout da casa',
      },
      {
        id: 'terreno-01-cl3',
        texto: 'Identifiquei onde posso atuar no orçamento (terreno, projeto ou mão de obra)',
      },
      {
        id: 'terreno-01-cl4',
        texto: 'Verifiquei se a topografia impõe fundação especial ou contenção',
      },
      {
        id: 'terreno-01-cl5',
        texto: 'Comparei o custo total do lote (terreno + intervenções) com alternativas',
      },
    ],
    metadados: [
      {
        campo: 'topografia',
        label: 'Tipo de Topografia',
        tipo: 'select',
        opcoes: [
          'Plano',
          'Aclive leve (<15%)',
          'Aclive moderado (15–30%)',
          'Aclive acentuado (>30%)',
          'Declive leve',
          'Declive moderado',
          'Declive acentuado',
        ],
      },
      {
        campo: 'area_terreno',
        label: 'Área do Terreno',
        tipo: 'number',
        placeholder: 'Ex: 300 (m²)',
      },
    ],
    temFerramenta: true,
  },

  {
    topicoId: 'terreno-02',
    resumo: [
      'Lote em aclive é o que sobe em relação à rua · toda análise de custo usa a rua como referência',
      'Remodelar a superfície do lote é o item mais caro da construção · mais ainda do que edificar',
      'Custo de remodelação não vira casa · é custo de preparação sem metragem nem acabamento',
      'Esse custo escapa do metro quadrado · cada intervenção é única e impossível de parametrizar',
      'Incorporadores classificam intervenções no terreno como custo de terreno, não de obra',
      'Quanto mais metragem a casa tem, mais área fica enterrada · e mais terra precisa sair',
    ],
    dicasDeOuro: [
      {
        icone: '🎯',
        texto:
          'Adapte a planta à topografia, nunca o terreno à planta · mudanças no projeto custam muito menos do que intervenções no solo',
      },
      {
        icone: '💰',
        texto:
          'Reduzir muro de arrimo de 4m para 2m gera economia de R$50–60 mil · cada decisão de projeto deve mirar menos terra',
      },
      {
        icone: '🏗️',
        texto:
          'Localize a casa acima da linha de corte · pavimentos enterrados têm menos luz, mais umidade e custo de construção maior',
      },
      {
        icone: '📊',
        texto:
          'Orce intervenção no lote como custo de terreno separado · somá-la ao metro quadrado da obra leva a subestimativa grave',
      },
    ],
    atencao: [
      {
        icone: '🏚️',
        texto:
          'Casa locada abaixo da linha de corte acumula umidade e mofo · riscos reais de problemas respiratórios e dermatológicos nos moradores',
      },
      {
        icone: '💸',
        texto:
          'Terreno barato com aclive acentuado pode custar mais que um plano valorizado · some sempre o custo de intervenção ao preço de compra',
      },
      {
        icone: '🚨',
        texto:
          'O custo de remodelação não aparece no orçamento por metro quadrado · quem não separa essa verba é surpreendido no meio da obra',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'terreno-02-cl1',
        texto: 'Identifiquei o desnível do lote em relação à rua e medi a altura do aclive',
      },
      {
        id: 'terreno-02-cl2',
        texto: 'Verifiquei a cota máxima de construção na prefeitura ou regulamento do condomínio',
      },
      {
        id: 'terreno-02-cl3',
        texto: 'Estimei o volume de terra a remover para encaixar a planta atual',
      },
      {
        id: 'terreno-02-cl4',
        texto: 'Avaliei se a metragem planejada permite locar a casa acima da linha de corte',
      },
      {
        id: 'terreno-02-cl5',
        texto: 'Orçamentei o custo de intervenção no lote separado do custo da edificação',
      },
      {
        id: 'terreno-02-cl6',
        texto: 'Comparei o custo total do terreno (preço de compra + intervenção) com alternativas',
      },
    ],
    metadados: [
      {
        campo: 'desnivel_metros',
        label: 'Desnível do Lote',
        tipo: 'number',
        placeholder: 'Ex: 4 (m)',
      },
      {
        campo: 'cota_maxima_construcao',
        label: 'Cota Máxima de Construção',
        tipo: 'number',
        placeholder: 'Ex: 6 (m)',
      },
      {
        campo: 'custo_intervencao_lote',
        label: 'Custo Estimado de Intervenção',
        tipo: 'number',
        placeholder: 'Ex: 80000 (R$)',
      },
    ],
    temFerramenta: true,
  },

  {
    topicoId: 'terreno-03',
    resumo: [
      'A construção em aclive gera cinco onerações encadeadas: botafora de terra, arrimos, impermeabilização, drenagem e custo de tempo',
      'A terra escavada aumenta 30–40% em volume ao ser removida por empolamento · calcule sempre com 40% a mais',
      'O custo do muro de arrimo cresce de forma exponencial com a altura · um aumento de 1m pode dobrar o preço',
      'Todo muro de arrimo precisa ser impermeabilizado nas costas · solo saturado exerce pressão de até 1 tonelada por metro cúbico',
      'A falta de drenagem é a principal causa de colapsos de muros de arrimo, mais do que falhas estruturais',
      'Para cada R$1 gasto em botafora de terra, gasta-se de R$1 a R$2 adicionais nas onerações consequentes',
      'A preparação de um aclive pode consumir de 2 a 6 meses de obra, gerando custo fixo de equipe e gerenciamento',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto:
          'Calcule o volume de terra a remover e adicione 40% de empolamento · o número de caminhões sempre surpreende',
      },
      {
        icone: '💡',
        texto:
          'Prefira contratar o botafora por valor fixo de empreitada · o risco do empolamento fica com o contratado',
      },
      {
        icone: '💡',
        texto:
          'Minimize a altura do muro de arrimo sempre que possível · cada metro a menos reduz o custo de forma desproporcional',
      },
      {
        icone: '💡',
        texto:
          'A drenagem atrás do muro não é opcional · é o item que define se o muro ficará de pé na primeira chuva forte',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Muro de arrimo sem drenagem é risco real de colapso · a maioria dos acidentes com muros vem da falta de drenagem, não de falha estrutural',
      },
      {
        icone: '⚠️',
        texto:
          'O efeito cascata é subestimado: tirar terra aciona automaticamente arrimo, impermeabilização e drenagem · nunca orce apenas o botafora isolado',
      },
      {
        icone: '⚠️',
        texto:
          'O tempo consumido preparando o aclive gera custo fixo de equipe que raramente entra no cálculo inicial',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'terreno-03-cl1',
        texto: 'Calculei o volume de terra a remover com 40% de empolamento incluído',
      },
      { id: 'terreno-03-cl2', texto: 'Obtive orçamento de botafora por valor fixo de empreitada' },
      {
        id: 'terreno-03-cl3',
        texto: 'Avaliei a menor altura possível para o muro de arrimo no meu projeto',
      },
      {
        id: 'terreno-03-cl4',
        texto: 'Incluí impermeabilização nas costas do muro de arrimo no orçamento',
      },
      {
        id: 'terreno-03-cl5',
        texto: 'Incluí sistema de drenagem atrás do muro no projeto e orçamento',
      },
      {
        id: 'terreno-03-cl6',
        texto: 'Estimei o tempo de preparação do terreno e seu impacto no cronograma e custo fixo',
      },
    ],
    metadados: [
      {
        campo: 'volume_terra_m3',
        label: 'Volume de Terra a Remover (m³)',
        tipo: 'number',
        placeholder: 'Ex: 80',
      },
      {
        campo: 'custo_botafora',
        label: 'Orçamento Botafora (R$)',
        tipo: 'number',
        placeholder: 'Ex: 8000',
      },
      {
        campo: 'altura_arrimo',
        label: 'Altura Máxima do Arrimo (m)',
        tipo: 'number',
        placeholder: 'Ex: 2.5',
      },
      {
        campo: 'custo_total_contencao',
        label: 'Custo Total das Onerações (R$)',
        tipo: 'number',
        placeholder: 'Ex: 25000',
      },
    ],
    temFerramenta: false,
  },

  {
    topicoId: 'terreno-04',
    resumo: [
      'Aclive leve (corte até 1,7m, área 15×15m): custo total de intervenção ficou em R$70 mil · botafora, arrimo, drenagem e impermeabilização inclusos',
      'Aclive moderado (muro de 3m, pavimento abaixo do nível da rua): custo de R$130 mil · quase o dobro do caso leve',
      'Aclive pesado (desnível de 13m, casa quase inteiramente abaixo da linha de corte): custo de R$300 mil apenas em intervenção de terreno',
      'Muros de arrimo tornam-se expressivamente mais caros a partir de 2m de altura · essa é a fronteira crítica para o orçamento',
      'Em aclives com grande volume de corte, arrimos laterais junto aos vizinhos também se tornam necessários, amplificando o custo',
      'Posicionar pavimentos abaixo do nível da rua cria risco permanente de entrada de água de chuva · pode exigir bombeamento',
    ],
    dicasDeOuro: [
      {
        icone: '📊',
        texto:
          'Use as proporções dos casos reais como referência: corte até 2m → ~R$70 mil; 3m → ~R$130 mil; 13m → ~R$300 mil (ajuste pela sua região)',
      },
      {
        icone: '💡',
        texto:
          'Antes de comprar o lote, estime o volume de corte necessário · terreno barato com aclive pesado pode custar mais que um terreno plano mais valorizado',
      },
      {
        icone: '💡',
        texto:
          'Evite localizar pavimentos abaixo do nível da rua · o risco de infiltração e o custo de drenagem se tornam permanentes',
      },
      {
        icone: '💡',
        texto:
          'Se o corte for generalizado no lote, reserve orçamento para arrimos laterais nas divisas com vizinhos, não apenas no fundo',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Quanto mais inclinado o terreno e maior a metragem construída, maior a proporção da casa abaixo da linha de corte · todas as cinco onerações crescem juntas',
      },
      {
        icone: '⚠️',
        texto:
          'Pavimento abaixo do nível da rua em aclive moderado ou pesado pode exigir bombeamento de água de chuva · custo de operação permanente durante toda a vida do imóvel',
      },
      {
        icone: '⚠️',
        texto:
          'Vizinhos com edificações próximas ao limite do lote exigem contenções laterais · o custo não se restringe ao fundo do terreno',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'terreno-04-cl1',
        texto:
          'Classifiquei o aclive do meu terreno como leve (até 2m), moderado (2–5m) ou pesado (acima de 5m)',
      },
      {
        id: 'terreno-04-cl2',
        texto:
          'Estimei o custo de intervenção com base nas referências de proporção dos casos reais',
      },
      {
        id: 'terreno-04-cl3',
        texto: 'Avaliei se algum pavimento ficará abaixo do nível da rua e o impacto para drenagem',
      },
      {
        id: 'terreno-04-cl4',
        texto: 'Verifiquei a distância das edificações dos vizinhos ao limite do meu lote',
      },
      {
        id: 'terreno-04-cl5',
        texto: 'Incluí orçamento para arrimos laterais caso o corte se aproxime das divisas',
      },
      {
        id: 'terreno-04-cl6',
        texto: 'Comparei o custo total (terreno + intervenção) com alternativas de terreno plano',
      },
    ],
    metadados: [
      {
        campo: 'classe_aclive',
        label: 'Classificação do Aclive',
        tipo: 'select',
        opcoes: ['Leve (até 2m)', 'Moderado (2–5m)', 'Pesado (acima de 5m)'],
      },
      {
        campo: 'altura_corte_max',
        label: 'Altura Máxima do Corte (m)',
        tipo: 'number',
        placeholder: 'Ex: 3.0',
      },
      {
        campo: 'custo_intervencao_total',
        label: 'Custo Estimado de Intervenção (R$)',
        tipo: 'number',
        placeholder: 'Ex: 130000',
      },
      {
        campo: 'pavimento_abaixo_rua',
        label: 'Pavimento abaixo do nível da rua',
        tipo: 'select',
        opcoes: ['Não', 'Parcialmente', 'Sim'],
      },
    ],
    temFerramenta: false,
  },

  {
    topicoId: 'terreno-05',
    resumo: [
      'O talude é a estratégia mais simples para aclives leves · corte na encosta formando inclinação natural',
      'Solos argilosos compactos suportam taludes sem revegetação; solos arenosos exigem revestimento vegetal',
      'Compare ao menos 5 estratégias antes de decidir: talude, escalonamento, pilotis, muro de arrimo e deck/rebaixo',
      'O custo de cada estratégia varia de 5% (talude leve) a 50% (muro de arrimo acentuado) sobre o custo total',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto:
          'Visite casas na mesma rua · a solução mais usada pelos vizinhos é um indicador do que funciona no local',
      },
      {
        icone: '💡',
        texto:
          'Misturar estratégias (ex.: talude + escalonamento) pode ser mais econômico que uma solução única',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto: 'Toda estratégia com movimentação de terra acima de 50m³ exige ART de engenheiro',
      },
      {
        icone: '⚠️',
        texto:
          'Estratégias mal executadas em terrenos inclinados são causa frequente de deslizamento',
      },
    ],
    checklistAplicabilidade: [
      { id: 't05-cl1', texto: 'Identifiquei a estratégia mais adequada para o meu terreno' },
      { id: 't05-cl2', texto: 'Obtive orçamentos comparativos entre as estratégias elegíveis' },
      { id: 't05-cl3', texto: 'Validei a escolha com engenheiro civil ou geotécnico' },
    ],
    metadados: [
      {
        campo: 'estrategia_terreno',
        label: 'Estratégia de Terreno Escolhida',
        tipo: 'select',
        opcoes: [
          'Talude',
          'Escalonamento',
          'Pilotis',
          'Muro de arrimo',
          'Deck / Rebaixo',
          'Combinação',
          'Ainda não definido',
        ],
      },
    ],
    temFerramenta: true,
  },

  {
    topicoId: 'terreno-06',
    resumo: [
      'Escalonar é dividir um grande desnível em vários menores, reduzindo o custo de cada muro de arrimo',
      'O custo do arrimo cresce com a altura ao quadrado (empuxo) e ao cubo (momento) · não é linear',
      'Quebrar um arrimo de 5m em dois de 3m e 2m reduz o empuxo em ~48% e o momento em ~72%',
      'A estratégia exige que o projeto aceite dois níveis de piso, com acesso interno por escada ou rampa',
      'Caso real: escalonamento de arrimo em obra de R$3M gerou economia de R$200 mil na contenção',
      'Características do solo são imutáveis; a altura do arrimo é a variável que você controla no projeto',
    ],
    dicasDeOuro: [
      {
        icone: '📐',
        texto:
          'Peça ao arquiteto para simular o projeto em 2 níveis · a readequação de ambientes pode viabilizar o escalonamento sem perda funcional',
      },
      {
        icone: '✂️',
        texto:
          'Sempre que o arrimo planejado passar de 3m, avalie se é possível quebrá-lo: a economia cresce de forma exponencial com a altura',
      },
      {
        icone: '🏗️',
        texto:
          'O escalonamento pode ser combinado com talude nas partes intermediárias, reduzindo ainda mais o volume de contenção paga',
      },
      {
        icone: '💰',
        texto:
          'Solicite dois orçamentos: um com o arrimo único e outro com o escalonamento · a diferença justifica o custo da revisão de projeto',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Escalonar sem ajuste de projeto cria bolsões de terra sem contenção adequada · risco de deslizamento e infiltração na edificação',
      },
      {
        icone: '🔧',
        texto:
          'A área "escalonada" entre os dois muros precisa de drenagem própria; ignorar isso causa acúmulo de água e pressão hidrostática',
      },
      {
        icone: '📋',
        texto:
          'Muros de arrimo com mais de 1,5m de altura exigem projeto estrutural e ART de engenheiro · verifique a regulamentação municipal',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'terreno-06-cl1',
        texto: 'Identifiquei a altura total do desnível que precisa ser vencido no projeto',
      },
      {
        id: 'terreno-06-cl2',
        texto:
          'Avaliei com o arquiteto se o projeto comporta divisão em dois ou mais níveis de piso',
      },
      {
        id: 'terreno-06-cl3',
        texto:
          'Calculei o comparativo de custo entre arrimo único e escalonamento com o engenheiro',
      },
      { id: 'terreno-06-cl4', texto: 'Defini a posição dos muros escalonados no plano do terreno' },
      {
        id: 'terreno-06-cl5',
        texto: 'Incluí sistema de drenagem no projeto das áreas entre os muros escalonados',
      },
      {
        id: 'terreno-06-cl6',
        texto: 'Obtive ART do engenheiro responsável pelo projeto dos muros de arrimo',
      },
    ],
    metadados: [
      {
        campo: 'altura_desnivel_total',
        label: 'Altura Total do Desnível (m)',
        tipo: 'number',
        placeholder: 'Ex: 5',
      },
      {
        campo: 'altura_arrimo_1',
        label: 'Altura do 1º Arrimo (m)',
        tipo: 'number',
        placeholder: 'Ex: 3',
      },
      {
        campo: 'altura_arrimo_2',
        label: 'Altura do 2º Arrimo (m)',
        tipo: 'number',
        placeholder: 'Ex: 2',
      },
      {
        campo: 'economia_estimada',
        label: 'Economia Estimada (R$)',
        tipo: 'number',
        placeholder: 'Ex: 25000',
      },
    ],
    temFerramenta: true,
  },

  {
    topicoId: 'terreno-07',
    resumo: [
      'O pavimento de alívio é um volume estreito próximo à rua que vence grande parte do aclive sem enterrar a casa',
      'Deve ser o mais curto horizontalmente possível · cada metro a mais equivale a mais terra retirada',
      'A garagem é o uso ideal: já precisa ficar perto da rua e não exige grande pé-direito final',
      'Pé-direito do pavimento pode chegar a 4m; o excedente estético é resolvido com forro interno',
      'Custo de adaptação de terreno não é recuperável na venda · R$140k de aclive em obra de R$2M vira custo puro',
      'Estratégias mistas (pavimento de alívio + talude + arrimo menor) são mais econômicas do que uma solução única',
    ],
    dicasDeOuro: [
      {
        icone: '🚗',
        texto:
          'Use a garagem como pavimento de alívio · ela já precisa ficar perto da rua e elimina a necessidade de rampa longa',
      },
      {
        icone: '📏',
        texto:
          'Mantenha o pavimento de alívio o mais estreito possível · cada metro extra horizontal é terra que você vai pagar para retirar',
      },
      {
        icone: '🔄',
        texto:
          'Combine pavimento de alívio, talude e arrimo menor nos fundos; a solução mista costuma ser 30–40% mais barata que contenção única',
      },
      {
        icone: '📦',
        texto:
          "Jogue a caixa d'água para os fundos quando a altura máxima for apertada · ganha folga vertical na frente sem custo adicional",
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Enterrar a casa para adequar à altura máxima do condomínio aumenta o custo de corte exponencialmente · revisar o projeto é sempre mais barato',
      },
      {
        icone: '💸',
        texto:
          'Gastos com adaptação de terreno não se convertem em valor de venda: o comprador paga pelo acabamento e layout, não pela contenção',
      },
      {
        icone: '🏗️',
        texto:
          'Pavimento de alívio muito largo anula a estratégia · passa a gerar área de corte igual à situação sem ele',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'terreno-07-cl1',
        texto: 'Verifiquei a altura máxima de construção permitida pelo condomínio ou prefeitura',
      },
      {
        id: 'terreno-07-cl2',
        texto: 'Identifiquei a posição ideal do pavimento de alívio no projeto (próximo à rua)',
      },
      {
        id: 'terreno-07-cl3',
        texto: 'Defini o uso funcional do pavimento de alívio (garagem é o mais indicado)',
      },
      {
        id: 'terreno-07-cl4',
        texto: 'Confirmei com o arquiteto a largura mínima necessária para o pavimento de alívio',
      },
      {
        id: 'terreno-07-cl5',
        texto: 'Avaliei se o pé-direito excedente precisa ser tratado internamente com forro',
      },
      {
        id: 'terreno-07-cl6',
        texto: 'Planejei a estratégia de contenção nos fundos (talude, arrimo ou misto)',
      },
    ],
    metadados: [
      {
        campo: 'altura_aclive_pavimento',
        label: 'Altura do Aclive a Vencer (m)',
        tipo: 'number',
        placeholder: 'Ex: 5',
      },
      {
        campo: 'uso_pavimento_alivio',
        label: 'Uso do Pavimento de Alívio',
        tipo: 'select',
        opcoes: ['Garagem', 'Área de serviço', 'Depósito', 'Outro'],
      },
      {
        campo: 'custo_adaptacao_aclive',
        label: 'Custo Est. Adaptação de Aclive (R$)',
        tipo: 'number',
        placeholder: 'Ex: 80000',
      },
    ],
    temFerramenta: false,
  },

  {
    topicoId: 'terreno-08',
    resumo: [
      'Cota é o nível horizontal de referência da casa · variações de apenas 50cm mudam drasticamente o custo de corte',
      'Estudar fatias de 50cm acima e abaixo da cota atual revela opções com volume de escavação muito menor',
      'Subir a cota reduz o corte, mas aumenta a inclinação da rampa de acesso veicular',
      'Rampa ideal tem 10% de inclinação; o limite máximo é 20% · acima disso o carro toca o fundo',
      'Recuar a casa para o fundo do lote suaviza a rampa sem alterar a cota, combinando economia e acesso confortável',
      'Entrada lateral de veículos pode ganhar comprimento de rampa e manter uma cota mais econômica',
    ],
    dicasDeOuro: [
      {
        icone: '📐',
        texto:
          'Peça ao arquiteto 3 estudos de cota (original, +50cm, +100cm) · a diferença no custo de escavação costuma ser de R$10.000 a R$40.000 por fatia',
      },
      {
        icone: '🚗',
        texto:
          'Se a rampa ficar muito íngreme, recue a casa para o fundo do lote · ganha comprimento de rampa sem precisar baixar a cota',
      },
      {
        icone: '↔️',
        texto:
          'Explore entrada lateral de veículos: o ganho de profundidade suaviza a rampa mesmo em cotas elevadas',
      },
      {
        icone: '📏',
        texto:
          'Use 10% como meta de inclinação de rampa e 20% como limite absoluto na análise de cada cenário',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Rampa acima de 20% de inclinação é inviável na prática · carro raspa no fundo, criando risco de dano e inviabilizando acesso',
      },
      {
        icone: '📉',
        texto:
          'Cada 50cm que você desce a cota não é variação linear · o custo de corte cresce exponencialmente por conta da pressão de contenção',
      },
      {
        icone: '🔍',
        texto:
          'Comparar cotas sem simular a rampa completa gera projetos aprovados com acesso inviável, forçando revisão cara depois',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'terreno-08-cl1',
        texto: 'Identifiquei a cota atual do projeto e o volume de corte correspondente',
      },
      {
        id: 'terreno-08-cl2',
        texto: 'Simulei ao menos 3 cenários de cota (original, +50cm, +100cm) com o arquiteto',
      },
      {
        id: 'terreno-08-cl3',
        texto: 'Calculei a inclinação da rampa de acesso em cada cenário de cota',
      },
      {
        id: 'terreno-08-cl4',
        texto: 'Confirmei que a cota escolhida mantém a rampa abaixo de 20% de inclinação',
      },
      {
        id: 'terreno-08-cl5',
        texto: 'Avaliei recuar a casa para o fundo do lote para suavizar a rampa sem mudar a cota',
      },
      {
        id: 'terreno-08-cl6',
        texto: 'Escolhi a cota que equilibra menor volume de corte com acesso veicular confortável',
      },
    ],
    metadados: [
      {
        campo: 'cota_projeto_rua',
        label: 'Cota Acima da Rua (m)',
        tipo: 'number',
        placeholder: 'Ex: 1.5',
      },
      {
        campo: 'inclinacao_rampa_pct',
        label: 'Inclinação da Rampa (%)',
        tipo: 'number',
        placeholder: 'Ex: 15 (máx. 20)',
      },
      {
        campo: 'volume_corte_m3',
        label: 'Volume de Corte Estimado (m³)',
        tipo: 'number',
        placeholder: 'Ex: 120',
      },
    ],
    temFerramenta: true,
  },

  {
    topicoId: 'terreno-09',
    resumo: [
      'Declive é o terreno que cai em direção ao fundo · situação oposta ao aclive, com desafios e vantagens próprias',
      'Terrenos em declive oferecem vista para o horizonte, ventilação natural e iluminação superior a lotes planos',
      'A queda do terreno cria respiro visual: a casa não fica "engaiolada" pelos muros dos vizinhos',
      'Assim como o aclive, o declive tem armadilhas financeiras · construir sem estratégia encaro a obra',
      'O conhecimento das estratégias de aclive e declive se complementa · técnicas de um cenário podem ser usadas no outro',
    ],
    dicasDeOuro: [
      {
        icone: '🌅',
        texto:
          'Valorize as vantagens do declive ao definir o layout: posicione salas e suítes no lado da vista, maximizando a qualidade de vida',
      },
      {
        icone: '💨',
        texto:
          'Aproveite a circulação de vento natural do declive ao orientar aberturas · pode reduzir o uso de ar-condicionado',
      },
      {
        icone: '🏘️',
        texto:
          'Conheça as estratégias de aclive antes de lidar com o declive: várias soluções de contenção e escalonamento se aplicam a ambos',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Declive também tem armadilhas financeiras significativas · não subestime os custos de adaptação por ser "o lado oposto" do aclive',
      },
      {
        icone: '🌧️',
        texto:
          'Terrenos em declive concentram fluxo de água da chuva no fundo do lote · drenagem inadequada causa erosão e infiltrações graves',
      },
      {
        icone: '🔍',
        texto:
          'Avalie o declive antes de comprar o lote: inclinação acentuada exige estruturas específicas que podem inviabilizar o projeto',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'terreno-09-cl1',
        texto: 'Medi a inclinação total do declive do lote (desnível em metros e comprimento)',
      },
      {
        id: 'terreno-09-cl2',
        texto: 'Identifiquei as vantagens de vista e ventilação e planejei aproveitá-las no layout',
      },
      {
        id: 'terreno-09-cl3',
        texto: 'Verifiquei o escoamento de água da chuva e o ponto de acúmulo no fundo do lote',
      },
      {
        id: 'terreno-09-cl4',
        texto: 'Consultei profissional sobre estratégias adequadas para o tipo e grau de declive',
      },
      {
        id: 'terreno-09-cl5',
        texto:
          'Avaliei o impacto do declive no custo de fundação e contenção antes de comprar ou construir',
      },
    ],
    metadados: [
      {
        campo: 'desnivel_declive_m',
        label: 'Desnível Total do Declive (m)',
        tipo: 'number',
        placeholder: 'Ex: 4',
      },
      {
        campo: 'comprimento_lote_declive',
        label: 'Comprimento do Lote (m)',
        tipo: 'number',
        placeholder: 'Ex: 30',
      },
      {
        campo: 'vantagem_principal',
        label: 'Principal Vantagem do Lote',
        tipo: 'select',
        opcoes: ['Vista panorâmica', 'Ventilação natural', 'Iluminação', 'Privacidade', 'Outro'],
      },
    ],
    temFerramenta: false,
  },

  {
    topicoId: 'terreno-10',
    resumo: [
      'O principal risco do declive é explodir a metragem: o terreno força uma casa maior do que o orçamento comporta',
      'A linha zero (nível da rua) divide o projeto: acima fica a fachada visível; abaixo gera metragem subutilizada',
      'Área social (sala + cozinha + lazer + banheiro) consome no mínimo 120m²; quartos somam mais ~100m²',
      'Cada caixa de escada consome ~15m² por andar, mais área de circulação · e terrenos em declive exigem escadas',
      'Metragem acima do poder de compra não tem solução: sistema construtivo mais barato não salva m² em excesso',
      'O espaço abaixo da linha zero tende a virar depósito, lavanderia extra ou áreas pouco usadas · metragem desperdiçada',
    ],
    dicasDeOuro: [
      {
        icone: '📊',
        texto:
          'Defina seu poder de metragem antes de iniciar o projeto: orçamento total ÷ custo/m² do padrão desejado = limite máximo a respeitar',
      },
      {
        icone: '🏠',
        texto:
          'Distribua os ambientes mais usados no pavimento da rua · a área abaixo da linha zero deve receber apenas usos que justifiquem o acesso por escada',
      },
      {
        icone: '📐',
        texto:
          'Minimize caixas de escada: cada escada extra consome 15m² + circulação por pavimento, somando 30–40m² que não aparecem no programa',
      },
      {
        icone: '🔍',
        texto:
          'Antes de aprovar o projeto, some toda a metragem (incluindo escadas e corredores) e compare com seu poder de metragem',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Metragem além do poder de compra é o caminho mais comum para obra parar no meio · não existe atalho que resolva m² em excesso',
      },
      {
        icone: '📉',
        texto:
          'Área abaixo da linha zero costuma ser subutilizada: antes de aceitar o projeto, confirme o uso real de cada ambiente lá embaixo',
      },
      {
        icone: '🏗️',
        texto:
          'Projetos em declive com múltiplos pavimentos multiplicam áreas de circulação · revise o projeto com foco em eliminar corredores e escadas desnecessários',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'terreno-10-cl1',
        texto: 'Calculei meu poder de metragem (orçamento ÷ custo/m² do padrão)',
      },
      {
        id: 'terreno-10-cl2',
        texto: 'Somei a metragem total do projeto incluindo escadas, corredores e hall',
      },
      {
        id: 'terreno-10-cl3',
        texto: 'Confirmei que a metragem total não excede meu poder de metragem',
      },
      {
        id: 'terreno-10-cl4',
        texto: 'Verifiquei o uso real de cada ambiente posicionado abaixo da linha zero',
      },
      {
        id: 'terreno-10-cl5',
        texto:
          'Identifiquei e eliminei ambientes subutilizados que foram criados só para preencher a área de declive',
      },
      {
        id: 'terreno-10-cl6',
        texto: 'Contei o número de caixas de escada e avaliei se alguma pode ser eliminada',
      },
    ],
    metadados: [
      {
        campo: 'orcamento_total_obra',
        label: 'Orçamento Total da Obra (R$)',
        tipo: 'number',
        placeholder: 'Ex: 600000',
      },
      {
        campo: 'custo_m2_padrao',
        label: 'Custo por m² do Padrão (R$)',
        tipo: 'number',
        placeholder: 'Ex: 3000',
      },
      {
        campo: 'metragem_projeto_total',
        label: 'Metragem Total do Projeto (m²)',
        tipo: 'number',
        placeholder: 'Ex: 220',
      },
      {
        campo: 'metragem_abaixo_linha_zero',
        label: 'Área Abaixo da Linha Zero (m²)',
        tipo: 'number',
        placeholder: 'Ex: 80',
      },
    ],
    temFerramenta: true,
  },

  {
    topicoId: 'terreno-11',
    resumo: [
      'O declive cria três armadilhas: explosão de metragem, caixão perdido e a tentação de completar o vazio',
      'Caixão perdido é o espaço oco abaixo da casa · não entra na metragem de alvará, mas custa 20–30% do m² cheio',
      'Clientes frequentemente subestimam o caixão perdido: chegam ao nível da rua sem grana para a casa de verdade',
      'A armadilha da tentação: ao ver o espaço oco com teto e estrutura, o impulso é terminar e aumentar a obra',
      'Acabamento representa ~18% do custo total · o restante (laje, pilar, impermeabilização) já existe no caixão perdido',
      'A melhor estratégia é construir menos: cada m² dentro da meta vale mais do que m² vazio fora do orçamento',
    ],
    dicasDeOuro: [
      {
        icone: '🧩',
        texto:
          'Se o espaço abaixo da linha zero não comporta um uso real do dia a dia, minimize-o · 20 a 30% do m² ainda é muito dinheiro para um depósito',
      },
      {
        icone: '💰',
        texto:
          'Inclua o custo do caixão perdido no orçamento antes de assinar o projeto: pergunte ao projetista a metragem oca e multiplique por 25% do seu custo/m²',
      },
      {
        icone: '🚫',
        texto:
          'Resista à tentação de terminar o espaço oco durante a obra · isso é o início de uma expansão não planejada que compromete o orçamento final',
      },
      {
        icone: '🏠',
        texto:
          'Prefira realocar ambientes úteis para o nível abaixo (quarto, escritório) a deixar a área oca: metragem utilizável recalcula a conta a seu favor',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Caixão perdido não aparece na metragem de alvará mas aparece na conta da construtora: negocie o escopo com clareza antes de assinar o contrato',
      },
      {
        icone: '🔥',
        texto:
          'Expandir a obra no meio do processo para aproveitar o espaço oco é uma das principais causas de obra parada por falta de recurso',
      },
      {
        icone: '📉',
        texto:
          'Otimizar 50m² oco para uso real pode economizar R$15.000–R$40.000 comparado a construir, deixar vazio e depois querer terminar',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'terreno-11-cl1',
        texto:
          'Identifiquei a metragem oca (caixão perdido) no projeto e quantifiquei o custo estimado',
      },
      {
        id: 'terreno-11-cl2',
        texto: 'Calculei 25% do meu custo/m² × metragem oca para incluir no orçamento total',
      },
      {
        id: 'terreno-11-cl3',
        texto:
          'Avaliei se o espaço abaixo pode ser substituído por uso real (quarto, escritório, garagem)',
      },
      {
        id: 'terreno-11-cl4',
        texto:
          'Confirmei com o arquiteto a redução máxima possível da área oca sem comprometer o projeto',
      },
      {
        id: 'terreno-11-cl5',
        texto:
          'Estabeleci um compromisso formal de não expandir a obra durante a execução sem revisão orçamentária',
      },
      {
        id: 'terreno-11-cl6',
        texto:
          'Verifiquei que toda a metragem do projeto (incluindo caixão perdido) cabe no meu poder de metragem',
      },
    ],
    metadados: [
      {
        campo: 'metragem_oca_m2',
        label: 'Metragem Oca Estimada (m²)',
        tipo: 'number',
        placeholder: 'Ex: 40',
      },
      {
        campo: 'custo_caixao_perdido',
        label: 'Custo Est. Caixão Perdido (R$)',
        tipo: 'number',
        placeholder: 'Ex: 18000',
      },
      {
        campo: 'uso_previsto_subsolop',
        label: 'Uso Previsto no Espaço Inferior',
        tipo: 'select',
        opcoes: [
          'Garagem',
          'Quarto / Suíte',
          'Escritório',
          'Depósito',
          'Área de serviço',
          'Vazio (caixão perdido)',
        ],
      },
    ],
    temFerramenta: true,
  },

  {
    topicoId: 'terreno-12',
    resumo: [
      'Regra de ouro: declive até 50cm pode ser aterrado; acima disso, deixe vazio e apoie a construção sobre o terreno natural',
      'Aterro cede com o tempo · mesmo bem compactado, abate milímetros por ano e causa trincas generalizadas na casa',
      'Fundação sobre aterro é proibida: você gasta para aterrar e depois para perfurar até o solo original · custo duplo',
      'O espaço vazio abaixo da casa facilita manutenção de tubulações: vantagem única do declive sobre terrenos planos',
      'Colchão de ar abaixo da laje de piso reduz umidade ascendente · benefício técnico de manter o espaço vazio',
      'Para declive de ~2m (insuficiente para um pavimento), ajuste a cota acima para criar os 2,70m necessários',
    ],
    dicasDeOuro: [
      {
        icone: '📏',
        texto:
          'Use 50cm como limite decisivo: abaixo → aterro pode ser viável; acima → deixe vazio e aproveite as vantagens técnicas do espaço livre',
      },
      {
        icone: '🔧',
        texto:
          'Projete o espaço vazio abaixo da laje com acesso por alçapão ou duto de inspeção · facilita manutenção de encanamento no futuro',
      },
      {
        icone: '💧',
        texto:
          'O colchão de ar abaixo da casa reduz umidade ascendente: vantagem rara que terrenos planos não oferecem',
      },
      {
        icone: '⬆️',
        texto:
          'Declive de 1,5–2m que não fecha um andar completo? Ajuste a cota da casa para cima para criar os 2,70m de pé-direito necessários',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Aterro sobre 50cm é armadilha técnica e financeira: cede, trinca a casa e ainda exige fundação que perfura até o solo original · custo triplo',
      },
      {
        icone: '💸',
        texto:
          'Remodelar terreno (mover terra) custa mais por m² do que construir · gastar R$30.000 aterrando 2m de declive é dinheiro fora da sua casa',
      },
      {
        icone: '🏗️',
        texto:
          'Piso sobre aterro pode ceder independentemente da estrutura: o roda-pé fica no lugar enquanto o piso afunda · sinal de aterro cedendo',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'terreno-12-cl1',
        texto: 'Medi a queda real do terreno abaixo da linha zero em centímetros',
      },
      {
        id: 'terreno-12-cl2',
        texto: 'Apliquei a regra dos 50cm para decidir entre aterro e espaço vazio',
      },
      {
        id: 'terreno-12-cl3',
        texto: 'Confirmei com o engenheiro que a fundação não será apoiada sobre aterro',
      },
      {
        id: 'terreno-12-cl4',
        texto: 'Verifiquei o acesso futuro para manutenção de tubulações no espaço vazio',
      },
      {
        id: 'terreno-12-cl5',
        texto: 'Avaliado ajuste de cota para aproveitar declive de ~2m como pavimento completo',
      },
    ],
    metadados: [
      {
        campo: 'queda_terreno_cm',
        label: 'Queda do Terreno Abaixo da Rua (cm)',
        tipo: 'number',
        placeholder: 'Ex: 80',
      },
      {
        campo: 'decisao_espaco',
        label: 'Decisão para Espaço Abaixo',
        tipo: 'select',
        opcoes: [
          'Aterrar (até 50cm)',
          'Deixar vazio',
          'Ajustar cota para criar pavimento',
          'Ainda não definido',
        ],
      },
      {
        campo: 'volume_aterro_m3',
        label: 'Volume de Aterro Previsto (m³)',
        tipo: 'number',
        placeholder: 'Ex: 25 (apenas se até 50cm)',
      },
    ],
    temFerramenta: false,
  },

  {
    topicoId: 'terreno-13',
    resumo: [
      'Declive moderado: 3–4m abaixo da linha zero · altura suficiente para encaixar um pavimento completo',
      'Lote urbano típico de 300m² com declive moderado gera ~100m² de construção no nível inferior',
      'Com padrão de R$5.000/m², o pavimento inferior já representa R$500.000 de investimento inevitável',
      'Área rústica (sem acabamento) economiza apenas 20% do m² · ainda custa R$4.000/m², longe de "quase de graça"',
      'Tratar o pavimento inferior como subárea desperdiça R$400–500k numa área que merece planejamento rigoroso',
    ],
    dicasDeOuro: [
      {
        icone: '💰',
        texto:
          'Calcule o custo do pavimento inferior antes de definir seu uso: metragem × custo/m² do padrão = investimento real, mesmo sem acabamento fino',
      },
      {
        icone: '🏠',
        texto:
          'Priorize ambientes de uso frequente no pavimento inferior (suítes, escritório, academia real) · áreas raramente visitadas são desperdício de R$400–500k',
      },
      {
        icone: '📐',
        texto:
          'Aproveite o pé-direito generoso que o declive moderado permite · projete ambientes com teto entre 2,70m e 3,0m, não apenas um porão',
      },
      {
        icone: '🔄',
        texto:
          'Conecte os dois pavimentos com uma escada bem posicionada: acesso ruim é o maior motivo de subutilização do pavimento inferior',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Área "rústica" no pavimento inferior poupa só 20% do custo · você ainda vai gastar R$400k em espaço potencialmente subutilizado',
      },
      {
        icone: '📊',
        texto:
          'Declarar o pavimento inferior como "futuro" não reduz o custo presente de estrutura, laje e impermeabilização já executados',
      },
      {
        icone: '🔍',
        texto:
          'Revise o programa de necessidades antes do declive moderado: o pavimento inferior pode acomodar ambientes que liberariam metragem nobre no nível superior',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'terreno-13-cl1',
        texto: 'Medi a queda do terreno e confirmei que comporta um pavimento completo (≥ 2,70m)',
      },
      {
        id: 'terreno-13-cl2',
        texto: 'Calculei a metragem do pavimento inferior e multipliquei pelo custo/m² do padrão',
      },
      {
        id: 'terreno-13-cl3',
        texto: 'Defini o uso real e frequente de cada ambiente do pavimento inferior',
      },
      {
        id: 'terreno-13-cl4',
        texto: 'Eliminei ambientes de baixo uso do pavimento inferior para reduzir metragem total',
      },
      {
        id: 'terreno-13-cl5',
        texto: 'Posicionei a escada de acesso para facilitar a integração entre os dois pavimentos',
      },
      {
        id: 'terreno-13-cl6',
        texto:
          'Confirmei que a soma dos dois pavimentos está dentro do poder de metragem do orçamento',
      },
    ],
    metadados: [
      {
        campo: 'queda_terreno_moderado',
        label: 'Queda do Terreno (m)',
        tipo: 'number',
        placeholder: 'Ex: 3.5',
      },
      {
        campo: 'metragem_pav_inferior',
        label: 'Metragem do Pavimento Inferior (m²)',
        tipo: 'number',
        placeholder: 'Ex: 100',
      },
      {
        campo: 'custo_pav_inferior_est',
        label: 'Custo Est. Pavimento Inferior (R$)',
        tipo: 'number',
        placeholder: 'Ex: 500000',
      },
      {
        campo: 'uso_pav_inferior',
        label: 'Uso Principal do Pavimento Inferior',
        tipo: 'select',
        opcoes: [
          'Suítes / Quartos',
          'Escritório',
          'Academia',
          'Garagem',
          'Área social',
          'Misto',
          'Ainda não definido',
        ],
      },
    ],
    temFerramenta: true,
  },

  {
    topicoId: 'terreno-14',
    resumo: [
      'Declive grande: 2 pavimentos abaixo da linha zero + 1 acima = 3 andares totais impostos pelo terreno',
      'Três pavimentos equivalem a um pequeno prédio: a fundação precisa ser dimensionada de forma muito mais robusta e cara',
      'Com 3 andares, é quase impossível alinhar paredes entre pavimentos · estrutura assimétrica gera vigas maiores e mais caras',
      'Vigas robustas de compensação ficam próximas à laje e forçam forro baixo · sensação claustrofóbica e custo de acabamento extra',
      'Tubulações de drenagem percorrem 3 andares inteiros · escondê-las exige desvios que encarecem a obra',
      'O terreno pode impor 3 andares, mas estratégias de projeto permitem reduzir para 2 · é possível e deve ser tentado',
    ],
    dicasDeOuro: [
      {
        icone: '🏗️',
        texto:
          'Antes de aceitar 3 pavimentos, peça ao arquiteto opções que eliminem um andar · existem estratégias de projeto específicas para isso',
      },
      {
        icone: '🧱',
        texto:
          'Exija que o projeto alinhe paredes entre os 3 pavimentos ao máximo · cada parede sobre vazio vira uma viga cara e um teto baixo',
      },
      {
        icone: '📐',
        texto:
          'Projete o forro de gesso com pé-direito mínimo de 2,50m em todos os andares · verifique se as vigas permitem isso antes de aprovar',
      },
      {
        icone: '🌧️',
        texto:
          'Planeje as prumadas de drenagem no início do projeto: tubos de 3 andares precisam de shafts ou rebaixos de teto para não aparecerem',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Fundação de 3 pavimentos é dimensionada como pequeno prédio · custo pode ser 3–5× maior que fundação de casa térrea no mesmo solo',
      },
      {
        icone: '🔩',
        texto:
          'Estrutura assimétrica em 3 andares é praticamente inevitável: negocie com o engenheiro estrutural antes de aprovar o arquitetônico',
      },
      {
        icone: '💸',
        texto:
          'Aceitar 3 andares sem estratégia é o caminho mais direto para uma obra que estoura orçamento antes do acabamento começar',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'terreno-14-cl1',
        texto:
          'Confirmei com o arquiteto se é possível reduzir de 3 para 2 pavimentos com ajuste de cota ou layout',
      },
      {
        id: 'terreno-14-cl2',
        texto:
          'Solicitei projeto estrutural preliminar específico para 3 pavimentos antes de orçar',
      },
      {
        id: 'terreno-14-cl3',
        texto: 'Verifiquei o alinhamento de paredes entre os 3 pavimentos no projeto arquitetônico',
      },
      {
        id: 'terreno-14-cl4',
        texto: 'Confirmei pé-direito mínimo de 2,50m em todos os andares com o forro projetado',
      },
      {
        id: 'terreno-14-cl5',
        texto: 'Defini a localização dos shafts de drenagem que percorrem os 3 andares',
      },
      {
        id: 'terreno-14-cl6',
        texto: 'Comparei o orçamento de 3 andares vs. 2 andares com uma das estratégias de redução',
      },
    ],
    metadados: [
      {
        campo: 'num_pavimentos_declive',
        label: 'Número de Pavimentos',
        tipo: 'select',
        opcoes: ['1 (só acima da rua)', '2 (1 acima + 1 abaixo)', '3 (1 acima + 2 abaixo)'],
      },
      {
        campo: 'assimetria_estrutural',
        label: 'Estrutura com Assimetria Identificada',
        tipo: 'select',
        opcoes: ['Sim', 'Não', 'A verificar'],
      },
      {
        campo: 'custo_fundacao_3pav',
        label: 'Orçamento Fundação 3 Pavimentos (R$)',
        tipo: 'number',
        placeholder: 'Ex: 80000',
      },
    ],
    temFerramenta: false,
  },

  {
    topicoId: 'terreno-15',
    resumo: [
      'Declive gigante (4+ pavimentos) pode tornar inviável uma casa de porte pequeno · as escadas consomem a metragem',
      'Em 4 andares, só circulação vertical (escadas + halls) ocupa ~70m² · R$350.000 a R$5.000/m² sem usar nenhum cômodo',
      'Escadas em múltiplos andares exigem granito, guarda-corpo de vidro ou inox · material mais caro que o restante da casa',
      'Tentativa de encaixar a casa andar por andar força aumento de metragem indefinido: quarto puxa corredor, que puxa banheiro',
      'A única solução econômica para declive gigante é estrutura de pilares (pilotis) · menos metragem construída, mais estrutura exposta',
      'Declive acima de 20m pode inviabilizar qualquer projeto de casa residencial comum em termos financeiros',
    ],
    dicasDeOuro: [
      {
        icone: '🧮',
        texto:
          'Calcule o custo só das escadas antes de aprovar o projeto: número de andares × 15m² × custo/m² = dinheiro que nunca vira cômodo útil',
      },
      {
        icone: '🏛️',
        texto:
          'Para declives muito acentuados, avalie estrutura de pilotis · pilares conectando 2 plataformas custam menos do que construção maciça andar a andar',
      },
      {
        icone: '🚫',
        texto:
          'Não tente fazer a casa "pequena" num declive gigante encaixando programa andar por andar · a lógica do terreno força o crescimento',
      },
      {
        icone: '📋',
        texto:
          'Se o terreno impõe 4+ pavimentos, faça uma consulta de viabilidade antes de comprar ou avançar: pode ser inviável economicamente',
      },
    ],
    atencao: [
      {
        icone: '⛔',
        texto:
          'Declive gigante pode tornar o lote literalmente inviável para construção residencial · avalie viabilidade antes de comprar',
      },
      {
        icone: '💸',
        texto:
          'Guarda-corpo de vidro ou inox em múltiplos lances de escada pode custar R$50.000–R$120.000 só em proteção de acesso',
      },
      {
        icone: '⚠️',
        texto:
          'Estrutura de pilotis em declive gigante exige projeto estrutural especializado · não é decisão de canteiro, é decisão de escritório de engenharia',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'terreno-15-cl1',
        texto: 'Calculei a metragem consumida só por escadas e circulações em todos os pavimentos',
      },
      {
        id: 'terreno-15-cl2',
        texto: 'Avaliei a viabilidade econômica do projeto com a soma real de todos os andares',
      },
      {
        id: 'terreno-15-cl3',
        texto:
          'Solicitei estudo de pilotis ou estrutura de ponte como alternativa à construção maciça',
      },
      {
        id: 'terreno-15-cl4',
        texto: 'Verifiquei o custo de guarda-corpo e acabamento de escada para todos os lances',
      },
      {
        id: 'terreno-15-cl5',
        texto: 'Obtive parecer técnico sobre a viabilidade construtiva antes de avançar no projeto',
      },
    ],
    metadados: [
      {
        campo: 'queda_gigante_m',
        label: 'Queda Total do Terreno (m)',
        tipo: 'number',
        placeholder: 'Ex: 12',
      },
      {
        campo: 'num_lances_escada',
        label: 'Número de Lances de Escada Previstos',
        tipo: 'number',
        placeholder: 'Ex: 3',
      },
      {
        campo: 'custo_escadas_est',
        label: 'Custo Est. Escadas e Circulação (R$)',
        tipo: 'number',
        placeholder: 'Ex: 350000',
      },
      {
        campo: 'solucao_estrutural',
        label: 'Solução Estrutural Considerada',
        tipo: 'select',
        opcoes: [
          'Construção maciça andar a andar',
          'Pilotis / Estrutura de pilares',
          'Misto',
          'Ainda não definido',
        ],
      },
    ],
    temFerramenta: false,
  },

  {
    topicoId: 'terreno-16',
    resumo: [
      'A estratégia do rebaixo ignora a linha zero: a casa é posicionada abaixo do nível da rua para eliminar um pavimento',
      'Rebaixar a casa transforma um projeto de 3 andares em 2 · eliminar 1 andar pode economizar R$300–500k',
      'O acesso ocorre por rampa que desce da rua; o fundo do terreno recebe aterro leve ou espaço vazio',
      'Ponto de atenção 1: a rampa que desce chama água da chuva para dentro · exige canaleta de drenagem no pé da rampa',
      'Ponto de atenção 2: vizinhos que seguiram a linha zero ficam mais altos · risco de perda de privacidade pelas janelas deles',
      'Mitigação: pé-direito mais alto no pavimento rebaixado compensa a aparência "enterrada" em relação à rua',
    ],
    dicasDeOuro: [
      {
        icone: '⬇️',
        texto:
          'Antes de aceitar 3 pavimentos, simule o rebaixo: descer 1m abaixo da linha zero pode eliminar um andar inteiro e economizar centenas de milhares',
      },
      {
        icone: '🌧️',
        texto:
          'Projete a canaleta de drenagem no pé da rampa como item obrigatório · sem ela, a garagem inunda a cada chuva forte',
      },
      {
        icone: '🏠',
        texto:
          'Compense a altura rebaixada com pé-direito de 3,0–3,5m no pavimento principal · a casa fica visualmente equilibrada com os vizinhos',
      },
      {
        icone: '🔭',
        texto:
          'Verifique a cota das janelas dos vizinhos antes de definir o rebaixo · às vezes um ajuste de 30–50cm resolve o problema de privacidade',
      },
    ],
    atencao: [
      {
        icone: '🌊',
        texto:
          'Rampa que desce concentra toda a água da chuva na garagem: canaleta de drenagem é item obrigatório de projeto, não opcional',
      },
      {
        icone: '👁️',
        texto:
          'Casa rebaixada pode perder privacidade para vizinhos com janelas ao nível da rua · avalie o contexto da rua antes de decidir',
      },
      {
        icone: '📐',
        texto:
          'O rebaixo exige corte de terra na frente do lote · verifique se o volume de escavação não ultrapassa o custo do pavimento eliminado',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'terreno-16-cl1',
        texto: 'Simulei o projeto com rebaixo e comparei o número de pavimentos resultantes',
      },
      {
        id: 'terreno-16-cl2',
        texto:
          'Calculei o volume de corte necessário para posicionar a casa abaixo do nível da rua',
      },
      {
        id: 'terreno-16-cl3',
        texto: 'Verifiquei a cota das janelas dos vizinhos em relação ao pavimento rebaixado',
      },
      {
        id: 'terreno-16-cl4',
        texto: 'Incluí canaleta de drenagem no pé da rampa de acesso no projeto hidráulico',
      },
      {
        id: 'terreno-16-cl5',
        texto: 'Defini o pé-direito do pavimento rebaixado para compensar a aparência enterrada',
      },
      {
        id: 'terreno-16-cl6',
        texto:
          'Comparei o custo do rebaixo com o custo do pavimento eliminado e confirmei a viabilidade',
      },
    ],
    metadados: [
      {
        campo: 'rebaixo_nivel_m',
        label: 'Profundidade do Rebaixo em Relação à Rua (m)',
        tipo: 'number',
        placeholder: 'Ex: 1.5',
      },
      {
        campo: 'pavimentos_antes',
        label: 'Pavimentos Antes do Rebaixo',
        tipo: 'number',
        placeholder: 'Ex: 3',
      },
      {
        campo: 'pavimentos_depois',
        label: 'Pavimentos Após o Rebaixo',
        tipo: 'number',
        placeholder: 'Ex: 2',
      },
      {
        campo: 'pe_direito_rebaixado',
        label: 'Pé-Direito do Pav. Rebaixado (m)',
        tipo: 'number',
        placeholder: 'Ex: 3.2',
      },
    ],
    temFerramenta: false,
  },

  {
    topicoId: 'terreno-17',
    resumo: [
      'Deck de madeira substitui a laje descoberta no fundo do declive com custo ~23% menor e prazo 4× mais curto',
      'Laje convencional exige 10–12 fornecedores e 2–3 meses; deck exige 1 carpinteiro e 2–3 semanas',
      'Deck é estrutura drenante: a água escoa pelo terreno natural, eliminando ralos, grelhas e canalização',
      'Piscina se encaixa naturalmente no declive · o vão do terreno substitui a escavação, economizando R$15.000–40.000',
      'Em 70m² de deck, a redução de peso chega a ~60 toneladas: alívio direto em fundação, estrutura e escavação',
      'Manutenção do deck: lixamento e verniz a cada 2–5 anos dependendo da madeira escolhida',
    ],
    dicasDeOuro: [
      {
        icone: '🪵',
        texto:
          'Escolha madeiras que envelhecem com tonalidade bonita (cumaru, ipê) · eliminam a necessidade de verniz frequente e ficam melhores com o tempo',
      },
      {
        icone: '🏊',
        texto:
          'Encaixe a piscina no vão natural do declive antes de pensar em escavar: cada 1m de profundidade que o terreno já entrega economiza R$3.000–8.000 em escavação',
      },
      {
        icone: '📋',
        texto:
          'Centralize o contrato de deck em um único carpinteiro especializado · você ganha poder de gestão e elimina a cadeia de dependências entre empreiteiros',
      },
      {
        icone: '💡',
        texto:
          'Para obras de venda ou orçamento apertado, deck é a estratégia certa: custo menor agora, manutenção futura é responsabilidade do comprador',
      },
    ],
    atencao: [
      {
        icone: '🔧',
        texto:
          'Deck requer manutenção periódica de 2–5 anos: inclua esse custo no planejamento antes de optar por ele como solução definitiva',
      },
      {
        icone: '🌿',
        texto:
          'Deck sobre terreno natural exige controle de plantas daninhas · instale manta geotêxtil sob a estrutura para evitar mato crescendo pelas frestas',
      },
      {
        icone: '⚖️',
        texto:
          'Deck não é universalmente adequado: laje convencional pode ser necessária em áreas de alto tráfego ou com restrições de condomínio',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'terreno-17-cl1',
        texto: 'Identifiquei a área no fundo do declive que pode receber deck em vez de laje',
      },
      {
        id: 'terreno-17-cl2',
        texto:
          'Calculei o custo comparativo: laje convencional (materiais + mão de obra) vs. deck (madeira + carpinteiro)',
      },
      {
        id: 'terreno-17-cl3',
        texto:
          'Verifiquei se o uso da área admite deck (área de lazer, transição, borda de piscina)',
      },
      {
        id: 'terreno-17-cl4',
        texto: 'Escolhi o tipo de madeira e incluí manta geotêxtil sob a estrutura do deck',
      },
      {
        id: 'terreno-17-cl5',
        texto: 'Avaliei o encaixe da piscina no vão natural do declive para evitar escavação extra',
      },
      {
        id: 'terreno-17-cl6',
        texto: 'Incluí custo de manutenção do deck no planejamento financeiro de longo prazo',
      },
    ],
    metadados: [
      {
        campo: 'area_deck_m2',
        label: 'Área de Deck Prevista (m²)',
        tipo: 'number',
        placeholder: 'Ex: 40',
      },
      {
        campo: 'economia_deck_est',
        label: 'Economia Est. vs Laje (R$)',
        tipo: 'number',
        placeholder: 'Ex: 6000',
      },
      {
        campo: 'tipo_madeira_deck',
        label: 'Tipo de Madeira do Deck',
        tipo: 'select',
        opcoes: [
          'Cumaru',
          'Ipê',
          'Eucalipto tratado',
          'Plástico reciclado (deck sintético)',
          'Outro',
          'Ainda não definido',
        ],
      },
      {
        campo: 'piscina_no_declive',
        label: 'Piscina Aproveitando o Vão do Declive',
        tipo: 'select',
        opcoes: ['Sim', 'Não', 'Em estudo'],
      },
    ],
    temFerramenta: true,
  },

  {
    topicoId: 'terreno-18',
    resumo: [
      'Estratégia dos pavilhões: dividir a casa em dois blocos separados para construir a menor metragem possível',
      'Bloco único em terreno desnivelado causa explosão de metragem; pavilhões cortam o volume construído ao mínimo necessário',
      'Os blocos são conectados por circulação mínima (escada, passarela), deixando a área entre eles como vazio ou lazer',
      'A área livre entre pavilhões pode receber deck, piscina ou cobertura leve · sem escavação nem fundação extra',
      'Funciona tanto para declive quanto para aclive: o princípio é construir menos, mexer menos no terreno',
      'Três princípios de terreno desnivelado: construir mínimo, retirar mínima terra, remodelar mínima superfície',
    ],
    dicasDeOuro: [
      {
        icone: '🏛️',
        texto:
          'Pense em cada bloco como um volume com função clara (social / íntimo / serviço) · a separação física reforça a zoneamento e reduz circulação interna inútil',
      },
      {
        icone: '🔗',
        texto:
          'Projete a conexão entre pavilhões como escada ou passarela descoberta · cobrir essa passagem transforma o ganho em metragem perdida',
      },
      {
        icone: '🏊',
        texto:
          'Use o vazio entre pavilhões para piscina ou deck: o terreno já entrega o rebaixo natural, evitando R$15.000–40.000 de escavação',
      },
      {
        icone: '📐',
        texto:
          'Aplique a estratégia em aclive ou declive: separe os blocos no eixo da inclinação e conecte-os no ponto mais econômico',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Passarela descoberta entre pavilhões é desconfortável em dias de chuva · projete cobertura mínima sem fechar o espaço para não gerar metragem',
      },
      {
        icone: '🏗️',
        texto:
          'Cada bloco independente tem fundação própria: verifique se o solo permite posicionar os dois blocos sem interferência entre as fundações',
      },
      {
        icone: '📋',
        texto:
          'Zoneamento municipal pode exigir que os pavilhões sejam registrados como uma única edificação · consulte o arquiteto antes de aprovar o partido',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'terreno-18-cl1',
        texto:
          'Identifiquei quais partes do programa de necessidades podem ser separadas em blocos distintos',
      },
      {
        id: 'terreno-18-cl2',
        texto: 'Calculei a metragem total em bloco único vs. dois pavilhões e confirmei a redução',
      },
      {
        id: 'terreno-18-cl3',
        texto:
          'Defini o uso da área entre os pavilhões (deck, piscina, jardim ou passarela coberta)',
      },
      {
        id: 'terreno-18-cl4',
        texto:
          'Confirmei com o arquiteto o tipo de conexão entre os blocos (escada, passarela, ponte)',
      },
      {
        id: 'terreno-18-cl5',
        texto:
          'Verifiquei com o engenheiro a viabilidade de fundações independentes para cada bloco',
      },
      {
        id: 'terreno-18-cl6',
        texto:
          'Consultei a legislação municipal sobre registro de pavilhões separados como uma edificação',
      },
    ],
    metadados: [
      {
        campo: 'metragem_bloco_unico',
        label: 'Metragem em Bloco Único (m²)',
        tipo: 'number',
        placeholder: 'Ex: 280',
      },
      {
        campo: 'metragem_pavilhoes',
        label: 'Metragem com Pavilhões (m²)',
        tipo: 'number',
        placeholder: 'Ex: 210',
      },
      {
        campo: 'uso_area_entre_blocos',
        label: 'Uso da Área Entre os Pavilhões',
        tipo: 'select',
        opcoes: [
          'Piscina',
          'Deck',
          'Jardim / Área verde',
          'Passarela coberta',
          'Laje de lazer',
          'Outro',
        ],
      },
    ],
    temFerramenta: false,
  },

  {
    topicoId: 'terreno-19',
    resumo: [
      'O encaixe da casa no terreno é a alavanca de custo mais poderosa da obra · diferenças de R$100k–R$300k entre soluções boas e ruins',
      'Caso real: garagem enterrada em declive que já tem espaço natural + vazio estruturado no fundo = custo duplo sem metragem útil',
      'Caso real: terreno com 10m de queda não identificado → guarda-corpo de vidro inesperado de R$45.000 para cobrir área 4m acima do solo',
      'Espaço vazio no projeto quase sempre vira expansão: o cliente vê estrutura pronta e completa · é o maior gatilho de obra crescente',
      'Declive lateral segue exatamente o mesmo raciocínio da linha zero · ajuste de cota no eixo lateral elimina arrimos desnecessários',
      'Levantamento topográfico com curvas de nível é pré-requisito de projeto · sem ele, quedas de 10m passam despercebidas',
    ],
    dicasDeOuro: [
      {
        icone: '🗺️',
        texto:
          'Exija o levantamento topográfico com curvas de nível antes de qualquer projeto · cada linha de cota representa 50cm de queda que o arquiteto precisa saber',
      },
      {
        icone: '🔄',
        texto:
          'Se o projeto tem espaço vazio com estrutura, mova ambientes de cima para baixo antes de aceitar: você libera metragem nobre e evita que o vazio vire expansão não planejada',
      },
      {
        icone: '↔️',
        texto:
          'Em declive lateral, experimente rampa comprida na lateral do lote · suaviza a inclinação sem rebaixar a cota, eliminando arrimos e escavação',
      },
      {
        icone: '💰',
        texto:
          'Antes de fechar projeto, pergunte: existe uma forma de posicionar a casa que reduza 80–200k? Quase sempre existe · e o arquiteto só vai olhar se você pedir',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Sem levantamento topográfico, surpresas de R$45k (guarda-corpo) ou R$80k (arrimos) aparecem no meio da obra, quando não há como voltar atrás',
      },
      {
        icone: '🚨',
        texto:
          'Espaço vazio estruturado é o principal gatilho de expansão de obra: cliente vê laje + pilar e inevitavelmente completa · planeje ou elimine, nunca ignore',
      },
      {
        icone: '📐',
        texto:
          'Garagem enterrada em terreno que já tem vão natural é o erro mais caro do declive: você cria custo onde o terreno já entregava o espaço de graça',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'terreno-19-cl1',
        texto: 'Obtive levantamento topográfico com curvas de nível antes de iniciar o projeto',
      },
      {
        id: 'terreno-19-cl2',
        texto: 'Analisei o projeto identificando todos os espaços vazios estruturados',
      },
      {
        id: 'terreno-19-cl3',
        texto: 'Verifiquei se a garagem foi enterrada onde o terreno já oferecia vão natural',
      },
      {
        id: 'terreno-19-cl4',
        texto:
          'Simulei realocação de ambientes de cima para baixo para eliminar vazios e reduzir metragem no nível superior',
      },
      {
        id: 'terreno-19-cl5',
        texto: 'Verifiquei se há declive lateral e apliquei o raciocínio da linha zero nesse eixo',
      },
      {
        id: 'terreno-19-cl6',
        texto:
          'Consultei o arquiteto sobre ao menos uma alternativa de posicionamento mais econômica da casa',
      },
    ],
    metadados: [
      {
        campo: 'levantamento_topografico',
        label: 'Levantamento Topográfico Realizado',
        tipo: 'select',
        opcoes: ['Sim', 'Não', 'Em andamento'],
      },
      {
        campo: 'queda_total_lote_m',
        label: 'Queda Total do Lote (m)',
        tipo: 'number',
        placeholder: 'Ex: 10',
      },
      {
        campo: 'espacos_vazios_m2',
        label: 'Área de Vazios Estruturados (m²)',
        tipo: 'number',
        placeholder: 'Ex: 60',
      },
      {
        campo: 'economia_reposicionamento',
        label: 'Economia Est. com Reposicionamento (R$)',
        tipo: 'number',
        placeholder: 'Ex: 120000',
      },
    ],
    temFerramenta: false,
  },

  {
    topicoId: 'terreno-20',
    resumo: [
      'Dois diagnósticos obrigatórios antes de construir: topografia (superfície, base do arquitetônico) e sondagem SPT (subsolo, base do estrutural)',
      'SPT mede golpes de martelo de 65kg para avançar 1m: SPT 5 = mole; SPT 20 = bom para casas; SPT 25 = limite da perfuratriz; SPT 40+ = impenetrável',
      'Quatro alertas de sondagem: aterro, solo muito mole, solo muito duro e presença de lençol freático',
      'Solo mole até 12m + lençol freático a 18m: fundação que custaria R$60–70k chegou a R$285k em caso real',
      'Loteamentos e condomínios frequentemente têm aterro profundo · lotes adjacentes podem ter fundações completamente diferentes',
      'Sondagem pode ser feita antes de comprar o lote · é um investimento que pode evitar uma compra de terreno inviável',
    ],
    dicasDeOuro: [
      {
        icone: '🔍',
        texto:
          'Faça a sondagem SPT antes de aprovar o projeto estrutural · o tipo de solo define qual fundação é viável e o custo pode variar 4× entre solos bons e ruins',
      },
      {
        icone: '🏘️',
        texto:
          'Em condomínios, nunca use a sondagem do vizinho: loteadoras movem terra entre lotes (corte e aterro) · seus solos podem ser radicalmente diferentes',
      },
      {
        icone: '💡',
        texto:
          'SPT 20–25 na profundidade certa é o cenário ideal: permite usar perfuratriz mecânica, que é a fundação mais econômica para casas residenciais',
      },
      {
        icone: '🛒',
        texto:
          'Avalie contratar sondagem antes de comprar o lote · R$1.500–4.000 de sondagem pode evitar a compra de um terreno com fundação de R$200.000+',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Solo muito mole (SPT 5 até 12m) pode multiplicar o custo de fundação por 4–5× em relação à média · inclua margem no orçamento se a sondagem revelar isso',
      },
      {
        icone: '🪨',
        texto:
          'Solo muito duro impede mecanização: trabalhador com martelete dentro da escavação, diâmetro maior que o necessário, prazo e custo explodem',
      },
      {
        icone: '💧',
        texto:
          'Lençol freático na profundidade de fundação impede estaca convencional · exige sapata acima do nível da água ou sistema LSE Contínua, bem mais caro',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'terreno-20-cl1',
        texto: 'Contratei levantamento topográfico com curvas de nível do lote',
      },
      {
        id: 'terreno-20-cl2',
        texto: 'Contratei sondagem SPT com pelo menos 2 furos no lote (frente e fundo)',
      },
      { id: 'terreno-20-cl3', texto: 'Identifiquei presença de aterro no relatório de sondagem' },
      {
        id: 'terreno-20-cl4',
        texto: 'Verifiquei o SPT médio nas profundidades prováveis de fundação',
      },
      {
        id: 'terreno-20-cl5',
        texto: 'Identifiquei o nível do lençol freático no relatório de sondagem',
      },
      {
        id: 'terreno-20-cl6',
        texto:
          'Entreguei o relatório de sondagem ao engenheiro estrutural antes de iniciar o projeto',
      },
    ],
    metadados: [
      {
        campo: 'sondagem_realizada',
        label: 'Sondagem SPT Realizada',
        tipo: 'select',
        opcoes: ['Sim', 'Não', 'Agendada'],
      },
      {
        campo: 'spt_profundidade_boa',
        label: 'Profundidade do SPT 20 (m)',
        tipo: 'number',
        placeholder: 'Ex: 5 (quanto menor, melhor)',
      },
      {
        campo: 'tem_aterro',
        label: 'Aterro Identificado na Sondagem',
        tipo: 'select',
        opcoes: ['Sim', 'Não', 'Não realizada'],
      },
      {
        campo: 'nivel_lenco_m',
        label: 'Nível do Lençol Freático (m)',
        tipo: 'number',
        placeholder: 'Ex: 8 (se indicado no relatório)',
      },
    ],
    temFerramenta: true,
  },

  {
    topicoId: 'terreno-21',
    resumo: [
      'A escolha da fundação correta pode representar economia de 15–40% nessa etapa',
      'Fundação em radier é adequada para solos com boa resistência e cargas distribuídas',
      'Estacas são necessárias quando o solo superficial não suporta a carga da estrutura',
      'A sondagem SPT é o investimento com melhor custo-benefício de toda a obra',
      'Solos argilosos expansivos exigem fundações especiais independentemente do porte da obra',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto: 'A sondagem SPT custa de R$1.500 a R$4.000 e evita surpresas de R$30.000+',
      },
      {
        icone: '💡',
        texto:
          'Fundação em sapata corrida pode ser mais econômica que radier em terrenos muito inclinados',
      },
      {
        icone: '💡',
        texto:
          'Consulte o vizinho sobre o tipo de fundação que usou · solo local similar é um dado valioso',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Nunca execute fundação sem laudo geotécnico · é responsabilidade civil do construtor',
      },
      {
        icone: '⚠️',
        texto:
          'Fundação subdimensionada causa recalque diferencial · trincas que custam dezenas de milhares para corrigir',
      },
    ],
    checklistAplicabilidade: [
      { id: 't21-cl1', texto: 'Realizei sondagem SPT no lote' },
      { id: 't21-cl2', texto: 'Obtive laudo geotécnico assinado por responsável' },
      { id: 't21-cl3', texto: 'Comparei ao menos 2 tipos de fundação com orçamento' },
      { id: 't21-cl4', texto: 'Defini o tipo de fundação com o engenheiro estrutural' },
    ],
    metadados: [
      {
        campo: 'tipo_fundacao',
        label: 'Tipo de Fundação Escolhida',
        tipo: 'select',
        opcoes: [
          'Sapata isolada',
          'Sapata corrida',
          'Radier',
          'Estaca',
          'Tubulão',
          'Bloco sobre estaca',
          'Outro',
        ],
      },
      {
        campo: 'resistencia_solo',
        label: 'Resistência do Solo (kPa)',
        tipo: 'number',
        placeholder: 'Dado do laudo SPT',
      },
      {
        campo: 'custo_fundacao',
        label: 'Orçamento Fundação (R$)',
        tipo: 'number',
        placeholder: 'Ex: 25000',
      },
    ],
    temFerramenta: true,
  },
]

// ── Planejamento Financeiro ───────────────────────────────────

const FIN_CONTENT: TopicoContent[] = [
  {
    topicoId: 'fin-01',
    resumo: [
      'O planejamento financeiro é a diferença entre concluir a obra e abandoná-la no meio',
      'Obras sem orçamento detalhado estouram 40–80% acima do previsto em média',
      'Divida o orçamento em dois eixos: por fases construtivas e por tipo de insumo',
      'Reserve mínimo 15% do orçamento total como reserva de contingência',
      'Documente cada gasto desde o início · é seu principal instrumento de controle',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto: 'Antes de qualquer gasto, abra três orçamentos de fornecedores diferentes',
      },
      {
        icone: '💡',
        texto: 'Controle semanal de gastos evita surpresas no fechamento de cada etapa',
      },
      {
        icone: '💡',
        texto: 'Use a área Financeiro do app para registrar cada lançamento na hora em que ocorre',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Não comece a obra sem pelo menos 60% do orçamento em caixa ou financiamento aprovado',
      },
      {
        icone: '⚠️',
        texto:
          'Orçamentos de obra têm prazo de validade · cotações de material caducam em 30–60 dias',
      },
    ],
    checklistAplicabilidade: [
      { id: 'fin01-cl1', texto: 'Defini o orçamento total disponível para a obra' },
      { id: 'fin01-cl2', texto: 'Separei a reserva de contingência (mínimo 15%)' },
      {
        id: 'fin01-cl3',
        texto: 'Tenho ao menos 60% do orçamento disponível ou financiamento aprovado',
      },
    ],
    metadados: [],
    temFerramenta: false,
  },
  {
    topicoId: 'fin-02',
    resumo: [
      'O orçamento pode ser dividido em duas dimensões: fases e insumos',
      'Por fases: aloca % do orçamento para cada etapa construtiva (terreno, fundação, estrutura…)',
      'Por insumos: divide entre mão de obra (~40%), materiais (~45%), projetos (~8%), taxas (~7%)',
      'A combinação dos dois eixos dá visibilidade completa sobre onde o dinheiro vai',
      'Benchmark nacional: mão de obra + materiais = 85% do custo total da obra',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto:
          'Mão de obra e materiais representam 85% do custo · dominar esses dois itens é essencial',
      },
      { icone: '💡', texto: 'Projetos bem feitos economizam na execução · não economize aqui' },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto: 'Mão de obra acima de 50% indica informalidade ou retrabalho · investigue',
      },
      {
        icone: '⚠️',
        texto: 'Materiais acima de 55% pode indicar desperdício ou compra sem planejamento',
      },
    ],
    checklistAplicabilidade: [
      { id: 'fin02-cl1', texto: 'Entendi a diferença entre divisão por fases e por insumos' },
      { id: 'fin02-cl2', texto: 'Tenho uma estimativa dos principais insumos da minha obra' },
    ],
    metadados: [],
    temFerramenta: false,
  },
  {
    topicoId: 'fin-03',
    resumo: [
      'Dividir o orçamento por fases antecipa o fluxo de caixa de cada etapa construtiva',
      'Cada fase da obra consome uma fatia previsível do orçamento total',
      'Mão de Obra e Execução juntos representam 60–65% do orçamento típico',
      'O recurso abaixo distribui seu orçamento com base em benchmarks do setor',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto: 'Ajuste os percentuais conforme a realidade da sua região e tipo de obra',
      },
      {
        icone: '💡',
        texto:
          'Use a distribuição por fases para liberar o dinheiro gradualmente · não coloque tudo em caixa de uma vez',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Se uma fase ultrapassar mais de 20% o previsto, revisite o planejamento antes de avançar',
      },
    ],
    checklistAplicabilidade: [
      { id: 'fin03-cl1', texto: 'Usei o recurso para distribuir meu orçamento pelas 7 fases' },
      { id: 'fin03-cl2', texto: 'Validei os percentuais com base na realidade da minha obra' },
    ],
    metadados: [],
    temFerramenta: true,
  },
  {
    topicoId: 'fin-04',
    resumo: [
      'Insumos são as categorias de gasto: materiais, mão de obra, projetos e taxas',
      'Cada insumo tem um intervalo saudável · desvios indicam risco de desequilíbrio',
      'Materiais: 40–50% | Mão de Obra: 35–45% | Projetos: 5–8% | Taxas: 3–5% | Reserva: 10–15%',
      'O recurso abaixo valida se a sua divisão está dentro dos benchmarks',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto:
          'Mantenha a reserva de contingência separada · não misture com o orçamento de execução',
      },
      {
        icone: '💡',
        texto:
          'Se reduzir projetos para economizar, o risco de retrabalho aumenta proporcionalmente',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto: 'Reserva abaixo de 10% é perigoso · qualquer imprevisto compromete a conclusão',
      },
      {
        icone: '⚠️',
        texto: 'Mão de obra acima de 50% pode indicar empreitada superintensiva ou retrabalho',
      },
    ],
    checklistAplicabilidade: [
      { id: 'fin04-cl1', texto: 'Dividi meu orçamento pelos tipos de insumo' },
      { id: 'fin04-cl2', texto: 'Minha divisão está dentro dos intervalos saudáveis' },
      { id: 'fin04-cl3', texto: 'Tenho reserva de contingência de pelo menos 10%' },
    ],
    metadados: [],
    temFerramenta: true,
  },
  {
    topicoId: 'fin-05',
    resumo: [
      'A tabela de insumos detalha quantidade e preço de cada item por m² construído',
      'Permite montar o orçamento de baixo para cima (bottom-up) com precisão',
      'Principais insumos: concreto, aço, tijolos, areia, brita, cimento, telhas, esquadrias',
      'Cotações devem ser atualizadas a cada 30–60 dias · preços variam com inflação e safra',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto: 'Peça o preço por unidade E por m² · facilita a comparação entre fornecedores',
      },
      { icone: '💡', texto: 'Adicione 10–15% de perda/quebra ao calcular quantidades de material' },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Nunca use apenas um fornecedor para itens de alto custo · sempre compare 3 orçamentos',
      },
    ],
    checklistAplicabilidade: [
      { id: 'fin05-cl1', texto: 'Montei a tabela de insumos com os principais materiais' },
      { id: 'fin05-cl2', texto: 'Cotei preços com pelo menos 2 fornecedores por insumo' },
    ],
    metadados: [],
    temFerramenta: true,
  },
  {
    topicoId: 'fin-11',
    resumo: [
      'A análise de viabilidade compara o orçamento necessário com o disponível',
      'O custo por m² varia com padrão e região · use benchmarks atualizados',
      'Score de viabilidade: Viável (orçamento >= estimativa), Atenção (10–20% abaixo), Inviável (>20% abaixo)',
      'O recurso abaixo estima o custo total e compara com seu orçamento cadastrado',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto:
          'Se o score der "Atenção", reduza a área ou rebaixe o padrão antes de comprometer o projeto',
      },
      {
        icone: '💡',
        texto: 'O custo por m² do CUB serve como base · acrescente 15–25% para obras individuais',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Custo estimado abaixo do real é a principal causa de obra parada · seja conservador',
      },
      {
        icone: '⚠️',
        texto: 'Não inicie a obra se o score for "Inviável" · renegocie área, padrão ou prazo',
      },
    ],
    checklistAplicabilidade: [
      { id: 'fin11-cl1', texto: 'Rodei o simulador de viabilidade com minha área e padrão' },
      {
        id: 'fin11-cl2',
        texto: 'Meu orçamento é compatível com a estimativa (score Viável ou Atenção)',
      },
      { id: 'fin11-cl3', texto: 'Tenho plano de ajuste caso o orçamento seja insuficiente' },
    ],
    metadados: [],
    temFerramenta: true,
  },
  {
    topicoId: 'fin-12',
    resumo: [
      'Estratégias de movimentação financeira impactam diretamente o custo da obra',
      'Pagamento à vista tem desconto médio de 5–10% sobre parcelado',
      'Compras antecipadas de material protegem da inflação mas exigem capital de giro',
      'Manter caixa mínimo de 3 meses de despesas previne interrupção por falta de recursos',
      'Negociar prazos de pagamento com fornecedores alonga o fluxo de caixa',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto:
          'Negocie desconto à vista em compras acima de R$5.000 · o fornecedor prefere receber logo',
      },
      {
        icone: '💡',
        texto: 'Compras em grande volume (ex: toda a estrutura) podem ter desconto de 8–15%',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Não antecipe compras de material para mais de 60 dias à frente · risco de furto e degradação',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'fin12-cl1',
        texto: 'Definí estratégia de pagamento (à vista x parcelado) por tipo de gasto',
      },
      { id: 'fin12-cl2', texto: 'Tenho caixa mínimo para 3 meses de obra' },
    ],
    metadados: [],
    temFerramenta: false,
  },
  {
    topicoId: 'fin-13',
    resumo: [
      'Financiamento imobiliário é a estratégia de alavancar capital para obras de maior porte',
      'Taxa de juros, prazo e valor financiado determinam o custo total do crédito',
      'Tabela Price: parcelas fixas (juros decrescentes e amortização crescente)',
      'SAC: amortização constante, parcelas decrescentes · paga menos juros no total',
      'A calculadora abaixo simula qualquer cenário de financiamento',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto: 'Compare SAC vs Price: SAC é melhor para quem pode pagar mais no início',
      },
      {
        icone: '💡',
        texto:
          'Antecipar parcelas reduz drasticamente os juros · simule o impacto na calculadora desta etapa',
      },
      {
        icone: '💡',
        texto: 'Taxa efetiva anual é diferente da nominal · sempre converta antes de comparar',
      },
    ],
    atencao: [
      { icone: '⚠️', texto: 'Comprometer mais de 30% da renda mensal com parcelas é arriscado' },
      {
        icone: '⚠️',
        texto: 'CET (Custo Efetivo Total) inclui seguros e taxas · use-o para comparar propostas',
      },
    ],
    checklistAplicabilidade: [
      { id: 'fin13-cl1', texto: 'Simulei o cenário de financiamento com a calculadora' },
      { id: 'fin13-cl2', texto: 'A parcela não compromete mais de 30% da minha renda' },
      { id: 'fin13-cl3', texto: 'Comparei pelo menos 2 instituições financeiras' },
    ],
    metadados: [],
    temFerramenta: true,
  },
]

TOPICOS_CONTENT.push(...FIN_CONTENT)

const FIN_CONTENT_2: TopicoContent[] = [
  {
    topicoId: 'fin-06',
    resumo: [
      'A verificação do terreno é o primeiro teste de viabilidade · parte do orçamento planejada para a obra pode já estar comprometida com o lote',
      'As 5 onerações do terreno (bota fora + arrimos + impermeabilização + drenagem + fator tempo) somam em média 2,5–3x o custo do bota fora de terra',
      'Regra do empolamento: acrescente 40% ao volume calculado de terra a remover · terra compactada expande ao ser escavada e contabilizada pelo caminhão',
      'Referência de viabilidade: 5% do orçamento já é número preocupante; 10% = grande intervenção; acima de 10% = impacto agressivo, acione alerta imediato',
      'Custos ocultos do terreno: instalações pelo vizinho (declive forçado), quebra de rocha, reforço de fundação vizinha e infraestrutura ausente',
      'Custo de terreno não é parametrizável por m² · é caso a caso e deve ser calculado antes de qualquer planejamento financeiro da edificação',
    ],
    dicasDeOuro: [
      {
        icone: '🧮',
        texto:
          'Orce o bota fora de terra com empresa especializada e multiplique por 2,5–3x para estimar o custo total das 5 onerações do lote',
      },
      {
        icone: '📐',
        texto:
          'Ao medir o volume de terra, adicione 40% de empolamento + folga lateral dos arrimos · a cubagem real supera sempre o calculado no papel',
      },
      {
        icone: '💡',
        texto:
          'Se o terreno consumir mais de 10% do orçamento disponível, recalcule a metragem da casa antes de seguir com o planejamento financeiro',
      },
      {
        icone: '🔍',
        texto:
          'Verifique a topografia para saber se esgoto e chuva chegam à rua da frente · se não chegarem, escoamento pelo vizinho é uma obra extra e cara',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Terrenos com quebra de rocha podem demandar 6+ meses só de fundação e consumir parcela expressiva do orçamento sem erguer uma parede sequer',
      },
      {
        icone: '🏗️',
        texto:
          'Escavar próximo à divisa sem verificar a fundação vizinha pode gerar obrigação de reforço estrutural do imóvel contíguo · custo imprevisto e inegociável',
      },
      {
        icone: '💸',
        texto:
          'Infraestrutura ausente (poço artesiano, postes de energia) pode custar R$ 30–80k antes de iniciar a edificação · verifique com prefeitura e concessionárias',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'fin06-cl1',
        texto: 'Orçamentei o custo do bota fora de terra com empresa especializada da região',
      },
      {
        id: 'fin06-cl2',
        texto:
          'Calculei o volume de terra com empolamento de 40% e folga lateral para trabalhar atrás dos arrimos',
      },
      {
        id: 'fin06-cl3',
        texto:
          'Estimei o custo total do terreno multiplicando o bota fora por 2,5–3x para incluir as 5 onerações',
      },
      {
        id: 'fin06-cl4',
        texto:
          'Calculei qual percentual do orçamento total o terreno está consumindo e avaliei se está dentro do limite aceitável',
      },
      {
        id: 'fin06-cl5',
        texto:
          'Verifiquei se as instalações de esgoto e chuva chegam à rua sem passar pela propriedade do vizinho',
      },
      {
        id: 'fin06-cl6',
        texto:
          'Confirmei disponibilidade de infraestrutura urbana (água, energia, asfalto) ou estimei custo de implementação',
      },
    ],
    metadados: [
      {
        campo: 'custo_bota_fora_rs',
        label: 'Custo do bota fora de terra (R$)',
        tipo: 'number',
        placeholder: 'Ex: 15000',
      },
      {
        campo: 'percentual_terreno_orcamento',
        label: 'Percentual do orçamento para o terreno (%)',
        tipo: 'number',
        placeholder: 'Ex: 8',
      },
      {
        campo: 'fundacao_especial_necessaria',
        label: 'Requer fundação ou intervenção especial',
        tipo: 'select',
        opcoes: ['Sim', 'Não', 'A verificar'],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...FIN_CONTENT_2)

const FIN_CONTENT_3: TopicoContent[] = [
  {
    topicoId: 'fin-07',
    resumo: [
      'Esquadrias de alumínio/vidro incluem janelas, portas externas, peles de vidro, brises, zenitais e portões · tudo alumínio com vidro',
      'Referência de mercado: R$ 1.200/m² de esquadria · multiplique pela área total levantada no quadro de esquadrias',
      'Para calcular a área, some base × altura de cada peça listada no projeto · em 5 minutos você varre uma das maiores parcelas do orçamento',
      'Teste de viabilidade: esquadrias bem dimensionadas ficam em ~10% do orçamento global da obra',
      'Projetos muito envidraçados podem superar 10% naturalmente · ajuste a análise ao estilo arquitetônico do projeto',
      'Exemplo concreto: 87 m² × R$ 1.200 = R$ 104.400 · descubrir isso antes do projeto executivo evita surpresas caras',
    ],
    dicasDeOuro: [
      {
        icone: '📐',
        texto:
          'Some base × altura de cada peça no quadro de esquadrias, multiplique pelo R$ 1.200/m² · é o custo estimado do contrato de alumínio e vidro',
      },
      {
        icone: '🔍',
        texto:
          'Inclua brises, claraboias, zenitais e portão de garagem na conta · são peças esquecidas que encarecem o contrato em 10–20%',
      },
      {
        icone: '📊',
        texto:
          'Divida o custo das esquadrias pelo orçamento global · resultado acima de 10% pede revisão da arquitetura antes do executivo',
      },
      {
        icone: '✏️',
        texto:
          'Se o projeto não tiver quadro de esquadrias, faça o levantamento manual folha por folha · não exige especialista e demora menos de uma hora',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Projetos com fachada envidraçada podem ter esquadrias consumindo 15–20% do orçamento · identifique isso antes de aprovar o anteprojeto',
      },
      {
        icone: '💸',
        texto:
          'Substituir alumínio por madeira para cortar custo pode sair mais caro a longo prazo em áreas úmidas ou expostas · manutenção e reposição anulam a economia inicial',
      },
      {
        icone: '🏗️',
        texto:
          'Portas internas de madeira geralmente ficam fora do contrato de esquadrias · não as some nessa conta para não distorcer o teste de viabilidade',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'fin07-cl1',
        texto:
          'Solicitei ao projetista o quadro de esquadrias completo com largura e altura de cada peça',
      },
      {
        id: 'fin07-cl2',
        texto: 'Levantei a área de cada esquadria (base × altura) e somei o total em m²',
      },
      {
        id: 'fin07-cl3',
        texto:
          'Incluí na conta janelas, portas externas, brises, zenitais, claraboias e portão de garagem',
      },
      {
        id: 'fin07-cl4',
        texto:
          'Calculei o custo estimado multiplicando a área total por R$ 1.200 (ou valor atualizado)',
      },
      {
        id: 'fin07-cl5',
        texto: 'Calculei o percentual que as esquadrias representam no orçamento global da obra',
      },
      {
        id: 'fin07-cl6',
        texto:
          'Avaliei se o percentual está dentro de ~10% ou se o projeto é altamente envidraçado e justifica ultrapassar esse limite',
      },
    ],
    metadados: [
      {
        campo: 'area_total_esquadrias_m2',
        label: 'Área total de esquadrias (m²)',
        tipo: 'number',
        placeholder: 'Ex: 87',
      },
      {
        campo: 'custo_estimado_esquadrias_rs',
        label: 'Custo estimado do contrato (R$)',
        tipo: 'number',
        placeholder: 'Ex: 104400',
      },
      {
        campo: 'percentual_esquadrias_orcamento',
        label: 'Percentual das esquadrias no orçamento (%)',
        tipo: 'number',
        placeholder: 'Ex: 10',
      },
    ],
    temFerramenta: false,
  },
  {
    topicoId: 'fin-08',
    resumo: [
      'O "combo estrutural" reúne aço + concreto + lajes · os 3 calculados juntos dão o custo realista da estrutura da sua obra',
      'Fórmula: m² × índice de aço × R$/kg + m² × índice de concreto × R$/m³ + m² × R$130 (laje) · três multiplicações e o número está na mesa',
      'Os perfis de consumo de aço orientam o cálculo: ~13 kg/m² (simples), ~23 kg/m² (médio-alto), ~30 kg/m² (ousado/especial)',
      'Exemplo perfil 2, 380 m²: aço R$ 87k + concreto R$ 103k + laje R$ 49k = R$ 239k · número pé no chão antes de qualquer obra',
      'Teste de viabilidade: combo ≤ 20% do orçamento = viável; ≤ 15% = viável e confortável; acima de 25% = inviável, exige redesenho',
      'Preços de aço e concreto são de mercado e variam por região · use sempre cotações locais atuais para não distorcer a análise',
    ],
    dicasDeOuro: [
      {
        icone: '🧮',
        texto:
          'Use a fórmula completa: (m² × kg/m² × R$/kg) + (m² × m³/m² × R$/m³) + (m² × R$130) · três multiplicações e você tem o combo estrutural',
      },
      {
        icone: '📊',
        texto:
          'Perfil 2 (23 kg/m² de aço, 0,45 m³/m² de concreto) é a referência para casas de médio-alto padrão em condomínio fechado',
      },
      {
        icone: '✏️',
        texto:
          'Calcule o combo antes de fechar o projeto arquitetônico · ajustar a geometria antes do executivo custa zero; depois custa muito',
      },
      {
        icone: '💡',
        texto:
          'Se o combo passar de 20%, a solução é simplificar a geometria do projeto · não adianta negociar preço de aço ou concreto no mercado',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Combo estrutural acima de 25% do orçamento torna a obra inviável · apenas redução de metragem ou simplificação significativa do projeto resolve',
      },
      {
        icone: '🏗️',
        texto:
          'Perfil alto de aço (>30 kg/m²) indica balanços, lajes especiais ou geometria irregular · revise o projeto estrutural antes de contratar o calculista',
      },
      {
        icone: '💸',
        texto:
          'Uma diferença de R$ 2/kg no aço impacta ~R$15–20k no exemplo de 380 m² · cote sempre com fornecedores da sua região antes de fechar o cálculo',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'fin08-cl1',
        texto:
          'Identifiquei o perfil de consumo de aço do projeto com base na complexidade arquitetônica (simples, médio ou ousado)',
      },
      {
        id: 'fin08-cl2',
        texto: 'Coletei o preço atual do aço (R$/kg) com fornecedores da minha região',
      },
      {
        id: 'fin08-cl3',
        texto: 'Coletei o preço atual do concreto usinado (R$/m³) com fornecedores da minha região',
      },
      {
        id: 'fin08-cl4',
        texto: 'Calculei o custo do aço: metragem × índice de consumo × preço por kg',
      },
      {
        id: 'fin08-cl5',
        texto: 'Calculei o custo do concreto: metragem × índice de consumo × preço por m³',
      },
      {
        id: 'fin08-cl6',
        texto:
          'Calculei o custo das lajes: metragem × R$ 130 (ou valor atualizado da tabela de viabilidade)',
      },
      {
        id: 'fin08-cl7',
        texto:
          'Somei os 3 valores e calculei o percentual do combo no orçamento total · avaliei se está dentro da faixa de viabilidade (≤ 20%)',
      },
    ],
    metadados: [
      {
        campo: 'perfil_consumo_aco',
        label: 'Perfil de consumo de aço adotado',
        tipo: 'select',
        opcoes: [
          'Perfil 1 · Simples (~13 kg/m²)',
          'Perfil 2 · Médio (~23 kg/m²)',
          'Perfil 3 · Ousado (~30 kg/m²)',
        ],
      },
      {
        campo: 'custo_combo_estrutural_rs',
        label: 'Custo total do combo estrutural (R$)',
        tipo: 'number',
        placeholder: 'Ex: 239000',
      },
      {
        campo: 'percentual_estrutura_orcamento',
        label: 'Percentual da estrutura no orçamento (%)',
        tipo: 'number',
        placeholder: 'Ex: 18',
      },
    ],
    temFerramenta: false,
  },
]
TOPICOS_CONTENT.push(...FIN_CONTENT_3)

const FIN_CONTENT_4: TopicoContent[] = [
  {
    topicoId: 'fin-09',
    resumo: [
      'Levante todos os revestimentos por ambiente: piso + paredes de cada cômodo, fachada, piscina, deck, pastilha · tudo entra na conta',
      'Sem projeto finalizado, estime a área de paredes como 60–70% da metragem de piso · referência validada em obra real (67% observado)',
      'Defina uma meta de custo por m²: R$150/m² como exemplo para alto padrão · toda compra acima dessa meta corrói a viabilidade da obra',
      'Método de controle ativo: produto acima da meta consome folga; produto abaixo gera folga · você mantém o orçamento sob controle a cada compra',
      'Teste de viabilidade: custo total dos revestimentos deve ficar em ~10% do orçamento global da obra',
      'Antes de comprar, simule trocas de materiais na tabela · trocar o revestimento de um único ambiente pode economizar R$10–30k na obra',
    ],
    dicasDeOuro: [
      {
        icone: '📋',
        texto:
          'Monte a lista de ambientes com as áreas de piso e adicione 65% para estimar paredes · você tem a área total de revestimento sem projeto finalizado',
      },
      {
        icone: '🎯',
        texto:
          'Fixe uma meta de R$/m² coerente com o padrão da casa · use ela como régua em toda visita à loja de revestimentos',
      },
      {
        icone: '🔄',
        texto:
          'Simule trocas de materiais antes de comprar: alterar o porcelanato de um cômodo de R$200 para R$120/m² pode gerar folga de R$10–20k',
      },
      {
        icone: '🏊',
        texto:
          'Deck, pastilha de piscina, pedra de fachada e piso elevado são revestimentos · inclua-os na conta ou o total vai surpreender no meio da obra',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Revestimentos acima de 10% do orçamento global indicam materiais premium ou projeto fora de escala · revise a lista antes de contratar qualquer coisa',
      },
      {
        icone: '💸',
        texto:
          'Comprar sem meta de preço por m² é a armadilha mais comum: cada "só um pouco mais caro" multiplicado por centenas de m² leva ao estouro de orçamento',
      },
      {
        icone: '🏗️',
        texto:
          'Áreas molhadas (banheiros, área de serviço) exigem rejunte especial e impermeabilização · orce com as especificações corretas para não subestimar o custo',
      },
    ],
    checklistAplicabilidade: [
      { id: 'fin09-cl1', texto: 'Listei todos os ambientes da casa com a área de piso de cada um' },
      {
        id: 'fin09-cl2',
        texto:
          'Estimei a área de paredes como 60–70% da área total de piso para os ambientes sem projeto detalhado',
      },
      {
        id: 'fin09-cl3',
        texto:
          'Incluí na conta os revestimentos especiais: deck, pastilha de piscina, pedra de fachada e pisos externos',
      },
      {
        id: 'fin09-cl4',
        texto: 'Defini uma meta de custo por m² de revestimento compatível com o padrão da casa',
      },
      {
        id: 'fin09-cl5',
        texto:
          'Calculei o custo total dos revestimentos multiplicando a área total pela meta de R$/m²',
      },
      {
        id: 'fin09-cl6',
        texto:
          'Calculei o percentual dos revestimentos no orçamento global e avaliei se está dentro de ~10%',
      },
    ],
    metadados: [
      {
        campo: 'area_total_revestimento_m2',
        label: 'Área total de revestimentos (m²)',
        tipo: 'number',
        placeholder: 'Ex: 650',
      },
      {
        campo: 'meta_custo_m2_revestimento_rs',
        label: 'Meta de custo por m² de revestimento (R$)',
        tipo: 'number',
        placeholder: 'Ex: 150',
      },
      {
        campo: 'percentual_revestimentos_orcamento',
        label: 'Percentual dos revestimentos no orçamento (%)',
        tipo: 'number',
        placeholder: 'Ex: 10',
      },
    ],
    temFerramenta: false,
  },
]
TOPICOS_CONTENT.push(...FIN_CONTENT_4)

const FIN_CONTENT_5: TopicoContent[] = [
  {
    topicoId: 'fin-10',
    resumo: [
      'Depois dos itens pesados, cerque os demais com cotação direta ou estimativa por m² · o objetivo é não ser surpreendido na obra',
      'Louças e metais: liste por ambiente (torneira, cuba, bojo, chuveiro), pesquise preços e ajuste o mix até o total caber na meta',
      'Marmoraria: leve o projeto à marmoraria e peça cotação · em uma visita você domina um dos itens mais caros da obra com número real',
      'Iluminação: o item mais flexível da obra · variação de até 15x entre internet e loja de grife · fixe um teto antes de escolher qualquer peça',
      'Forro: estime pela área coberta · gesso ~R$ 75/m² para toda a área; madeira ~R$ 700/m² (quase 10x mais caro), use pontualmente',
      'Ao completar essas verificações você está blindado contra surpresas · reprogramar a rota agora custa zero; parar no meio da obra custa muito',
    ],
    dicasDeOuro: [
      {
        icone: '🚿',
        texto:
          'Liste louças e metais por ambiente antes de escolher · quando o total ultrapassar a meta, troque peças menos visíveis por versões mais baratas',
      },
      {
        icone: '🔍',
        texto:
          'Leve o projeto a uma marmoraria para cotação: em uma visita você tem número real para um dos itens mais caros, sem precisar estimar',
      },
      {
        icone: '💡',
        texto:
          'Defina o teto de gasto para iluminação antes de entrar na loja · sem teto, o mesmo ambiente pode custar R$ 2k ou R$ 30k em luminárias',
      },
      {
        icone: '📐',
        texto:
          'Calcule o forro com área coberta × tipo: gesso R$ 75/m² em toda a área; madeira R$ 700/m² apenas onde for destaque visual',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Iluminação sem teto de gasto definido é a rubrica que explode silenciosamente · escolhas premium em cada cômodo somam facilmente R$ 20–50k extras',
      },
      {
        icone: '💸',
        texto:
          'Trocar gesso por madeira em toda a área coberta multiplica o custo desse item por quase 10x · avalie uso pontual em ambientes de destaque',
      },
      {
        icone: '🚧',
        texto:
          'Se as verificações revelarem obra inviável, reprogramar agora é gratuito · iniciar obra sem viabilidade confirmada e parar no meio é o pior cenário possível',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'fin10-cl1',
        texto:
          'Listei louças e metais por ambiente e pesquisei preços para ter o custo total desse contrato',
      },
      {
        id: 'fin10-cl2',
        texto:
          'Levei o projeto a pelo menos uma marmoraria e obtive cotação real para bancadas e elementos em pedra',
      },
      {
        id: 'fin10-cl3',
        texto:
          'Defini um teto de gasto para iluminação e confirmei que o item cabe no orçamento global',
      },
      {
        id: 'fin10-cl4',
        texto:
          'Calculei o custo do forro multiplicando a área coberta pelo preço/m² do material escolhido',
      },
      {
        id: 'fin10-cl5',
        texto:
          'Somei todos os itens verificados e calculei o total estimado da obra até este ponto',
      },
      {
        id: 'fin10-cl6',
        texto:
          'Avaliei se o total está viável · se não, identifiquei os itens a reprogramar antes de contratar qualquer serviço',
      },
    ],
    metadados: [
      {
        campo: 'custo_loucas_metais_rs',
        label: 'Custo estimado de louças e metais (R$)',
        tipo: 'number',
        placeholder: 'Ex: 35000',
      },
      {
        campo: 'custo_forro_estimado_rs',
        label: 'Custo estimado do forro (R$)',
        tipo: 'number',
        placeholder: 'Ex: 18000',
      },
      {
        campo: 'custo_iluminacao_teto_rs',
        label: 'Teto de gasto para iluminação (R$)',
        tipo: 'number',
        placeholder: 'Ex: 20000',
      },
    ],
    temFerramenta: false,
  },
]
TOPICOS_CONTENT.push(...FIN_CONTENT_5)

// ── Tributos ──────────────────────────────────────────────────

const TRIB_CONTENT: TopicoContent[] = [
  {
    topicoId: 'trib-02',
    resumo: [
      'A regularização de uma obra percorre 3 camadas: Prefeitura, Receita Federal e Cartório',
      'Cada camada tem pré-requisitos da anterior · pular etapas gera bloqueios e multas',
      'A Prefeitura emite o Alvará e o Habite-se; a Receita cuida do CNO e INSS; o Cartório averba a construção',
      'O recurso abaixo permite rastrear o andamento de cada etapa',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto:
          'Comece pela Prefeitura antes mesmo de iniciar a obra · o Alvará é o marco inicial do CNO',
      },
      {
        icone: '💡',
        texto: 'Sem Habite-se, você não consegue averbar no cartório e o imóvel fica irregular',
      },
      { icone: '💡', texto: 'A Receita Federal cruza dados com Prefeitura · tenha tudo alinhado' },
    ],
    atencao: [
      { icone: '⚠️', texto: 'Obra sem CNO pode gerar auto de infração com multa retroativa' },
      { icone: '⚠️', texto: 'Cartório sem CND da Receita: averbação pode ser bloqueada' },
    ],
    checklistAplicabilidade: [
      { id: 'trib02-cl1', texto: 'Marquei todas as etapas da esteira que já concluí' },
      { id: 'trib02-cl2', texto: 'Sei quais etapas estão pendentes e a próxima etapa de cada uma' },
    ],
    metadados: [],
    temFerramenta: true,
  },
  {
    topicoId: 'trib-04',
    resumo: [
      'O CNO (Cadastro Nacional de Obra) deve ser aberto no e-CAC em até 30 dias após o alvará',
      'O CNO é a "identidade fiscal" da sua obra perante a Receita Federal',
      'Sem CNO, todas as GPS de INSS ficam inválidas e o INSS de mão de obra não é reconhecido',
      'O encerramento do CNO exige CND · e sem encerrar, o imóvel não pode ser vendido com financiamento',
    ],
    dicasDeOuro: [
      { icone: '💡', texto: 'Abra o CNO assim que receber o Alvará · não deixe para o último dia' },
      {
        icone: '💡',
        texto:
          'Para abrir, você precisa de: endereço completo da obra, área, tipo, ART/RRT do responsável',
      },
      {
        icone: '💡',
        texto: 'O número do CNO deve constar em todos os contratos e notas fiscais da obra',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto: 'Abertura em atraso gera multa de 2% do INSS devido por mês de atraso',
      },
      {
        icone: '⚠️',
        texto: 'CNO em aberto após conclusão pode travar financiamento e venda do imóvel',
      },
    ],
    checklistAplicabilidade: [
      { id: 'trib04-cl1', texto: 'Usei o recurso para calcular o prazo de abertura do CNO' },
      { id: 'trib04-cl2', texto: 'Tenho acesso ao e-CAC (gov.br ou certificado digital)' },
      { id: 'trib04-cl3', texto: 'Abri o CNO dentro do prazo de 30 dias' },
    ],
    metadados: [
      {
        campo: 'numero_cno',
        label: 'Número do CNO',
        tipo: 'text',
        placeholder: 'Ex: 3.002.123/456-7',
      },
      { campo: 'data_alvara', label: 'Data do Alvará', tipo: 'text', placeholder: 'DD/MM/AAAA' },
    ],
    temFerramenta: true,
  },
  {
    topicoId: 'trib-06',
    resumo: [
      'O INSS de obra é uma contribuição previdenciária sobre a mão de obra da construção',
      'A alíquota varia conforme o tipo de contratação: 3,5% (empreitada total) a 20% (CLT direto)',
      'O contratante da obra é o responsável pelo recolhimento · mesmo que a empreiteira não pague',
      'Guardar GPS, contratos e notas fiscais é a única defesa contra cobranças retroativas',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto: 'Empreitada Total com empresa idônea é a modalidade de menor risco fiscal',
      },
      {
        icone: '💡',
        texto: 'Exija CND (Certidão Negativa de Débito) da empreiteira antes de todo pagamento',
      },
      {
        icone: '💡',
        texto: 'MEI não gera obrigação de retenção para o contratante · confirme o enquadramento',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto: 'INSS não recolhido pode ser cobrado com multa e juros por até 5 anos',
      },
      {
        icone: '⚠️',
        texto: 'Contratar autônomo sem RPA e retenção coloca você como devedor solidário',
      },
    ],
    checklistAplicabilidade: [
      { id: 'trib06-cl1', texto: 'Calculei o INSS estimado com o recurso abaixo' },
      { id: 'trib06-cl2', texto: 'Defini o tipo de contratação que usarei na obra' },
      { id: 'trib06-cl3', texto: 'Entendo minha responsabilidade como tomador de serviço' },
    ],
    metadados: [],
    temFerramenta: true,
  },
  {
    topicoId: 'trib-12',
    resumo: [
      'Ao vender um imóvel, o ganho de capital (venda − custo) é tributado pelo IR',
      'O custo inclui: preço do terreno + construção documentada + benfeitorias comprovadas',
      'Alíquota progressiva: 15% até R$5M, 17,5% de R$5M-10M, 20% de R$10M-30M, 22,5% acima',
      'Documentar a obra aumenta o custo e reduz drasticamente o imposto na venda',
      'Isenção possível: imóvel único até R$440.000 ou reinvestimento em 180 dias',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto: 'Cada R$1.000 de obra documentada economiza R$150 de IR na venda (alíquota 15%)',
      },
      {
        icone: '💡',
        texto: 'Atualize o custo do imóvel na DIRPF a cada ano com os gastos de construção',
      },
      {
        icone: '💡',
        texto: 'Reinvestir o valor da venda em outro imóvel em 180 dias pode isentar o IR',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto: 'Obra não documentada aumenta o ganho tributável e pode gerar IR alto na venda',
      },
      {
        icone: '⚠️',
        texto:
          'A Receita Federal cruza dados de ITBI com declaração de venda · declare corretamente',
      },
    ],
    checklistAplicabilidade: [
      { id: 'trib12-cl1', texto: 'Simulei meu IR na venda com o recurso abaixo' },
      { id: 'trib12-cl2', texto: 'Entendo a importância de documentar todos os gastos da obra' },
      { id: 'trib12-cl3', texto: 'Vou declarar o custo da obra anualmente na DIRPF' },
    ],
    metadados: [],
    temFerramenta: true,
  },
  {
    topicoId: 'trib-14',
    resumo: [
      'Documentos são sua única defesa contra autuações, disputas contratuais e cobranças indevidas',
      'A Receita Federal pode cobrar retroativamente por até 5 anos · tenha tudo guardado',
      'Os documentos mais críticos: NFs de materiais, GPS do INSS, contratos, matrícula e Alvará',
      'Guarde em nuvem e em local físico seguro · documentos de obra devem durar décadas',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto: 'Digitalize tudo e armazene no Google Drive ou similar · papel deteriora',
      },
      {
        icone: '💡',
        texto:
          'Organize em pastas por categoria: Terreno, Projetos, Contratos, NFs, INSS, Cartório',
      },
      {
        icone: '💡',
        texto:
          'Um único documento faltando pode custar muito mais do que o custo de solicitá-lo a tempo',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto: 'NF de material sem comprovante de pagamento pode ser desconsiderada pela Receita',
      },
      {
        icone: '⚠️',
        texto: 'Contrato sem valor especificado não serve para compor o custo da obra no IR',
      },
    ],
    checklistAplicabilidade: [
      { id: 'trib14-cl1', texto: 'Conferi o checklist de documentos críticos abaixo' },
      { id: 'trib14-cl2', texto: 'Digitalizei e organizei os documentos já em mãos' },
      {
        id: 'trib14-cl3',
        texto: 'Tenho local seguro (físico e digital) para guardar os documentos',
      },
    ],
    metadados: [],
    temFerramenta: true,
  },
  {
    topicoId: 'trib-18',
    resumo: [
      'A Receita Federal usa o Fator de Ajuste para presumir o custo de uma obra quando não há documentação',
      'O cálculo é baseado no CUB (Custo Unitário Básico) publicado mensalmente',
      'Se o custo declarado for muito inferior ao presumido, a Receita pode autuar e cobrar a diferença',
      'O recurso abaixo compara seu custo declarado com o presumido e aponta o risco',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto: 'Quanto mais documentação, mais distante do Fator de Ajuste você fica',
      },
      {
        icone: '💡',
        texto: 'O CUB é regional · estados do Norte têm CUB maior, o que aumenta o presumido',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Declarar custo muito abaixo do CUB sem documentação é o principal gatilho de autuação',
      },
      { icone: '⚠️', texto: 'Em caso de fiscalização, a documentação é o único argumento válido' },
    ],
    checklistAplicabilidade: [
      {
        id: 'trib18-cl1',
        texto: 'Calculei o custo presumido pela Receita com o recurso abaixo',
      },
      {
        id: 'trib18-cl2',
        texto: 'Meu custo declarado está dentro de um intervalo razoável (diferença < 35%)',
      },
    ],
    metadados: [],
    temFerramenta: true,
  },
  {
    topicoId: 'trib-22',
    resumo: [
      'A regularização completa de uma obra envolve 12 ações fiscais distribuídas em 4 categorias',
      'CNO, recolhimento de INSS, documentação fiscal e averbação cartorial são os pilares',
      'Use o checklist abaixo para rastrear o andamento e identificar pendências de alta prioridade',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto: 'Resolva primeiro os itens de Prioridade Alta · eles têm maior risco financeiro',
      },
      {
        icone: '💡',
        texto: 'Um contador especializado em obra custa menos do que uma autuação da Receita',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto: 'Regularização incompleta pode travar financiamento, venda e inventário do imóvel',
      },
    ],
    checklistAplicabilidade: [
      { id: 'trib22-cl1', texto: 'Completei o checklist de saúde fiscal abaixo' },
      { id: 'trib22-cl2', texto: 'Resolvi ou planejei resolver todos os itens de Prioridade Alta' },
    ],
    metadados: [],
    temFerramenta: true,
  },
]

TOPICOS_CONTENT.push(...TRIB_CONTENT)

const TRIB_CONTENT_00: TopicoContent[] = [
  {
    topicoId: 'trib-00',
    resumo: [
      'Tributos de obra percorrem 6 blocos: da consciência às estratégias de pagar menos na lei',
      'Bloco Fundamentos: quem não conhece as regras do jogo tributário não consegue otimizá-las',
      'Bloco Decisões: a forma de contratar (empreitada, MEI, autônomo) define o valor do INSS',
      'Bloco Dinheiro: documentos fiscais e notas impactam diretamente o imposto de renda',
      'Bloco Estratégias (o ouro): formas legais de reduzir INSS, IR e encargos da obra',
      'Bloco Problema-Solução: regularização ainda tem saída mesmo quando o problema já chegou',
    ],
    dicasDeOuro: [
      {
        icone: '🗂️',
        texto:
          'Guarde todas as notas fiscais desde o primeiro pagamento · uma única nota pode reduzir até 3 impostos diferentes ao mesmo tempo',
      },
      {
        icone: '⚖️',
        texto:
          'Estude o bloco de Decisões antes de assinar qualquer contrato de mão de obra · a forma de contratar define quanto de INSS você paga ao longo de toda a obra',
      },
      {
        icone: '🎯',
        texto:
          'Se a obra já está em execução, priorize o bloco de Estratégias · ele concentra as formas de economizar antes que as decisões se tornem irreversíveis',
      },
      {
        icone: '🛤️',
        texto:
          'A sequência lógica dos blocos prepara os conceitos progressivamente · mas cada bloco pode ser acessado isoladamente se você já conhece os anteriores',
      },
    ],
    atencao: [
      {
        icone: '⏳',
        texto:
          'Decisões de contratação feitas sem conhecer as regras tributárias podem gerar cobranças retroativas de INSS por até 5 anos · o erro de hoje vira passivo futuro',
      },
      {
        icone: '📉',
        texto:
          'Quando o problema tributário já foi instaurado (autuação, pendência na Receita), as opções de regularização ficam mais caras e o espaço de negociação reduz drasticamente',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'trib-00-cl1',
        texto:
          'Identifiquei em qual bloco desta etapa estou mais defasado e defini por onde começar',
      },
      {
        id: 'trib-00-cl2',
        texto:
          'Separei uma pasta física ou digital exclusiva para guardar notas fiscais desde o início da obra',
      },
      {
        id: 'trib-00-cl3',
        texto:
          'Listei as formas de contratação que já usei ou pretendo usar na obra (empreiteiro, autônomo, MEI, CLT)',
      },
      {
        id: 'trib-00-cl4',
        texto: 'Confirmei se o CNO da obra já foi aberto ou se ainda precisa ser aberto no e-CAC',
      },
      {
        id: 'trib-00-cl5',
        texto: 'Verifiquei em que etapa da obra estou para priorizar os blocos mais urgentes',
      },
      {
        id: 'trib-00-cl6',
        texto:
          'Identifiquei quais impostos já estão no meu radar: INSS de obra, GCAP e IRPF sobre o imóvel',
      },
    ],
    metadados: [
      {
        campo: 'bloco_prioritario_estudo',
        label: 'Bloco prioritário para estudar primeiro',
        tipo: 'select',
        opcoes: [
          'Bloco 1 · Consciência',
          'Bloco 2 · Fundamentos',
          'Bloco 3 · Decisões',
          'Bloco 4 · Dinheiro',
          'Bloco 5 · Estratégias (ouro)',
          'Bloco 6 · Problema-Solução',
        ],
      },
      {
        campo: 'etapa_atual_obra_trib',
        label: 'Etapa atual da obra',
        tipo: 'select',
        opcoes: [
          'Pré-obra (planejamento)',
          'Em execução',
          'Obra finalizada · regularização pendente',
          'Imóvel pronto há mais de 2 anos',
        ],
      },
      {
        campo: 'pasta_notas_organizada',
        label: 'Pasta de notas fiscais organizada?',
        tipo: 'select',
        opcoes: ['Sim · física e digital', 'Sim · só digital', 'Só física', 'Ainda não organizei'],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...TRIB_CONTENT_00)

const TRIB_CONTENT_01: TopicoContent[] = [
  {
    topicoId: 'trib-01',
    resumo: [
      'Obra que existe já carrega obrigações fiscais · a diferença é se você as conhece ou não',
      'Há 3 caminhos: pagar o valor justo, pagar mais por desconhecimento, ou travar o imóvel',
      'O ponto cego da construção civil: projetos e materiais são debatidos, mas o fiscal é ignorado',
      'INSS de obra é um tributo, não um imposto · ignorá-lo gera dívida retroativa de até 5 anos',
      'Decisões de contratação de hoje definem se você consegue vender, averbar e financiar lá na frente',
      'Regularização inteligente economiza dinheiro e tempo · chegar desinformado custa muito mais',
    ],
    dicasDeOuro: [
      {
        icone: '🗺️',
        texto:
          'Identifique qual perfil fiscal você é agora (desavisado, apavorado, travado, cauteloso) para saber onde focar a atenção antes de tomar as próximas decisões',
      },
      {
        icone: '📋',
        texto:
          'Entender o mapa tributário da obra é suficiente para tomar boas decisões · você não precisa virar especialista em INSS, só precisa conhecer as regras do jogo',
      },
      {
        icone: '⏰',
        texto:
          'Estude as regras fiscais antes de assinar qualquer contrato de mão de obra · decisões tomadas antes do conhecimento são as mais difíceis e caras de corrigir',
      },
      {
        icone: '🏦',
        texto:
          'Regularização bem feita libera venda, financiamento e averbação · imóvel com pendência fiscal é um ativo que não circula e perde valor de mercado',
      },
    ],
    atencao: [
      {
        icone: '🔍',
        texto:
          'A Receita Federal cruza dados automaticamente · você pode estar devendo INSS de obra sem saber, e o acréscimo de multa e juros cresce silenciosamente por anos',
      },
      {
        icone: '🏚️',
        texto:
          'Imóvel irregular por pendências fiscais não pode ser vendido com financiamento e fica travado em inventário · a irregularidade custa mais do que o imposto original',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'trib-01-cl1',
        texto:
          'Identifiquei com qual perfil fiscal me identifico: desavisado, apavorado, envergonhado, travado ou cauteloso',
      },
      {
        id: 'trib-01-cl2',
        texto:
          'Confirmei que minha obra tem obrigações fiscais independentemente do tamanho ou de quanto já paguei',
      },
      {
        id: 'trib-01-cl3',
        texto:
          'Entendi que a questão não é SE pago, mas COMO · e escolhi o caminho de pagar o valor exato e justo',
      },
      {
        id: 'trib-01-cl4',
        texto:
          'Listei as formas de contratação já utilizadas para avaliar se estão dentro das regras fiscais',
      },
      {
        id: 'trib-01-cl5',
        texto:
          'Verifiquei se o imóvel tem pendências que possam bloquear venda ou financiamento no futuro',
      },
      {
        id: 'trib-01-cl6',
        texto:
          'Marquei as decisões de contratação futuras que ainda posso otimizar para pagar o mínimo dentro da lei',
      },
    ],
    metadados: [
      {
        campo: 'perfil_fiscal_identificado',
        label: 'Perfil fiscal com que mais me identifico',
        tipo: 'select',
        opcoes: [
          'Desavisado · nunca ouvi falar de INSS de obra',
          'Apavorado · acho que estou devendo sem saber',
          'Envergonhado · fiz errado e temo as consequências',
          'Travado · dúvidas bloqueiam minhas decisões',
          'Cauteloso · quero reduzir mas com segurança',
        ],
      },
      {
        campo: 'principal_risco_percebido',
        label: 'Principal risco fiscal identificado na minha obra',
        tipo: 'text',
        placeholder: 'Ex: INSS não recolhido / imóvel sem averbação',
      },
      {
        campo: 'imovel_tem_pendencia_fiscal',
        label: 'Imóvel tem pendência fiscal conhecida?',
        tipo: 'select',
        opcoes: [
          'Não · estou regularizado',
          'Sim · sei qual é e estou resolvendo',
          'Sim · não sei exatamente o que é',
          'Ainda não verifiquei',
        ],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...TRIB_CONTENT_01)

const TRIB_CONTENT_03: TopicoContent[] = [
  {
    topicoId: 'trib-03',
    resumo: [
      'A regularização percorre 3 fases: pré-obra, construção ativa e desfecho físico-fiscal',
      'A linha do tempo começa no Alvará e só termina com o registro no Cartório',
      'CNO deve ser aberto em até 30 dias após o Alvará · é o ponto de partida fiscal da obra',
      'Durante a obra: alimentar eSocial, gerar DCTF Web e pagar guias de INSS mensalmente',
      'Sem CND (Certidão Negativa de Débito), o Cartório não registra e o imóvel não pertence a você',
      'Obra concluída de verdade = Habite-se + CND + matrícula atualizada no Cartório',
    ],
    dicasDeOuro: [
      {
        icone: '📅',
        texto:
          'Abra o CNO imediatamente após receber o Alvará · o prazo de 30 dias não para e o atraso gera multa retroativa calculada sobre todo o INSS due',
      },
      {
        icone: '🔍',
        texto:
          'Verifique os dados do CNO mesmo quando foi aberto por terceiro (engenheiro, contador) · erro no cadastro contamina toda a regularização e pode travar a CND',
      },
      {
        icone: '🔄',
        texto:
          'Trate a regularização fiscal como ciclo mensal durante a obra: eSocial → DCTF Web → guia paga · deixar acumular transforma em problema de regularização retroativa',
      },
      {
        icone: '🔑',
        texto:
          'A CND é a chave do Cartório · só a obtenha após encerrar o CNO com INSS integralmente quitado; sem ela o imóvel existe fisicamente mas não é seu juridicamente',
      },
    ],
    atencao: [
      {
        icone: '📌',
        texto:
          'CNO com dados errados (área, tipo, responsável técnico) gera inconsistência detectável pela Receita Federal e pode resultar em autuação com multa retroativa',
      },
      {
        icone: '⛓️',
        texto:
          'Sem CND, o imóvel não pode ser vendido com financiamento, não pode ser inventariado e não pertence a você juridicamente · é o risco mais silencioso da obra',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'trib-03-cl1',
        texto:
          'Confirmei aprovação do projeto na prefeitura e tenho o Alvará de Construção em mãos',
      },
      {
        id: 'trib-03-cl2',
        texto: 'Abri o CNO no e-CAC dentro do prazo de 30 dias após o Alvará de Construção',
      },
      {
        id: 'trib-03-cl3',
        texto:
          'Revisei os dados do CNO (área, tipo, responsável técnico) para garantir que estão corretos',
      },
      {
        id: 'trib-03-cl4',
        texto: 'Configurei os lançamentos mensais no eSocial durante todo o período de construção',
      },
      {
        id: 'trib-03-cl5',
        texto: 'Solicitei o Habite-se na prefeitura após conclusão física da obra',
      },
      {
        id: 'trib-03-cl6',
        texto: 'Obtive a CND da Receita Federal para encaminhar o registro no Cartório de Imóveis',
      },
    ],
    metadados: [
      {
        campo: 'fase_atual_regularizacao',
        label: 'Fase atual da regularização da obra',
        tipo: 'select',
        opcoes: [
          'Fase 1 · Aguardando Alvará',
          'Fase 1 · Alvará em mãos (CNO a abrir)',
          'Fase 2 · Em construção (CNO aberto)',
          'Fase 3 · Habite-se solicitado',
          'Fase 3 · CND em mãos',
          'Concluído · Registrado no Cartório',
        ],
      },
      {
        campo: 'data_abertura_cno_trib03',
        label: 'Data de abertura do CNO',
        tipo: 'text',
        placeholder: 'Ex: 15/01/2025',
      },
      {
        campo: 'esocial_lancamentos_em_dia',
        label: 'Lançamentos no eSocial em dia?',
        tipo: 'select',
        opcoes: [
          'Sim · todos os meses em dia',
          'Parcialmente atualizado',
          'Ainda não iniciei os lançamentos',
          'Não se aplica · obra encerrada',
        ],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...TRIB_CONTENT_03)

const TRIB_CONTENT_05: TopicoContent[] = [
  {
    topicoId: 'trib-05',
    resumo: [
      'A obra tem 3 camadas: física (visível), fiscal (auditada pela Receita) e patrimonial (GCAP/IR)',
      'Ao retirar o Alvará, a prefeitura notifica a Receita Federal automaticamente via CISOBRA-PREF',
      'Desde 2021, o mito dos 5 anos acabou · a Receita nasce sabendo da obra assim que o Alvará é emitido',
      'A camada patrimonial define se o lucro da obra vai para o bolso ou para o leão no GCAP na venda',
      'Quem ainda vai começar tem o menor custo possível · estruture as 3 camadas desde o dia zero',
      'Obra concluída sem regularização: a cartinha da Receita chega · não existe escapar após 2021',
    ],
    dicasDeOuro: [
      {
        icone: '🛡️',
        texto:
          'Estruture as 3 camadas da obra desde o início · a patrimonial (IR e GCAP) é a que mais pessoas ignoram e a que mais custa na venda futura do imóvel',
      },
      {
        icone: '📮',
        texto:
          'Se a obra já terminou sem regularização, não espere a cartinha chegar · regularização proativa custa menos do que após autuação da Receita Federal',
      },
      {
        icone: '💰',
        texto:
          'Quem constrói como investimento precisa cuidar especialmente do GCAP · o imposto sobre o lucro na venda pode devorar o retorno calculado na ponta do lápis',
      },
      {
        icone: '📅',
        texto:
          'Obras com Alvará antes de 2021 podem ter situação diferente quanto à prescrição · consulte um especialista antes de assumir que o débito prescreveu',
      },
    ],
    atencao: [
      {
        icone: '🚨',
        texto:
          'O sistema CISOBRA-PREF obrigou prefeituras a informar a Receita Federal automaticamente · toda obra com Alvará emitido após 2021 está no radar sem nenhuma ação sua',
      },
      {
        icone: '⏳',
        texto:
          'A prescrição de 5 anos não se aplica a obras pós-2021 · esperar só aumenta multa e juros; a dívida não desaparece, ela cresce enquanto você espera',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'trib-05-cl1',
        texto:
          'Mapeei as 3 camadas da minha obra: o que está regularizado em cada uma (física, fiscal e patrimonial)',
      },
      {
        id: 'trib-05-cl2',
        texto:
          'Identifiquei se meu Alvará foi emitido após 2021 e confirmei que estou no radar da Receita via CISOBRA-PREF',
      },
      {
        id: 'trib-05-cl3',
        texto: 'Identifiquei meu cenário: ainda vai começar, já começou ou já terminou',
      },
      {
        id: 'trib-05-cl4',
        texto:
          'Tomei providências para regularizar a camada fiscal (CNO, INSS, eSocial) antes da cartinha chegar',
      },
      {
        id: 'trib-05-cl5',
        texto:
          'Calculei o impacto do GCAP e do IR na venda futura do imóvel para entender o lucro real (camada patrimonial)',
      },
      {
        id: 'trib-05-cl6',
        texto:
          'Decidi não esperar · a obra está no radar da Receita desde o Alvará e qualquer atraso aumenta o custo',
      },
    ],
    metadados: [
      {
        campo: 'cenario_regularizacao_atual',
        label: 'Em qual cenário você está?',
        tipo: 'select',
        opcoes: [
          'Ainda vou começar · estruturando as 3 camadas',
          'Já comecei · preciso de correção rápida',
          'Já terminei · regularização retroativa pendente',
          'Já terminei · tudo regularizado',
        ],
      },
      {
        campo: 'camada_mais_defasada',
        label: 'Camada mais defasada na sua obra',
        tipo: 'select',
        opcoes: [
          'Fiscal (CNO, INSS, eSocial)',
          'Patrimonial (custo de aquisição, GCAP, IR)',
          'Ambas · fiscal e patrimonial',
          'Estou regularizado nas 3 camadas',
        ],
      },
      {
        campo: 'alvara_emitido_apos_2021',
        label: 'Alvará emitido após 2021 (CISOBRA-PREF)?',
        tipo: 'select',
        opcoes: [
          'Sim · estou no radar da Receita',
          'Não · Alvará anterior a 2021',
          'Não sei a data exata do Alvará',
        ],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...TRIB_CONTENT_05)

const TRIB_CONTENT_07: TopicoContent[] = [
  {
    topicoId: 'trib-07',
    resumo: [
      'A forma de contratar mão de obra define diretamente quanto de INSS você vai pagar na obra',
      'Decidir apenas por preço é o erro mais comum · INSS, risco e gestão também compõem o custo real',
      'O contrato é a bússola fiscal da obra · 100% da responsabilidade de INSS depende do modelo legal escolhido',
      'Há 3 modalidades principais: empreitada total, empreitada parcial e autônomos/MEIs',
      'Os impactos da forma de contratar persistem além da obra · aparecem na venda e na regularização futura',
      'Quanto mais descentralizada a contratação, mais trabalho de gestão fiscal você assume diretamente',
    ],
    dicasDeOuro: [
      {
        icone: '⚖️',
        texto:
          'Avalie cada contratação por 4 critérios: valor do INSS, nível de risco assumido, trabalho de gestão e impactos futuros · preço do serviço é apenas um deles',
      },
      {
        icone: '📝',
        texto:
          'Nunca inicie um serviço sem contrato assinado · é o documento que define quem arca com o INSS daquele serviço e quem responde em caso de autuação',
      },
      {
        icone: '🎯',
        texto:
          'Se já sabe a modalidade que vai usar, vá direto à etapa específica · se ainda está decidindo, compare as 3 modalidades em sequência',
      },
      {
        icone: '📅',
        texto:
          'Defina a forma de contratar antes de abrir o CNO · a modalidade influencia como você vai configurar o eSocial e os recolhimentos mensais',
      },
    ],
    atencao: [
      {
        icone: '🚫',
        texto:
          'Contratar por preço sem avaliar o INSS embutido pode transformar uma economia aparente em custo real muito maior após uma autuação da Receita Federal',
      },
      {
        icone: '🔁',
        texto:
          'Mudar de modalidade de contratação no meio da obra é difícil · exige reconfiguração no eSocial e pode gerar inconsistências fiscais difíceis de corrigir retroativamente',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'trib-07-cl1',
        texto:
          'Defini a modalidade de contratação que usarei na obra antes de assinar qualquer contrato',
      },
      {
        id: 'trib-07-cl2',
        texto:
          'Avaliei os 4 critérios de cada modalidade: valor do INSS, risco, trabalho de gestão e impactos futuros',
      },
      {
        id: 'trib-07-cl3',
        texto:
          'Comparei o custo total (serviço + INSS) entre as modalidades antes de tomar a decisão final',
      },
      {
        id: 'trib-07-cl4',
        texto: 'Assinei contrato formal com cada prestador antes do início do serviço',
      },
      {
        id: 'trib-07-cl5',
        texto:
          'Confirmei que a modalidade escolhida está configurada corretamente no eSocial e no CNO',
      },
    ],
    metadados: [
      {
        campo: 'modalidade_contratacao_principal',
        label: 'Modalidade de contratação principal escolhida',
        tipo: 'select',
        opcoes: [
          'Empreitada total (construtora)',
          'Empreitada parcial',
          'Autônomos e MEIs',
          'Misto de modalidades',
          'Ainda não decidi',
        ],
      },
      {
        campo: 'avaliou_alem_do_preco',
        label: 'Avaliou INSS, risco e gestão além do preço?',
        tipo: 'select',
        opcoes: [
          'Sim · avaliei os 4 critérios',
          'Parcialmente · analisei alguns',
          'Não · decidi só pelo preço e preciso reavaliar',
          'Ainda estou avaliando',
        ],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...TRIB_CONTENT_07)

const TRIB_CONTENT_08: TopicoContent[] = [
  {
    topicoId: 'trib-08',
    resumo: [
      'Na empreitada total a construtora assume 100% da mão de obra · inclusive via subcontratação',
      'Benefícios: responsabilidade concentrada num único CNPJ, baixo envolvimento do dono, menor risco operacional',
      'No cenário ideal, o INSS já está embutido no preço e a CND é entregue sem custo extra',
      'Armadilha mais comum: construtora propõe abrir o CNO só no final da obra · sinal vermelho',
      'Construtora que não aloca mensalmente acumula passivo que cai no CPF do dono se ela quebrar',
      'O contrato de empreitada total precisa de 4 cláusulas fiscais obrigatórias para ser seguro',
    ],
    dicasDeOuro: [
      {
        icone: '🔒',
        texto:
          'Exija no contrato que a construtora abra o CNO imediatamente · "deixar para o final" é a frase que antecede o efeito dominó do passivo tributário',
      },
      {
        icone: '📋',
        texto:
          'Solicite comprovação mensal da alocação de funcionários no eSocial · é a única garantia de que o INSS está sendo pago e não vai aparecer como surpresa no final',
      },
      {
        icone: '💬',
        texto:
          'Exigir cláusulas fiscais no contrato não é frescura · é a primeira auditoria de saúde financeira e pode revelar uma construtora que vai quebrar no meio da obra',
      },
      {
        icone: '💲',
        texto:
          'Peça preço fechado que já englobe o INSS previdenciário · se a proposta não inclui esse custo, questione quem vai pagar antes de assinar qualquer documento',
      },
    ],
    atencao: [
      {
        icone: '🔴',
        texto:
          '"A gente abre o CNO só no final" é sinal de alerta máximo · significa que não haverá alocação mensal de funcionários, e o passivo tributário acumulado pode cair no seu CPF',
      },
      {
        icone: '⛓️',
        texto:
          'Construtora que quebra durante a obra deixa o dono como devedor solidário do INSS não recolhido · a responsabilidade não some com a falência da empresa contratada',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'trib-08-cl1',
        texto:
          'Incluí no contrato a responsabilidade exclusiva da construtora por 100% da mão de obra (empreitada total)',
      },
      {
        id: 'trib-08-cl2',
        texto:
          'Exigi abertura imediata do CNO como cláusula contratual · não aceitei "abrimos no final"',
      },
      {
        id: 'trib-08-cl3',
        texto: 'Estabeleci cláusula de comprovação mensal da alocação de funcionários no eSocial',
      },
      {
        id: 'trib-08-cl4',
        texto: 'Confirmei que o preço fechado já inclui o custo previdenciário do INSS de obra',
      },
      {
        id: 'trib-08-cl5',
        texto:
          'Solicitei a CND da construtora (certidão negativa de débito) antes de assinar o contrato',
      },
      {
        id: 'trib-08-cl6',
        texto:
          'Verifiquei a saúde financeira da construtora para reduzir o risco de quebra e absorção do passivo tributário',
      },
    ],
    metadados: [
      {
        campo: 'cno_abertura_empreitada',
        label: 'Quando a construtora vai abrir o CNO?',
        tipo: 'select',
        opcoes: [
          'Imediatamente (dia 1) · correto',
          'No final da obra · risco alto',
          'Não sei quando vai abrir',
          'CNO já aberto pela construtora',
        ],
      },
      {
        campo: 'comprovacao_mensal_clausula',
        label: 'Cláusula de comprovação mensal do eSocial no contrato?',
        tipo: 'select',
        opcoes: [
          'Sim · incluída no contrato',
          'Não · preciso incluir ainda',
          'A construtora "garante" sem cláusula · risco',
          'Não se aplica à minha situação',
        ],
      },
      {
        campo: 'inss_embutido_no_preco',
        label: 'INSS previdenciário embutido no preço fechado?',
        tipo: 'select',
        opcoes: [
          'Sim · confirmado e descrito na proposta',
          'Não sei · não foi mencionado',
          'Não · será cobrado separadamente',
          'A definir antes de assinar',
        ],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...TRIB_CONTENT_08)

const TRIB_CONTENT_09: TopicoContent[] = [
  {
    topicoId: 'trib-09',
    resumo: [
      'Na empreitada parcial o dono é o gestor central com múltiplos contratos por etapa da obra',
      'Fornecedores com CNPJ e funcionários CLT permitem alocação digital de equipe na sua obra',
      'O segredo não está só na execução física · está na vinculação digital dos funcionários no CNO',
      'Combine a alocação de funcionários CLT antes do início de cada etapa · depois é tarde demais',
      'Empresa terceira CLT aloca funcionário na sua obra → você recebe abatimento legal de INSS',
      'Empreitada parcial permite especialização técnica · melhor pintor, melhor eletricista, etc.',
    ],
    dicasDeOuro: [
      {
        icone: '🤝',
        texto:
          'Antes de contratar cada etapa, pergunte se a empresa tem CLTs e aceita fazer a alocação · esse alinhamento prévio é o que ativa o benefício de abatimento de INSS',
      },
      {
        icone: '📅',
        texto:
          'Monitore mensalmente se a alocação está sendo feita de fato · o benefício existe no sistema, mas só vale se a empresa terceira o executar corretamente todo mês',
      },
      {
        icone: '🏗️',
        texto:
          'Empreitada parcial permite escolher o melhor profissional para cada etapa sem ficar preso a uma construtora única · especialização técnica como vantagem adicional',
      },
      {
        icone: '📊',
        texto:
          'Se todos os fornecedores forem autônomos, você perde a oportunidade de abatimento · tente equilibrar CNPJs com CLTs e autônomos na estratégia de contratação',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Autônomos que não emitem nota exigem que o dono recolha o INSS diretamente · sem esse controle por etapa, o passivo se acumula e vira multa retroativa',
      },
      {
        icone: '🗓️',
        texto:
          'Não espere o início da etapa para combinar a alocação · se a empresa não confirmou antes de começar, o benefício pode não ser ativado nem retroativamente',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'trib-09-cl1',
        texto:
          'Listei todos os fornecedores que serão contratados e verifiquei o perfil jurídico de cada um (CNPJ, autônomo, MEI)',
      },
      {
        id: 'trib-09-cl2',
        texto:
          'Confirmei que o CNO já está aberto para receber as alocações dos fornecedores com CLT',
      },
      {
        id: 'trib-09-cl3',
        texto:
          'Negociei com cada empresa CNPJ a alocação de funcionários CLT na obra antes do início de cada etapa',
      },
      {
        id: 'trib-09-cl4',
        texto:
          'Estabeleci controle mensal para verificar se as alocações estão sendo realizadas no eSocial',
      },
      {
        id: 'trib-09-cl5',
        texto:
          'Registrei os autônomos sem CNPJ e configurei o recolhimento direto de INSS para cada um deles',
      },
      {
        id: 'trib-09-cl6',
        texto:
          'Calculei o abatimento de INSS esperado de cada fornecedor com alocação acordada para estimar a economia total',
      },
    ],
    metadados: [
      {
        campo: 'perfil_fornecedores_contratados',
        label: 'Perfil dos fornecedores contratados',
        tipo: 'select',
        opcoes: [
          'Todos são CNPJ com CLT · máxima otimização',
          'Mistura de CNPJs e autônomos',
          'Maioria autônomos · baixa otimização de INSS',
          'Ainda não defini os fornecedores',
        ],
      },
      {
        campo: 'alocacao_clt_negociada',
        label: 'Alocação de CLTs negociada com os fornecedores?',
        tipo: 'select',
        opcoes: [
          'Sim · combinado com todos antes do início',
          'Parcialmente · alguns fornecedores combinados',
          'Não · preciso retroceder e combinar',
          'Ainda não iniciei as etapas',
        ],
      },
      {
        campo: 'monitoramento_mensal_emp_parcial',
        label: 'Monitoramento mensal das alocações no eSocial?',
        tipo: 'select',
        opcoes: [
          'Sim · acompanho mensalmente',
          'Não tenho controle · preciso estruturar',
          'A empresa garante sem acompanhamento (risco)',
        ],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...TRIB_CONTENT_09)

const TRIB_CONTENT_10: TopicoContent[] = [
  {
    topicoId: 'trib-10',
    resumo: [
      'Contratar autônomos (caminho 3) torna o dono 100% responsável: CNO, eSocial, declarações e guias',
      'O custo inicial menor não conta a metade da história · o INSS que o dono recolhe está fora do orçamento',
      'A complexidade cresce: empreitada total (baixíssima), parcial (mediana) e autônomos (muito alta)',
      'Muitas construtoras e contabilidades não sabem fazer a alocação · o dono precisa cobrar e verificar',
      'Sem nota ou recibo de cada autônomo, o controle vai para a Receita Federal, não para o seu bolso',
      'Omissões de INSS podem bloquear venda do imóvel via financiamento bancário no futuro',
    ],
    dicasDeOuro: [
      {
        icone: '📄',
        texto:
          'Exija nota fiscal ou recibo de todo autônomo contratado · sem documento você perde o controle e a Receita presume que a mão de obra existiu e cobra com multa',
      },
      {
        icone: '🔢',
        texto:
          'No caminho dos autônomos, abra o CNO imediatamente e lance cada trabalhador no eSocial · é você que faz tudo, sem poder delegar para ninguém',
      },
      {
        icone: '🧮',
        texto:
          'Calcule o custo total real antes de optar por autônomos: preço do serviço + INSS a recolher · o "mais barato" pode virar o mais caro quando somado ao risco fiscal',
      },
      {
        icone: '👥',
        texto:
          'Se a construtora diz que cuida da alocação, peça confirmação mensal em papel · muitas não dominam esse processo e deixam o dono exposto ao passivo tributário',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Autônomo sem nota ou recibo transforma o dono em devedor de INSS · a Receita presume que o serviço foi pago e cobra quem contratou, com multa por omissão de declaração',
      },
      {
        icone: '🚫',
        texto:
          'Omissões de INSS no caminho dos autônomos podem bloquear a venda via financiamento bancário · banco exige CND e imóvel com débito ativo é impedido de ser financiado',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'trib-10-cl1',
        texto:
          'Defini a modalidade de contratação para cada etapa e mapeei a responsabilidade fiscal de cada uma',
      },
      {
        id: 'trib-10-cl2',
        texto:
          'Para autônomos: abri o CNO e configurei o lançamento de cada trabalhador no eSocial desde o início',
      },
      {
        id: 'trib-10-cl3',
        texto: 'Coletei nota fiscal ou recibo assinado de todos os autônomos e MEIs contratados',
      },
      {
        id: 'trib-10-cl4',
        texto:
          'Calculei o custo total real de contratar autônomos (serviço + INSS a recolher) versus empreitada total',
      },
      {
        id: 'trib-10-cl5',
        texto:
          'Para empreitada parcial: exigi e verifiquei mensalmente a alocação dos funcionários CLT das empresas no meu CNO',
      },
      {
        id: 'trib-10-cl6',
        texto:
          'Estruturei o controle documental de cada modalidade para não perder o controle para a Receita Federal',
      },
    ],
    metadados: [
      {
        campo: 'autonomos_na_obra',
        label: 'Você tem autônomos ou MEIs contratados?',
        tipo: 'select',
        opcoes: [
          'Sim · assumindo 100% da responsabilidade fiscal',
          'Não · só empreitada com CNPJ',
          'Mistura de MEIs, autônomos e empresas',
          'Ainda não iniciei a contratação',
        ],
      },
      {
        campo: 'documentacao_autonomos_coletada',
        label: 'Documentação dos autônomos coletada?',
        tipo: 'select',
        opcoes: [
          'Sim · todos têm nota ou recibo assinado',
          'Parcialmente · alguns ainda sem documento',
          'Não · preciso regularizar com recibos retroativos',
          'Não se aplica · sem autônomos',
        ],
      },
      {
        campo: 'custo_inss_autonomos_calculado',
        label: 'Calculou o INSS sobre os autônomos contratados?',
        tipo: 'select',
        opcoes: [
          'Sim · calculei e estou recolhendo corretamente',
          'Não · contratei apenas pelo preço do serviço',
          'Em processo de cálculo retroativo',
        ],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...TRIB_CONTENT_10)

const TRIB_CONTENT_11: TopicoContent[] = [
  {
    topicoId: 'trib-11',
    resumo: [
      'A modalidade de contratação define o tipo de comprador que pode adquirir seu imóvel no futuro',
      'Caixa Econômica e outros bancos podem exigir que a obra seja feita por PJ do ramo civil',
      'Autônomos geram robustez documental baixa · bancos podem negar o financiamento ao seu comprador',
      'A pergunta certa não é qual mão de obra é mais barata, mas qual gera mais liberdade de venda',
      'Mais custos comprovados em nota fiscal = menor ganho de capital = menos GCAP na venda futura',
      'Contratação, INSS, CNO, notas e venda são engrenagens conectadas · uma falha mula todo o resto',
    ],
    dicasDeOuro: [
      {
        icone: '🏦',
        texto:
          'Se planeja vender o imóvel com financiamento, privilegie PJs do ramo civil · a robustez documental pode ser a diferença entre fechar o negócio e perder o comprador',
      },
      {
        icone: '📑',
        texto:
          'Notas fiscais comprovando o custo de construção servem a dois propósitos: desbloqueiam o financiamento do comprador E reduzem o GCAP na hora da venda',
      },
      {
        icone: '⚖️',
        texto:
          'Avalie cada contratação com 5 critérios: preço, segurança jurídica, regularização, praticidade na obra e potencial de financiamento futuro para o comprador',
      },
      {
        icone: '🔗',
        texto:
          'Encare a obra como uma cadeia: contratação → INSS → CNO → notas → regularização → venda · cada elo influencia o seguinte e uma falha contamina tudo',
      },
    ],
    atencao: [
      {
        icone: '🚧',
        texto:
          'Obra construída apenas com autônomos pode bloquear o financiamento bancário do seu futuro comprador · o comprador perfeito pode não conseguir crédito por causa da sua escolha de hoje',
      },
      {
        icone: '💸',
        texto:
          'Construir com autônomos reduz o custo comprovado, aumenta o GCAP e limita o universo de compradores · o "mais barato" na execução pode custar muito mais na venda',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'trib-11-cl1',
        texto:
          'Avaliei se planejo vender o imóvel e qual tipo de comprador desejo atrair (à vista, financiado por banco)',
      },
      {
        id: 'trib-11-cl2',
        texto:
          'Verifiquei se a modalidade de contratação escolhida atende os critérios de financiamento dos bancos principais',
      },
      {
        id: 'trib-11-cl3',
        texto:
          'Confirmei que o construtor principal tem CNPJ e ART de execução registrada como pessoa jurídica',
      },
      {
        id: 'trib-11-cl4',
        texto:
          'Coletei e organizei notas fiscais de materiais e serviços para comprovar o custo total de construção',
      },
      {
        id: 'trib-11-cl5',
        texto:
          'Calculei como o custo comprovado em notas afeta o GCAP estimado na venda futura do imóvel',
      },
      {
        id: 'trib-11-cl6',
        texto:
          'Reavaliou a modalidade de contratação com os 5 critérios: preço, juridico, regularização, praticidade e liquidez na venda',
      },
    ],
    metadados: [
      {
        campo: 'pretende_vender_imovel',
        label: 'Pretende vender o imóvel no futuro?',
        tipo: 'select',
        opcoes: [
          'Sim · planejo vender (investimento)',
          'Talvez · depende do cenário futuro',
          'Não · uso próprio / moradia',
        ],
      },
      {
        campo: 'modalidade_atende_financiamento_pj',
        label: 'Modalidade de contratação atende exigência de PJ?',
        tipo: 'select',
        opcoes: [
          'Sim · PJ com CNAE civil e ART de execução',
          'Parcialmente · mistura de PJ e autônomos',
          'Não · principalmente autônomos e CPFs',
          'Não sei · preciso verificar',
        ],
      },
      {
        campo: 'notas_custo_construcao_arquivadas',
        label: 'Notas fiscais do custo de construção arquivadas?',
        tipo: 'select',
        opcoes: [
          'Sim · organizadas e arquivadas',
          'Parcialmente · algumas faltando',
          'Não · preciso reconstituir o histórico',
          'Ainda construindo · guardando tudo',
        ],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...TRIB_CONTENT_11)

const TRIB_CONTENT_13: TopicoContent[] = [
  {
    topicoId: 'trib-13',
    resumo: [
      'Custo do imóvel para o IR não é tudo que você gastou · é tudo que você consegue provar com documento',
      'Filtro duplo da Receita: documentação hábil (nota ou recibo) + relação direta com o imóvel',
      'Pilar 1: materiais, mão de obra, projetos, engenheiros e reformas com comprovante entram no custo',
      'Pilar 2: ITBI, corretagem e juros do financiamento também entram · muita gente esquece desses',
      'Mobília removível não entra; móvel embutido que não sai sem estragar segue a regra do dano',
      'Manutenção simples não entra; investimento estrutural (novos cômodos, piso, telhado) entra',
    ],
    dicasDeOuro: [
      {
        icone: '🧾',
        texto:
          'Guarde nota fiscal de tudo que permanece no imóvel: material, mão de obra, projetos, ITBI, corretagem e juros de financiamento · cada comprovante reduz o GCAP na venda',
      },
      {
        icone: '🧲',
        texto:
          'Teste rápido para saber se entra no custo: "Consegue remover sem estragar?" · se sim, não entra; se não pode remover sem dano, pode entrar no custo declarado',
      },
      {
        icone: '📐',
        texto:
          'Reformas estruturais (novos cômodos, troca de piso, telhado) são investimentos · declare com documentação no IR para reduzir o ganho de capital na venda futura',
      },
      {
        icone: '🔎',
        texto:
          'Declarar sem documento é fácil, mas sustentar uma auditoria sem comprovante é impossível · só declare o que você consegue provar se a Receita Federal questionar',
      },
    ],
    atencao: [
      {
        icone: '💸',
        texto:
          'Quem não guarda notas tem custo declarado menor → lucro imobiliário maior → mais imposto · duas pessoas com gasto igual podem pagar GCAP completamente diferente',
      },
      {
        icone: '🚫',
        texto:
          'Lançar gastos sem documento no IR expõe a autuação · a Receita pode exigir comprovação de cada item declarado como custo do imóvel em caso de questionamento',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'trib-13-cl1',
        texto:
          'Listei todos os gastos da obra e categorizei cada um: entra no custo do imóvel ou não entra',
      },
      {
        id: 'trib-13-cl2',
        texto:
          'Coletei e arquivei notas fiscais de materiais, mão de obra, projetos de engenharia e arquitetura',
      },
      {
        id: 'trib-13-cl3',
        texto: 'Incluí ITBI, corretagem e juros do financiamento no custo declarado do imóvel',
      },
      {
        id: 'trib-13-cl4',
        texto:
          'Identifiquei gastos de infraestrutura e entorno que beneficiaram diretamente o imóvel (asfalto, pavimentação, etc.)',
      },
      {
        id: 'trib-13-cl5',
        texto:
          'Separei manutenções simples (não entram) de reformas estruturais (entram) na declaração de custo',
      },
      {
        id: 'trib-13-cl6',
        texto:
          'Verifiquei benfeitoras fixas e móveis embutidos que não podem ser removidos sem dano · incluídos no custo declarado',
      },
    ],
    metadados: [
      {
        campo: 'custo_total_declarado_imovel_rs',
        label: 'Custo total declarado do imóvel (R$)',
        tipo: 'number',
        placeholder: 'Ex: 450000 (soma de todos os custos com nota)',
      },
      {
        campo: 'itbi_corretagem_lancados',
        label: 'ITBI e corretagem incluídos no custo declarado?',
        tipo: 'select',
        opcoes: [
          'Sim · incluídos corretamente',
          'Não · esqueci de incluir',
          'Não paguei ITBI ou corretagem',
          'Ainda vou lançar',
        ],
      },
      {
        campo: 'reformas_estruturais_documentadas',
        label: 'Reformas estruturais documentadas com comprovante?',
        tipo: 'select',
        opcoes: [
          'Sim · todas com nota ou recibo',
          'Parcialmente · algumas sem comprovante',
          'Não · preciso reunir os documentos retroativamente',
        ],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...TRIB_CONTENT_13)

const TRIB_CONTENT_15: TopicoContent[] = [
  {
    topicoId: 'trib-15',
    resumo: [
      'Uma nota fiscal PJ reduz 3 impostos: IR/GCAP, INSS e ISS · é seu maior ativo de defesa patrimonial',
      'Nota integral: R$15k a mais hoje economizou R$23k de GCAP na venda · a diferença é real',
      'Recibo vale para a Receita Federal, mas não resolve o ISS da prefeitura · nota é inegociável',
      'Isenção de GCAP é restrita · nunca planeje dependendo dela como garantia da economia futura',
      'Inventário, divórcio e herança são eventos involuntários · o GCAP chega mesmo sem você vender',
      'Contabilidade contratada no momento zero da obra · não na hora de emitir o Habite-se',
    ],
    dicasDeOuro: [
      {
        icone: '📝',
        texto:
          'Exija 100% de nota fiscal de todas as empresas contratadas · a diferença de preço que elas cobram a mais é quase sempre menor do que o imposto extra que você paga na venda',
      },
      {
        icone: '🗃️',
        texto:
          'Autônomos e MEIs: guarde todos os recibos com rigor · eles valem para a Receita Federal e podem reduzir até 70% do INSS, mas não substituem nota fiscal para o ISS municipal',
      },
      {
        icone: '🔮',
        texto:
          'Inventário e divórcio podem antecipar o GCAP involuntariamente · não decida sobre notas pensando que "nunca vai vender"; seus herdeiros podem não ter essa escolha',
      },
      {
        icone: '📅',
        texto:
          'Contrate contabilidade antes do primeiro pagamento de mão de obra · cálculo retroativo e regularização após a obra são sempre mais caros do que planejamento desde o dia zero',
      },
    ],
    atencao: [
      {
        icone: '🏗️',
        texto:
          'Sem nota fiscal, o ISS fica por conta do contratante · o recibo não resolve com a prefeitura; a cobrança municipal chega mesmo que toda a parte federal esteja correta',
      },
      {
        icone: '💭',
        texto:
          '"Vou investir a economia de hoje" para cobrir o imposto maior depois levaria 5+ anos para empatar matematicamente · na maioria dos cenários, a nota integral sai mais barato',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'trib-15-cl1',
        texto: 'Exigi nota fiscal integral de todas as empreiteiras e PJs contratadas na obra',
      },
      {
        id: 'trib-15-cl2',
        texto:
          'Calculei a diferença entre nota parcial e integral e comparei com o GCAP futuro esperado na venda',
      },
      {
        id: 'trib-15-cl3',
        texto:
          'Organizei todos os recibos de autônomos e MEIs para eventual uso no abatimento de INSS',
      },
      {
        id: 'trib-15-cl4',
        texto:
          'Verifiquei se o ISS de cada serviço está coberto por nota fiscal (não apenas por recibo de autônomo)',
      },
      {
        id: 'trib-15-cl5',
        texto:
          'Consultei especialista sobre as regras de isenção de GCAP que se aplicam ao meu imóvel específico',
      },
      {
        id: 'trib-15-cl6',
        texto:
          'Contratei contabilidade desde o início da obra · antes do primeiro pagamento de mão de obra',
      },
    ],
    metadados: [
      {
        campo: 'notas_integrais_exigidas',
        label: 'Exigiu nota fiscal integral de todos os PJs?',
        tipo: 'select',
        opcoes: [
          'Sim · nota integral em todos os contratos PJ',
          'Parcialmente · algumas notas parciais aceitas',
          'Não · aceitei notas parciais ou sem nota',
          'Ainda estou negociando com os prestadores',
        ],
      },
      {
        campo: 'custo_obra_comprovado_nota_rs',
        label: 'Custo total da obra comprovado por nota (R$)',
        tipo: 'number',
        placeholder: 'Ex: 303000 (soma de todas as notas fiscais)',
      },
      {
        campo: 'contabilidade_contratada_momento',
        label: 'Quando a contabilidade foi contratada?',
        tipo: 'select',
        opcoes: [
          'Antes da obra · momento zero',
          'Durante a obra · em andamento',
          'Após a obra · regularização retroativa',
          'Ainda sem contabilidade contratada',
        ],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...TRIB_CONTENT_15)

const TRIB_CONTENT_16: TopicoContent[] = [
  {
    topicoId: 'trib-16',
    resumo: [
      'Áreas complementares têm peso diferente no INSS · a Receita permite redução de 50% a 75%',
      'Garagem não integrada, piscina e quadra poliesportiva podem ser classificadas como complementar',
      'A redução de área complementar precisa estar no projeto e no Alvará · o dono não decide sozinho',
      'Piscina coberta tem redução menor; descoberta tem redução maior · a estrutura define o percentual',
      'Obra sem separação de áreas paga INSS como se tudo fosse área principal · custo desnecessário',
      'A economia aqui não é em negociar preço, mas em classificar a obra corretamente desde o projeto',
    ],
    dicasDeOuro: [
      {
        icone: '📐',
        texto:
          'Inclua a separação de áreas complementares (garagem, piscina, quadra) no projeto antes de submeter ao Alvará · corrigir depois exige reaprovação e documentação adicional',
      },
      {
        icone: '🏊',
        texto:
          'Se planeja piscina, considere deixá-la descoberta · a estrutura mais simples gera redução maior do INSS e impacta diretamente a base de cálculo tributário',
      },
      {
        icone: '🔍',
        texto:
          'Peça ao contador tributário para analisar o projeto antes da aprovação municipal · o enquadramento correto de áreas pode reduzir o INSS em dezenas de milhares de reais',
      },
    ],
    atencao: [
      {
        icone: '❌',
        texto:
          'Classificar área como complementar por conta própria sem documentação no projeto e Alvará é risco de autuação · a Receita Federal verifica antes de aceitar qualquer redução',
      },
      {
        icone: '⚠️',
        texto:
          'Obra construída sem análise das áreas complementares paga INSS como se toda a metragem fosse área principal · imposto desnecessário que quase ninguém percebe na execução',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'trib-16-cl1',
        texto:
          'Identifiquei todas as áreas do projeto que podem ser classificadas como complementares (garagem, piscina, quadra)',
      },
      {
        id: 'trib-16-cl2',
        texto:
          'Confirmei que a separação das áreas complementares está formalmente registrada no projeto arquitetônico',
      },
      {
        id: 'trib-16-cl3',
        texto:
          'Verifiquei que o Alvará e a documentação refletem a correta caracterização das áreas (principal + complementar)',
      },
      {
        id: 'trib-16-cl4',
        texto:
          'Consultei contador tributário para calcular o percentual de redução aplicável a cada área complementar',
      },
      {
        id: 'trib-16-cl5',
        texto:
          'Para piscina: defini coberta ou descoberta com ciência do impacto no percentual de redução do INSS',
      },
      {
        id: 'trib-16-cl6',
        texto:
          'Confirmei que o CNO foi aberto com as áreas discriminadas corretamente (área principal + áreas complementares)',
      },
    ],
    metadados: [
      {
        campo: 'tipo_areas_complementares',
        label: 'Quais áreas complementares existem na obra?',
        tipo: 'select',
        opcoes: [
          'Garagem não integrada',
          'Piscina descoberta',
          'Piscina coberta',
          'Quadra poliesportiva',
          'Mais de um tipo',
          'Não tenho áreas complementares',
        ],
      },
      {
        campo: 'complementares_no_projeto_alvara',
        label: 'Áreas complementares no projeto e Alvará?',
        tipo: 'select',
        opcoes: [
          'Sim · formalmente separadas',
          'Não · ainda não discriminado',
          'Em análise com arquiteto e contador',
          'Não se aplica',
        ],
      },
      {
        campo: 'reducao_inss_complementar_perc',
        label: 'Percentual de redução de INSS nas áreas complementares (%)',
        tipo: 'number',
        placeholder: 'Ex: 50 (garagem) ou 75 (área simplificada)',
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...TRIB_CONTENT_16)

const TRIB_CONTENT_17: TopicoContent[] = [
  {
    topicoId: 'trib-17',
    resumo: [
      'Pré-fabricados e pré-moldados externos reduzem a estimativa de mão de obra e o INSS calculado',
      'Para valer, precisa de nota separada (material + mão de obra de implementação) e projeto indicando o sistema',
      'Vigas e pilares pré-moldados na estrutura externa são os itens elegíveis para a redução de INSS',
      'Laje pré-moldada interna não conta para redução · apenas estrutura externa com nota correta vale',
      'Pré-moldados externos podem reclassificar a obra de "alvenaria" para "mista" · INSS menor em toda a base',
      'A economia não está em comprar pré-moldado · está em documentar projeto e nota corretamente',
    ],
    dicasDeOuro: [
      {
        icone: '📋',
        texto:
          'Exija ao fornecedor nota fiscal com material e mão de obra separados · nota genérica com valor único não comprova a redução e pode ser rejeitada pela Receita Federal',
      },
      {
        icone: '📐',
        texto:
          'Coloque no projeto o uso de vigas e pilares pré-moldados externos · sem o projeto indicando o sistema, a nota de material não prova que o item foi efetivamente usado na obra',
      },
      {
        icone: '🔄',
        texto:
          'A reclassificação de "alvenaria" para "mista" é um benefício secundário automático · impacta toda a base de cálculo do INSS, não só a parcela pré-fabricada',
      },
      {
        icone: '🏗️',
        texto:
          'Antes de comprar pré-moldados como estratégia fiscal, confirme com o contador que projeto, execução e documentação estão alinhados · o benefício exige as 3 peças simultaneamente',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Ter a nota de material sem a nota de mão de obra de implementação não prova uso na obra · a Receita pode interpretar como revenda e rejeitar toda a redução de INSS',
      },
      {
        icone: '🚫',
        texto:
          'Laje pré-moldada interna não gera o benefício fiscal de redução de INSS · apenas vigas e pilares na estrutura externa são elegíveis para o abatimento',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'trib-17-cl1',
        texto:
          'Identifiquei se o projeto prevê uso de vigas e pilares pré-moldados na estrutura externa da obra',
      },
      {
        id: 'trib-17-cl2',
        texto:
          'Alinhei com o fornecedor a emissão de nota fiscal separando material e mão de obra de implementação',
      },
      {
        id: 'trib-17-cl3',
        texto:
          'Confirmei com o contador que projeto + notas estão coerentes para viabilizar a redução de INSS',
      },
      {
        id: 'trib-17-cl4',
        texto:
          'Verifiquei a reclassificação da obra para "mista" após inclusão dos pré-moldados externos no projeto',
      },
      {
        id: 'trib-17-cl5',
        texto:
          'Descartei a laje pré-moldada interna como estratégia de redução de INSS · ela não é elegível',
      },
      {
        id: 'trib-17-cl6',
        texto:
          'Documentei a sequência estratégica: projeto → compra → execução → nota separada (material + mão de obra)',
      },
    ],
    metadados: [
      {
        campo: 'usa_premoldados_externos',
        label: 'Usa vigas/pilares pré-moldados externos?',
        tipo: 'select',
        opcoes: [
          'Sim · incluídos no projeto e na execução',
          'Não · alvenaria convencional',
          'Em análise com contador e arquiteto',
          'Não se aplica ao meu projeto',
        ],
      },
      {
        campo: 'nota_separada_material_mdo',
        label: 'Nota fiscal com material e mão de obra separados?',
        tipo: 'select',
        opcoes: [
          'Sim · exigi a separação no ato de emissão',
          'Não · nota genérica com valor único (risco)',
          'Ainda não negociei com o fornecedor',
        ],
      },
      {
        campo: 'classificacao_obra_cno',
        label: 'Classificação da obra no CNO',
        tipo: 'select',
        opcoes: [
          'Mista (pré-moldados externos presentes)',
          'Alvenaria convencional',
          'Ainda não classificada / verificar com contador',
        ],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...TRIB_CONTENT_17)

const TRIB_CONTENT_19: TopicoContent[] = [
  {
    topicoId: 'trib-19',
    resumo: [
      'Obra pronta ainda tem chance: alocação retroativa no eSocial reduz INSS mesmo após a conclusão',
      'Regularizar antes da cartinha da Receita garante o máximo de economia · proativo é mais barato',
      'INSS estimado pela Receita: 36,8%; com alocação retroativa comprovada de autônomos: apenas 20%',
      'Mesmo com multas, juros e honorários contábeis, a regularização compensa em 99,9% dos casos',
      'Recibo retroativo precisa de modelo específico com dados cadastrais · papel genérico não serve',
      'Quanto antes você agir, menor é o total de multas e juros acumulados sobre o INSS atrasado',
    ],
    dicasDeOuro: [
      {
        icone: '⚡',
        texto:
          'Não espere a cartinha da Receita para regularizar · cada mês de atraso acumula multa sobre o INSS; regularização proativa reduz o total a pagar e o nível de estresse',
      },
      {
        icone: '📃',
        texto:
          'Para recibos retroativos de autônomos, use o modelo específico com dados cadastrais completos e datas dentro do prazo de obra · recibo genérico ou informal não é aceito pela Receita',
      },
      {
        icone: '🤝',
        texto:
          'Contate construtoras e empresas da obra para solicitar a alocação retroativa · mesmo se houver custo extra, o delta de economia entre 36,8% e 20% justifica na maioria dos casos',
      },
      {
        icone: '🧮',
        texto:
          'Faça o cálculo antes de decidir: INSS estimado × 36,8% vs alocação comprovada × 20% · em 99,9% dos casos o esforço de regularização compensa o total de multas e honorários',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'O mito dos 5 anos para obras pós-2021 é falso · a Receita já sabe desde o Alvará e a dívida não caduca; esperar só aumenta o total acumulado de multas e juros',
      },
      {
        icone: '🗓️',
        texto:
          'Valores e datas dos recibos retroativos precisam ser coerentes com o período de execução da obra · inconsistências são rejeitadas e podem configurar irregularidade fiscal',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'trib-19-cl1',
        texto:
          'Decidi regularizar a obra proativamente antes de qualquer notificação da Receita Federal',
      },
      {
        id: 'trib-19-cl2',
        texto:
          'Calculei o INSS estimado pela Receita (36,8%) versus com alocação comprovada (~20%) para estimar a economia potencial',
      },
      {
        id: 'trib-19-cl3',
        texto:
          'Contactei a construtora ou empreiteiras para solicitar a alocação retroativa dos funcionários no eSocial',
      },
      {
        id: 'trib-19-cl4',
        texto:
          'Levantei os recibos dos autônomos e MEIs contratados e identifiquei quais precisam de recibo retroativo com modelo correto',
      },
      {
        id: 'trib-19-cl5',
        texto:
          'Confirmei que valores e datas dos recibos retroativos são coerentes com o período de execução registrado no Alvará',
      },
      {
        id: 'trib-19-cl6',
        texto:
          'Contratei contador especializado em INSS de obras para conduzir a regularização retroativa com segurança',
      },
    ],
    metadados: [
      {
        campo: 'status_regularizacao_retroativa',
        label: 'Status da regularização retroativa da obra',
        tipo: 'select',
        opcoes: [
          'Já iniciei a regularização retroativa',
          'Planejando iniciar · aguardando orçamento',
          'Recebi a cartinha · urgente',
          'Obra recém concluída · atuando proativamente',
          'Ainda não decidi',
        ],
      },
      {
        campo: 'inss_estimado_vs_comprovado_status',
        label: 'Calculou o delta 36,8% vs 20% de INSS?',
        tipo: 'select',
        opcoes: [
          'Sim · calculei e a regularização compensa',
          'Ainda não calculei o delta',
          'Em cálculo com o contador especializado',
        ],
      },
      {
        campo: 'recibos_autonomos_levantados',
        label: 'Recibos retroativos dos autônomos levantados?',
        tipo: 'select',
        opcoes: [
          'Sim · todos com modelo correto e dados cadastrais',
          'Parcialmente · alguns ainda sem recibo',
          'Não · preciso contatar autônomos retroativamente',
          'Não se aplica · usei só empreitada com CNPJ',
        ],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...TRIB_CONTENT_19)

const TRIB_CONTENT_20: TopicoContent[] = [
  {
    topicoId: 'trib-20',
    resumo: [
      'Obras finalizadas há mais de 5 anos podem ter isenção total de INSS pela regra da decadência',
      'A isenção é proporcional: se só o início é decadente, apenas esse período fica isento',
      'A regra dos 5 anos só funciona em silêncio absoluto · se a cartinha chegou, ela não se aplica',
      'A decadência não é presumida · precisa ser comprovada com no mínimo 3 documentos históricos',
      'Documentos válidos: Alvará antigo, conta de luz/água da época e notas de material de fundação',
      'IPTU com área construída ou planta aerofotogramétrica online provam o término da obra',
    ],
    dicasDeOuro: [
      {
        icone: '🗺️',
        texto:
          'Obtenha a planta aerofotogramétrica gratuitamente online · ela é um dos documentos mais fortes para provar o término e a antiguidade da construção sem custo',
      },
      {
        icone: '📂',
        texto:
          'Guarde agora qualquer documento da época da obra (Alvará, contas de consumo, notas de material) · são eles que provam a decadência e podem eliminar o INSS anos depois',
      },
      {
        icone: '👁️',
        texto:
          'Monitore o e-CAC regularmente por 5 anos após a regularização · se a Receita intimar dentro desse prazo, você precisa responder no prazo ou as multas se tornam altíssimas',
      },
      {
        icone: '⚡',
        texto:
          'Se a intimação já chegou, não espere nenhum momento · a cartinha tem prazo e o descumprimento gera multas severas; consulte contador especializado imediatamente',
      },
    ],
    atencao: [
      {
        icone: '🚨',
        texto:
          'A regra dos 5 anos exige silêncio absoluto da Receita · uma intimação já recebida elimina o benefício da decadência, independentemente da antiguidade da construção',
      },
      {
        icone: '📋',
        texto:
          'Sem documentação histórica robusta a Receita pode rejeitar a decadência · prove com pelo menos 3 documentos distintos cobrindo início e término da obra',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'trib-20-cl1',
        texto:
          'Calculei quantos anos atrás a obra foi iniciada e finalizada para avaliar o enquadramento na regra dos 5 anos',
      },
      {
        id: 'trib-20-cl2',
        texto:
          'Verifiquei no e-CAC se já recebi alguma intimação ou cartinha da Receita Federal que eliminaria o benefício',
      },
      {
        id: 'trib-20-cl3',
        texto: 'Levantei o Alvará original da época da construção como prova do início da obra',
      },
      {
        id: 'trib-20-cl4',
        texto:
          'Localizei contas antigas de água, luz ou telefone do endereço da obra na época da construção',
      },
      {
        id: 'trib-20-cl5',
        texto:
          'Obtive a planta aerofotogramétrica online e/ou o histórico de cobranças de IPTU com área construída registrada',
      },
      {
        id: 'trib-20-cl6',
        texto:
          'Consultei contador especializado para conduzir o processo de comprovação da decadência com a Receita Federal',
      },
    ],
    metadados: [
      {
        campo: 'anos_desde_conclusao_obra',
        label: 'Anos desde a conclusão da obra',
        tipo: 'number',
        placeholder: 'Ex: 8 (anos desde que a obra foi concluída)',
      },
      {
        campo: 'cartinha_receita_recebida_trib20',
        label: 'Já recebeu intimação ou cartinha da Receita?',
        tipo: 'select',
        opcoes: [
          'Não · silêncio absoluto (regra se aplica)',
          'Sim · intimação recebida (regra não se aplica)',
          'Não sei · preciso verificar no e-CAC urgente',
        ],
      },
      {
        campo: 'documentos_antiguidade_levantados',
        label: 'Documentos históricos da obra levantados?',
        tipo: 'select',
        opcoes: [
          'Sim · Alvará + conta de consumo + IPTU/aerofoto',
          'Parcialmente · alguns documentos levantados',
          'Não · preciso levantar urgente',
          'Não se aplica · obra recente',
        ],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...TRIB_CONTENT_20)

const TRIB_CONTENT_21: TopicoContent[] = [
  {
    topicoId: 'trib-21',
    resumo: [
      'A Receita escala em 3 etapas: aviso (amigável) → intimação (multa 70–225%) → penalidade aplicada',
      'Aviso ignorado converte em intimação com multas de 70% a 225% sobre o valor de INSS devido',
      'Regularizar sozinho paga a estimativa máxima da Receita; especialista reduz para o mínimo legal',
      'A Receita não presume inocência · mesmo sem ter construído, você precisa responder ao aviso',
      'Alvará sem obra ou cancelado pode gerar cobrança indevida · mas ainda precisa de resposta formal',
      'Plano de ação: acionar especialista imediatamente e montar dosê de defesa dentro do prazo fatal',
    ],
    dicasDeOuro: [
      {
        icone: '🚨',
        texto:
          'Ao receber qualquer aviso da Receita, acione especialista imediatamente · o prazo de 20–34 dias é fatal e aviso ignorado vira intimação com multa de até 225%',
      },
      {
        icone: '📊',
        texto:
          'Nunca regularize sozinho pelo caminho sugerido pela Receita · ela aplica estimativa genérica máxima; especialista usa a base real da obra e reduz para o mínimo legal',
      },
      {
        icone: '🔍',
        texto:
          'Verifique se a cobrança é indevida antes de pagar · Alvará não utilizado, obra cancelada ou responsabilidade de outra empresa são casos onde você não deve nada mas precisa provar',
      },
      {
        icone: '📅',
        texto:
          'Prevenir é muito mais barato que remediar · quem estrutura as 3 camadas corretamente desde o início tem chances muito menores de receber o aviso da equipe Eobra',
      },
    ],
    atencao: [
      {
        icone: '💥',
        texto:
          'Aviso ignorado converte em intimação com multa de 70% a 225% · o sistema da Receita não aguarda voluntariamente, ele escalona automaticamente dentro do prazo estipulado',
      },
      {
        icone: '🔕',
        texto:
          'O sistema da Receita não cruza automaticamente com cancelamentos da prefeitura · mesmo que o Alvará tenha sido cancelado, a cobrança chega e exige resposta formal; silêncio = dívida assumida',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'trib-21-cl1',
        texto:
          'Monitoro o e-CAC regularmente para identificar qualquer aviso antes que vire intimação com prazo fatal',
      },
      {
        id: 'trib-21-cl2',
        texto:
          'Caso recebi aviso: anotei o prazo exato e acionei especialista no mesmo dia de recebimento',
      },
      {
        id: 'trib-21-cl3',
        texto:
          'Verifiquei se a cobrança é devida · confirmo que o Alvará foi utilizado e a obra foi executada',
      },
      {
        id: 'trib-21-cl4',
        texto:
          'Montei o dosê de defesa com toda a documentação da obra para responder ao aviso formalmente',
      },
      {
        id: 'trib-21-cl5',
        texto:
          'Avaliei se meu caso se enquadra em isenção: decadência, Alvará não utilizado ou responsabilidade de terceiro',
      },
      {
        id: 'trib-21-cl6',
        texto:
          'Não tentei regularizar sozinho · uso especialista para garantir base de cálculo real e não a estimativa genérica',
      },
    ],
    metadados: [
      {
        campo: 'status_aviso_receita_eobra',
        label: 'Situação atual com a Receita Federal',
        tipo: 'select',
        opcoes: [
          'Nunca recebi aviso · prevenção ativa',
          'Recebi aviso · acionando especialista',
          'Recebi intimação · urgente',
          'Recebi cobrança indevida · montando defesa',
          'Regularização em curso',
        ],
      },
      {
        campo: 'prazo_resposta_aviso_dias',
        label: 'Prazo para resposta ao aviso (dias)',
        tipo: 'number',
        placeholder: 'Ex: 30 (dias para cumprir o prazo da Receita)',
      },
      {
        campo: 'especialista_inss_acionado',
        label: 'Especialista em INSS de obras acionado?',
        tipo: 'select',
        opcoes: [
          'Sim · especialista contratado e atuando',
          'Não · ainda sem especialista (risco)',
          'Em processo de contratação',
          'Tentei regularizar sozinho (risco alto)',
        ],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...TRIB_CONTENT_21)

// ── Sistemas Construtivos (RFC-08B) ──────────────────────────────
const SC_CONTENT: TopicoContent[] = [
  {
    topicoId: 'sc-01',
    resumo: [
      'O sistema construtivo deve ser definido na fase 2 do ciclo · entre terreno e projeto · para que o projeto nasça compatível com o sistema',
      'Pular essa etapa faz o projeto nascer intuitivamente para alvenaria convencional, sem que o arquiteto perceba',
      'O terreno já sugere o sistema: lote plano favorece estrutura sobre radier; declive acentuado aponta para estrutura metálica',
      'Adaptar um projeto de um sistema para outro gera retrabalho e custo extra que não tem como recuperar',
      'Cada sistema tem módulos e perfis específicos · o projeto precisa casar com essas medidas para evitar desperdício',
      'Forçar adaptação pode tornar o sistema alternativo mais caro do que o original, como acontece em obras reais de grande porte',
    ],
    dicasDeOuro: [
      {
        icone: '📐',
        texto:
          'Defina o sistema antes de contratar o arquiteto · assim o projeto já nasce com as medidas certas para o sistema',
      },
      {
        icone: '🏔️',
        texto:
          'Em lotes com declive acentuado, estrutura metálica pode ser a opção mais eficiente e econômica · avalie antes do projeto',
      },
      {
        icone: '📏',
        texto:
          'Cada sistema tem largura de parede diferente: 14cm (convencional), menor (Steel Frame), maior (ICF) · isso impacta a área útil real',
      },
      {
        icone: '💬',
        texto:
          'Comunique o sistema escolhido ao projetista como premissa · não deixe essa decisão implícita',
      },
    ],
    atencao: [
      {
        icone: '🚫',
        texto:
          'Projetar antes de definir o sistema é um atalho que custa caro: o projeto genérico não aproveita os benefícios do sistema escolhido',
      },
      {
        icone: '💸',
        texto:
          'Forçar um projeto de alvenaria convencional para alvenaria estrutural pode deixar a obra mais cara do que teria sido no sistema original',
      },
      {
        icone: '⚠️',
        texto:
          'Steel Frame e ICF têm formas de tamanhos fixos · paredes fora do módulo geram gambiarras e perda de dinheiro',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'sc01-cl1',
        texto:
          'Revisei as conclusões do terreno e identifiquei os sistemas construtivos compatíveis com o lote',
      },
      {
        id: 'sc01-cl2',
        texto:
          'Pesquisei disponibilidade de mão de obra especializada para os sistemas candidatos na minha região',
      },
      {
        id: 'sc01-cl3',
        texto: 'Defini o sistema construtivo antes de iniciar qualquer conversa com o arquiteto',
      },
      {
        id: 'sc01-cl4',
        texto: 'Comuniquei o sistema escolhido ao projetista como premissa inegociável de projeto',
      },
      {
        id: 'sc01-cl5',
        texto: 'Avaliei se alguma restrição do terreno elimina sistemas da lista de candidatos',
      },
    ],
    metadados: [
      {
        campo: 'sistema_candidato',
        label: 'Sistema construtivo candidato',
        tipo: 'select',
        opcoes: [
          'Alvenaria Convencional',
          'Alvenaria Estrutural',
          'Steel Frame',
          'Estrutura Metálica',
          'ICF',
          'Tijolo Ecológico',
          'Híbrido',
        ],
      },
      {
        campo: 'motivo_escolha_sistema',
        label: 'Principal motivo da escolha',
        tipo: 'textarea',
        placeholder: 'Ex: Terreno plano favorece radier; mão de obra disponível na cidade',
      },
      {
        campo: 'disponibilidade_mdo_sistema',
        label: 'Mão de obra especializada disponível',
        tipo: 'select',
        opcoes: ['Confirmada', 'Em pesquisa', 'Não disponível na região'],
      },
    ],
    temFerramenta: false,
  },
  {
    topicoId: 'sc-02',
    resumo: [
      'O mapa de escolha de sistemas construtivos orienta a decisão com base em prazo, custo, região e disponibilidade de mão de obra',
      'Nenhum sistema é universalmente melhor · a escolha certa depende do contexto da sua obra',
      'Os 6 sistemas mais usados no Brasil são: Alvenaria Convencional, Alvenaria Estrutural, Steel Frame, Estrutura Metálica, ICF e Tijolo Ecológico',
      'Use o seletor abaixo para encontrar o sistema ideal para o seu perfil',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto:
          'Valide a disponibilidade de mão de obra especializada na sua cidade antes de definir o sistema',
      },
      {
        icone: '💡',
        texto: 'Steel Frame e ICF são mais rápidos, mas exigem equipes treinadas · pesquise antes',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Mudar de sistema no meio da obra gera retrabalho e custo elevado · decida antes da fundação',
      },
      {
        icone: '⚠️',
        texto:
          'Sistemas industrializados têm prazo de entrega de materiais · planeje com antecedência',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'sc02-cl1',
        texto: 'Avaliei a disponibilidade de mão de obra especializada na minha região',
      },
      { id: 'sc02-cl2', texto: 'Pesquisei fornecedores dos materiais do sistema escolhido' },
      {
        id: 'sc02-cl3',
        texto: 'Confirmei o sistema escolhido com o engenheiro responsável pela obra',
      },
    ],
    metadados: [
      {
        campo: 'sistema_escolhido',
        label: 'Sistema construtivo definido',
        tipo: 'select',
        opcoes: [
          'Alvenaria Convencional',
          'Alvenaria Estrutural',
          'Steel Frame',
          'Estrutura Metálica',
          'ICF',
          'Tijolo Ecológico',
        ],
      },
      {
        campo: 'justificativa_sistema',
        label: 'Motivo da escolha',
        tipo: 'textarea',
        placeholder: 'Por que este sistema?',
      },
    ],
    temFerramenta: true,
  },
  {
    topicoId: 'sc-03',
    resumo: [
      'Sistema tradicional = alvenaria de tijolo + estrutura de concreto · o modelo dominante no Brasil há décadas',
      'Custo de molde: formas de madeira e escoramento somam 30–90 mil reais em obras medianas e são inteiramente descartados',
      'Alvenaria artesanal: tijolo por tijolo, dependente da qualidade e disposição do pedreiro naquele dia',
      'Reboco em colherada é sujeito a trincas, bolhas e desaprumo · cada etapa artesanal multiplica os pontos de falha',
      'Para passar tubulação elétrica e hidráulica, a parede acabada precisa ser quebrada, gerando entulho e retrabalho',
      'Vantagens: liberdade arquitetônica total, bom desempenho térmico e acústico, adaptável durante a obra e zero barreira cultural para venda',
    ],
    dicasDeOuro: [
      {
        icone: '🏛️',
        texto:
          'Prefira o sistema tradicional para projetos com geometria complexa, grandes vãos ou balanços · sistemas alternativos têm limitações que o tradicional não tem',
      },
      {
        icone: '🔧',
        texto:
          'No sistema tradicional é fácil adaptar a obra: nichos, tomadas, paredes e instalações mudam sem reconstruir tudo',
      },
      {
        icone: '🏠',
        texto:
          'Para imóvel destinado à venda, o sistema convencional elimina barreira cultural · compradores não questionam o que não conhecem',
      },
      {
        icone: '📋',
        texto:
          'Controle rigoroso do carpinteiro de formas e do responsável pelo reboco é onde você mais recupera eficiência no sistema tradicional',
      },
    ],
    atencao: [
      {
        icone: '💸',
        texto:
          'Formas de madeira e escoramento somam até 90 mil reais em obras grandes e saem da obra como entulho · inclua esse custo no orçamento',
      },
      {
        icone: '📐',
        texto:
          'Alvenaria artesanal feita num dia ruim gera paredes fora de prumo que exigem reboco extra · supervisão constante é indispensável',
      },
      {
        icone: '🔨',
        texto:
          'Quebrar paredes para instalar tubulações gera entulho, custo extra de pedreiro e pode fragilizar a estrutura se mal executado',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'sc03-cl1',
        texto:
          'Avaliei se o projeto exige geometria complexa, balanços ou grandes vãos que justificam o sistema tradicional',
      },
      {
        id: 'sc03-cl2',
        texto: 'Incluí no orçamento o custo de formas, escoramento e descarte de entulho',
      },
      {
        id: 'sc03-cl3',
        texto:
          'Confirmei disponibilidade de carpinteiro de formas qualificado para a estrutura de concreto',
      },
      {
        id: 'sc03-cl4',
        texto:
          'Planejei a passagem de instalações antes de levantar as paredes para reduzir quebras',
      },
      {
        id: 'sc03-cl5',
        texto:
          'Defini cronograma considerando o tempo artesanal de alvenaria e reboco (mais lento que sistemas industrializados)',
      },
    ],
    metadados: [
      {
        campo: 'decisao_sistema_tradicional',
        label: 'Sistema tradicional selecionado',
        tipo: 'select',
        opcoes: [
          'Sim · é o sistema escolhido',
          'Não · avaliando alternativas',
          'Em comparação com outros',
        ],
      },
      {
        campo: 'custo_estimado_formas_escora',
        label: 'Orçamento estimado de formas e escoramento (R$)',
        tipo: 'number',
        placeholder: 'Ex: 40000',
      },
      {
        campo: 'complexidade_arquitetonica',
        label: 'Complexidade arquitetônica do projeto',
        tipo: 'select',
        opcoes: [
          'Simples · poucos vãos e geometria regular',
          'Moderada',
          'Complexa · balanços, vãos grandes ou geometria livre',
        ],
      },
    ],
    temFerramenta: false,
  },
  {
    topicoId: 'sc-04',
    resumo: [
      'Estrutura metálica pesada usa perfis robustos · não confunda com Steel Frame, que é metal leve e funciona de forma diferente',
      'Não é ferramenta de economia: seu papel é viabilizar arquiteturas ousadas com balanços e grandes vãos sem colunas',
      'Perfis metálicos representam 10–12% do orçamento total · o item mais caro do sistema e o que mais pesa na decisão',
      'O projeto deve usar medidas múltiplas de 6m (3, 6, 9, 12) · medidas "quebradas" geram corte e descarte de perfis caríssimos',
      'Cronograma paralelo: compra e beneficiamento dos perfis ocorrem fora da obra enquanto a fundação avança · esqueleto montado em 15 dias',
      'Estrutura aparente (estilo industrial) elimina reboco e pintura, acelerando a obra e reduzindo custo ao mesmo tempo',
    ],
    dicasDeOuro: [
      {
        icone: '📐',
        texto:
          'Dimensione os ambientes em múltiplos de 6m antes de definir os perfis · medidas quebradas geram corte e desperdício do material mais caro da obra',
      },
      {
        icone: '⚡',
        texto:
          'Inicie compra e beneficiamento dos perfis em paralelo com a fundação · isso encurta o prazo total sem paralisar a obra',
      },
      {
        icone: '🏭',
        texto:
          'Deixar a estrutura metálica aparente é uma das formas mais inteligentes de cortar custo: elimina chapisco, reboco e pintura de uma vez',
      },
      {
        icone: '🔩',
        texto:
          'Compre perfis de fornecedores distantes se o preço compensar · o frete não inviabiliza a economia em lotes grandes',
      },
    ],
    atencao: [
      {
        icone: '🌡️',
        texto:
          'A junta entre metal e alvenaria é ponto crítico de fissuração: expansão térmica diferente exige tratamento obrigatório com junta flexível',
      },
      {
        icone: '📍',
        texto:
          'A locação dos pilares na fundação exige precisão milimétrica · erro aqui impede o encaixe da estrutura quando ela chega do fabricante',
      },
      {
        icone: '🔧',
        texto:
          'Estrutura metálica dificulta passagem de tubulações · planeje shafts e caminhos verticais antes de fechar qualquer parede',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'sc04-cl1',
        texto:
          'Confirmei que o projeto tem balanços ou grandes vãos que justificam a estrutura metálica pesada',
      },
      {
        id: 'sc04-cl2',
        texto:
          'Defini os módulos do projeto em múltiplos de 6m para minimizar desperdício de perfis',
      },
      {
        id: 'sc04-cl3',
        texto:
          'Planejei cronograma paralelo: compra e beneficiamento dos perfis enquanto a fundação é executada',
      },
      {
        id: 'sc04-cl4',
        texto: 'Defini a rota de todas as tubulações (shafts verticais) antes de fechar as paredes',
      },
      {
        id: 'sc04-cl5',
        texto:
          'Especifiquei tratamento de junta flexível em todos os pontos de contato metal-alvenaria',
      },
    ],
    metadados: [
      {
        campo: 'maior_vao_metalico_m',
        label: 'Maior vão livre projetado (m)',
        tipo: 'number',
        placeholder: 'Ex: 9',
      },
      {
        campo: 'custo_estimado_perfis_rs',
        label: 'Orçamento estimado dos perfis metálicos (R$)',
        tipo: 'number',
        placeholder: 'Ex: 120000',
      },
      {
        campo: 'perfis_aparentes',
        label: 'Estrutura será aparente (estilo industrial)',
        tipo: 'select',
        opcoes: ['Sim · estrutura aparente', 'Não · será revestida', 'Parcialmente aparente'],
      },
    ],
    temFerramenta: false,
  },
  {
    topicoId: 'sc-05',
    resumo: [
      'Steel Frame = metal leve + placas resistentes · não confunda com estrutura metálica pesada: são sistemas completamente diferentes',
      'Da fundação ao ponto de acabamento em 60 dias · o sistema mais rápido disponível no mercado hoje',
      'Paredes são fabricadas em painéis 2D num galpão e chegam prontas para montar · chuva e clima não afetam a produção',
      'Um contrato cobre estrutura, vedação, cobertura e forro · elimina reboco, tijolo e escoramento do orçamento de uma vez',
      'Instalações passam entre as placas antes do fechamento final · eletricistas e hidráulicos têm uma janela curta e concentrada',
      'Reformas futuras são simples: demolir uma parede é só desparafusar, sem marretada, sem entulho',
    ],
    dicasDeOuro: [
      {
        icone: '⏱️',
        texto:
          'Obra rápida significa desembolso acelerado: o que iria em 18 meses sai em 6 · organize o fluxo de caixa antes de começar',
      },
      {
        icone: '📐',
        texto:
          'Steel Frame exige projeto detalhado e praticamente imutável · invista todo o esforço de planejamento antes da obra, não durante',
      },
      {
        icone: '🏭',
        texto:
          'Contrate empresa com portfólio de obras concluídas e referências verificáveis · a execução da fachada é o principal ponto de diferença entre obras boas e ruins',
      },
      {
        icone: '🔌',
        texto:
          'Coordene eletricistas e hidráulicos no cronograma de fechamento das placas · há uma janela curta e crítica que não pode ser perdida',
      },
    ],
    atencao: [
      {
        icone: '🌞',
        texto:
          'Fachada com apenas pintura pode marcar o esqueleto metálico sob luz direta · use pedra, vidro ou revestimento espesso para esconder a estrutura',
      },
      {
        icone: '🔧',
        texto:
          'Alterar a obra em andamento é muito mais custoso do que no sistema tradicional · vãos de porta e janela precisam estar corretos antes da montagem',
      },
      {
        icone: '🏙️',
        texto:
          'Mão de obra especializada ainda é escassa no Brasil · confirme disponibilidade de montadores e projetistas capacitados na sua cidade antes de decidir',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'sc05-cl1',
        texto:
          'Confirmei disponibilidade de empresa de Steel Frame com experiência comprovada na minha cidade',
      },
      {
        id: 'sc05-cl2',
        texto:
          'Finalizei o projeto arquitetônico completo antes de contratar a fabricação · sem mudanças previstas após início',
      },
      {
        id: 'sc05-cl3',
        texto: 'Planejei o fluxo de caixa para 6 meses de obra intensa (não 18 meses diluídos)',
      },
      {
        id: 'sc05-cl4',
        texto:
          'Agendei eletricistas e hidráulicos para a janela de instalações antes do fechamento das placas',
      },
      {
        id: 'sc05-cl5',
        texto:
          'Defini o sistema de revestimento da fachada (pedra, vidro ou espesso) para evitar marcação do esqueleto',
      },
    ],
    metadados: [
      {
        campo: 'empresa_steel_frame_pesquisada',
        label: 'Empresa de Steel Frame pesquisada',
        tipo: 'text',
        placeholder: 'Ex: nome da empresa, cidade',
      },
      {
        campo: 'prazo_estimado_obra_dias',
        label: 'Prazo estimado da obra (dias)',
        tipo: 'number',
        placeholder: 'Ex: 60',
      },
      {
        campo: 'revestimento_fachada_steel',
        label: 'Tipo de revestimento da fachada',
        tipo: 'select',
        opcoes: [
          'Pedra natural ou porcelanato',
          'Vidro / ACM',
          'Revestimento espesso texturizado',
          'Apenas pintura (verificar marcação)',
        ],
      },
    ],
    temFerramenta: false,
  },
  {
    topicoId: 'sc-06',
    resumo: [
      'Alvenaria estrutural elimina pilares, vigas e formas · a própria parede faz a estrutura da casa',
      'Sem madeira, escoramento e estrutura separada: é a principal ferramenta de economia entre os sistemas construtivos',
      'Cargas são diluídas em toda a alvenaria, reduzindo também o custo da fundação',
      'Ideal para casas térreas, terreno nivelado e vãos menores · onde os blocos estruturais trabalham melhor',
      'Limitação crítica: paredes não podem ser demolidas depois · o layout fica permanentemente travado após a obra',
      'Não funciona com grandes vãos, pé-direito duplo ou planta aberta · nesses trechos exige complemento em metal ou concreto',
    ],
    dicasDeOuro: [
      {
        icone: '💰',
        texto:
          'Alvenaria estrutural reduz custo de fundação e estrutura ao mesmo tempo · use quando o projeto for compacto e o terreno plano',
      },
      {
        icone: '🧱',
        texto:
          'O bloco pode ficar aparente eliminando reboco e pintura · economia dupla com estética honesta e industrial',
      },
      {
        icone: '🏡',
        texto:
          'Para casas com quartos e banheiros compactos em pavimento único, é a escolha mais econômica disponível no mercado',
      },
      {
        icone: '📐',
        texto:
          'Defina o layout definitivo antes de iniciar a obra · qualquer mudança em parede estrutural depois é extremamente cara ou impossível',
      },
    ],
    atencao: [
      {
        icone: '🔒',
        texto:
          'Paredes estruturais não podem ser demolidas após a obra · abrir ambientes ou mudar layout exige reforço estrutural complexo e caro',
      },
      {
        icone: '📏',
        texto:
          'Projetos com grandes vãos, pé-direito duplo ou planta aberta são incompatíveis com alvenaria estrutural · exige mistura de sistemas',
      },
      {
        icone: '⚠️',
        texto:
          'Usar alvenaria estrutural num projeto nascido para sistema convencional gera adaptações caras que anulam toda a economia',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'sc06-cl1',
        texto: 'Confirmei que o projeto é principalmente térreo e tem vãos menores (até 4–5m)',
      },
      {
        id: 'sc06-cl2',
        texto:
          'Verifiquei que não há necessidade de grandes aberturas, pé-direito duplo ou paredes para demolir no futuro',
      },
      {
        id: 'sc06-cl3',
        texto: 'Calculei a economia estimada em fundação e estrutura com alvenaria estrutural',
      },
      {
        id: 'sc06-cl4',
        texto:
          'Defini o layout definitivo antes de contratar a execução · sem previsão de mudanças após início',
      },
      {
        id: 'sc06-cl5',
        texto:
          'Identifiquei os trechos com grandes vãos que precisarão de estrutura complementar (metal ou concreto)',
      },
    ],
    metadados: [
      {
        campo: 'pavimentos_alvenaria_estrutural',
        label: 'Número de pavimentos da obra',
        tipo: 'select',
        opcoes: ['Térreo (único pavimento)', 'Sobrado (2 pavimentos)', 'Mais de 2 pavimentos'],
      },
      {
        campo: 'maior_vao_ambiente_ae_m',
        label: 'Maior vão entre paredes (m)',
        tipo: 'number',
        placeholder: 'Ex: 4',
      },
      {
        campo: 'economia_estimada_ae_rs',
        label: 'Economia estimada vs. sistema convencional (R$)',
        tipo: 'number',
        placeholder: 'Ex: 25000',
      },
    ],
    temFerramenta: false,
  },
  {
    topicoId: 'sc-07',
    resumo: [
      'ICF = formas permanentes de EPS preenchidas com concreto · o isopor é o molde que fica na parede, não a estrutura',
      'Um pavimento de 120–150m² erguido em 1 semana com 1 mestre e 3 ajudantes · sem chuva parando a produção, sem entulho de madeira',
      'EPS não absorve umidade · a casa terá muito menos infiltração e mofo do que alvenaria convencional com reboco',
      'Desempenho térmico e acústico excepcional: casca dupla de EPS + concreto reduz drasticamente o uso de ar-condicionado',
      'Instalações passam cortando o EPS com estilete · muito mais rápido e limpo do que quebrar alvenaria rebocada com marreta',
      'Versátil: grandes aberturas, balanços e piscinas são viáveis · e o sistema pode ser financiado pela Caixa Econômica Federal',
    ],
    dicasDeOuro: [
      {
        icone: '🌡️',
        texto:
          'Em regiões quentes, ICF reduz o uso de ar-condicionado de forma impressionante · o delay térmico é sentido desde o primeiro dia na casa',
      },
      {
        icone: '🏊',
        texto:
          'Piscinas em ICF são mais rápidas e econômicas do que com formas de madeira · o molde de EPS já serve de forma permanente para a concretagem',
      },
      {
        icone: '🔌',
        texto:
          'Para passar instalações, corte o EPS com estilete · muito mais ágil e limpo do que quebrar tijolo rebocado com marreta',
      },
      {
        icone: '🏦',
        texto:
          'ICF é financiável pela Caixa Econômica Federal · confirme as condições com o gerente antes de fechar o sistema',
      },
    ],
    atencao: [
      {
        icone: '🧱',
        texto:
          'Reboco comum não adere ao EPS · exige reboco específico para ICF com ponte química, que tem custo maior e deve entrar no orçamento',
      },
      {
        icone: '⚠️',
        texto:
          'Não confunda ICF com painéis monolíticos ou outros sistemas com isopor "estrutural" · somente no ICF o concreto é quem faz a resistência',
      },
      {
        icone: '🔒',
        texto:
          'ICF é sistema de paredes estruturais · demolir paredes após a obra é difícil: defina o layout definitivo antes de iniciar',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'sc07-cl1',
        texto:
          'Pesquisei fornecedores de formas ICF e reboco específico disponíveis na minha cidade ou região',
      },
      {
        id: 'sc07-cl2',
        texto: 'Verifiquei disponibilidade de financiamento pela Caixa para ICF no meu estado',
      },
      {
        id: 'sc07-cl3',
        texto: 'Confirmei que o projetista tem experiência com detalhamento de projetos para ICF',
      },
      {
        id: 'sc07-cl4',
        texto: 'Planejei a passagem de instalações antes da concretagem das paredes',
      },
      {
        id: 'sc07-cl5',
        texto:
          'Incluí o custo do reboco específico para ICF no orçamento (maior que reboco convencional)',
      },
    ],
    metadados: [
      {
        campo: 'clima_regiao_icf',
        label: 'Clima predominante da região',
        tipo: 'select',
        opcoes: [
          'Quente e seco (cerrado, semiárido)',
          'Quente e úmido (litorâneo, amazônico)',
          'Temperado (sul do Brasil)',
          'Frio (serras e planaltos)',
        ],
      },
      {
        campo: 'financiamento_caixa_icf',
        label: 'Financiamento pela Caixa verificado',
        tipo: 'select',
        opcoes: ['Sim · confirmado com gerente', 'Não · pagamento próprio', 'A verificar'],
      },
      {
        campo: 'fornecedor_icf_pesquisado',
        label: 'Fornecedor de formas ICF pesquisado',
        tipo: 'text',
        placeholder: 'Ex: nome do fornecedor, cidade',
      },
    ],
    temFerramenta: false,
  },
  {
    topicoId: 'sc-08',
    resumo: [
      'Tijolo modular de solo-cimento 15×30cm · sem queima, menor pegada ecológica entre os sistemas industriais disponíveis no Brasil',
      'Resistência de 5,9 MPa supera o bloco de concreto estrutural (norma exige 4,5 MPa) · pode-se construir até 3 pavimentos autoportantes',
      'Assentamento com cola de 1mm de junta, sem argamassa grossa · parede nasce reta independentemente da perícia do pedreiro',
      'Instalações passam pelos furos do tijolo sem quebrar a parede · canaletas servem para cintas de amarração, conduítes e tubulações',
      'Modulação rigorosa: projeto deve usar múltiplos de 15cm e prever gráutes a cada 1m e nas extremidades de cada parede',
      'Combinado com estrutura metálica, as paredes fazem o contraventamento naturalmente · permite perfis mais esbeltos e economia',
    ],
    dicasDeOuro: [
      {
        icone: '📐',
        texto:
          'Todo projeto em tijolo ecológico deve ser modulado em múltiplos de 15cm · 1mm de erro por junta acumula e torna a parede inutilizável',
      },
      {
        icone: '⚡',
        texto:
          'A primeira fiada é sagrada: nivelamento, gráutes, conduítes e esperas hidráulicas devem estar marcados antes de assentar o primeiro tijolo',
      },
      {
        icone: '🏗️',
        texto:
          'Tijolo ecológico combinado com estrutura metálica dispensa contraventamento em X · as paredes já travam os pilares naturalmente',
      },
      {
        icone: '🔌',
        texto:
          'Para passar instalações após a obra, use Serra-Copo ou grosa na casca do tijolo · muito mais limpo do que quebrar alvenaria rebocada',
      },
    ],
    atencao: [
      {
        icone: '🎯',
        texto:
          'Errar o nível da primeira fiada condena toda a parede · o assentamento é com cola de 1mm e não comporta correções com argamassa',
      },
      {
        icone: '🔒',
        texto:
          'Paredes autoportantes em tijolo ecológico não podem ser demolidas depois sem projeto estrutural específico',
      },
      {
        icone: '📏',
        texto:
          'Projeto com medidas fora dos múltiplos de 15cm exige cortes, gera desperdícios e compromete o módulo da parede · ajuste antes de contratar',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'sc08-cl1',
        texto:
          'Verifiquei que todas as paredes do projeto têm dimensão em múltiplos de 15cm (módulo do tijolo)',
      },
      {
        id: 'sc08-cl2',
        texto:
          'Prevei gráutes a cada 1m e nas extremidades de cada parede antes de iniciar a alvenaria',
      },
      {
        id: 'sc08-cl3',
        texto:
          'Mapeei percurso de instalações elétricas e hidráulicas para passar pelos furos do tijolo',
      },
      {
        id: 'sc08-cl4',
        texto:
          'Planejei a primeira fiada com nivelamento milimétrico confirmado e esperas já posicionadas',
      },
      {
        id: 'sc08-cl5',
        texto:
          'Confirmei disponibilidade de tijolo ecológico e cola específica na minha cidade ou região',
      },
    ],
    metadados: [
      {
        campo: 'pavimentos_tijolo_eco',
        label: 'Número de pavimentos com tijolo ecológico',
        tipo: 'select',
        opcoes: [
          'Térreo · 1 pavimento',
          'Sobrado · 2 pavimentos',
          '3 pavimentos (requer cálculo estrutural)',
        ],
      },
      {
        campo: 'tipo_uso_tijolo_eco',
        label: 'Uso estrutural do tijolo',
        tipo: 'select',
        opcoes: [
          'Autoportante (sem estrutura metálica)',
          'Misto com estrutura metálica',
          'Misto com estrutura de concreto',
        ],
      },
      {
        campo: 'fornecedor_tijolo_ecologico',
        label: 'Fabricante de tijolo ecológico pesquisado',
        tipo: 'text',
        placeholder: 'Ex: nome do fabricante, cidade',
      },
    ],
    temFerramenta: false,
  },
  {
    topicoId: 'sc-09',
    resumo: [
      'Sistemas híbridos combinam diferentes tecnologias construtivas para aproveitar o melhor de cada uma',
      'Exemplo comum: estrutura de concreto + fechamento em Steel Frame ou Tijolo Ecológico',
      'A comparação entre sistemas deve avaliar 7 critérios: velocidade, custo, isolamento térmico, isolamento acústico, disponibilidade, sustentabilidade e facilidade de autoconstrução',
      'Use o comparador abaixo para visualizar o desempenho de cada sistema nos critérios que importam para você',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto:
          'Sistemas híbridos podem reduzir custo e prazo ao mesmo tempo · consulte seu projetista',
      },
      {
        icone: '💡',
        texto: 'Priorize os critérios que mais impactam a sua realidade (prazo, custo, região)',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Sistemas híbridos exigem compatibilização de projetos para evitar incompatibilidades de junções',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'sc09-cl1',
        texto: 'Comparei os sistemas construtivos pelos critérios relevantes para minha obra',
      },
      {
        id: 'sc09-cl2',
        texto: 'Avaliei a viabilidade de sistema híbrido com o engenheiro responsável',
      },
    ],
    metadados: [],
    temFerramenta: true,
  },
  {
    topicoId: 'sc-10',
    resumo: [
      'O custo por sistema construtivo varia entre 5% e 35% em relação à alvenaria convencional',
      'Tijolo Ecológico é o sistema mais econômico; ICF e Estrutura Metálica são os mais caros',
      'O prazo de execução varia de 5 meses (Steel Frame) a 18 meses (Alvenaria Convencional) para obras de 100 m²',
      'Use a calculadora abaixo para comparar o custo estimado de cada sistema para a área e padrão da sua obra',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto:
          'O sistema mais barato nem sempre é o mais econômico · considere custo de mão de obra e prazo',
      },
      {
        icone: '💡',
        texto: 'Sistemas industrializados reduzem desperdício de material em até 30%',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Os valores são estimativas · solicite orçamentos formais de pelo menos 3 fornecedores',
      },
      {
        icone: '⚠️',
        texto: 'O custo de fundação não muda com o sistema construtivo · é determinado pelo solo',
      },
    ],
    checklistAplicabilidade: [
      { id: 'sc10-cl1', texto: 'Calculei o custo estimado para o sistema escolhido' },
      { id: 'sc10-cl2', texto: 'Comparei o custo entre pelo menos 3 sistemas diferentes' },
      { id: 'sc10-cl3', texto: 'Solicitei orçamentos formais para validar as estimativas' },
    ],
    metadados: [
      {
        campo: 'custo_estimado_sistema',
        label: 'Custo estimado calculado (R$)',
        tipo: 'number',
        placeholder: 'Resultado da calculadora',
      },
    ],
    temFerramenta: true,
  },
]

TOPICOS_CONTENT.push(...SC_CONTENT)

const PROJ_CONTENT: TopicoContent[] = [
  {
    topicoId: 'proj-01',
    resumo: [
      'O projeto é onde se decide o custo real da obra · dois projetos de 300m² no mesmo terreno podem ter preços radicalmente diferentes',
      'O projeto vem depois de terreno e sistema construtivo · ele é uma reação a essas duas definições, não pode vir antes',
      'Uma única alteração de layout pode enxugar de 50 mil a 600 mil reais sem comprometer estética ou funcionalidade',
      'Quem já tem projeto pode revisá-lo com novos critérios e identificar pontos de otimização antes de contratar a obra',
      'Quem ainda não tem projeto pode projetar do zero de forma otimizada · aproveitando o conhecimento antes de qualquer compromisso',
    ],
    dicasDeOuro: [
      {
        icone: '📐',
        texto:
          'Se já tem projeto, revise-o antes de contratar o engenheiro · pequenas mudanças de layout geram as maiores economias',
      },
      {
        icone: '🔄',
        texto:
          'O projeto é a última chance de mudar sem custo alto · depois que começa a obra, cada alteração multiplica o impacto no orçamento',
      },
      {
        icone: '💰',
        texto:
          'Uma alteração estrutural bem aplicada pode economizar mais do que meses de corte em material de acabamento',
      },
      {
        icone: '🎯',
        texto:
          'Se já tem projeto, abra o arquivo lado a lado com as etapas deste módulo · cada uma revela pontos concretos de otimização',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Projeto genérico feito sem premissas de terreno e sistema construtivo nasce ineficiente · revise a fundo antes de aprovar',
      },
      {
        icone: '💸',
        texto:
          'Aprovar projeto sem entender o impacto financeiro de cada decisão pode tornar a obra inviável no meio do caminho',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'proj01-cl1',
        texto:
          'Verifiquei se o projeto reflete as conclusões do terreno (topografia, orientação, restrições)',
      },
      {
        id: 'proj01-cl2',
        texto: 'Verifiquei se o projeto foi pensado para o sistema construtivo já definido',
      },
      {
        id: 'proj01-cl3',
        texto: 'Listei pontos do projeto que parecem caros ou redundantes para revisar nesta etapa',
      },
      {
        id: 'proj01-cl4',
        texto: 'Defini uma meta de custo para usar como filtro de decisões ao longo do projeto',
      },
    ],
    metadados: [
      {
        campo: 'area_projeto_total_m2',
        label: 'Área total do projeto (m²)',
        tipo: 'number',
        placeholder: 'Ex: 200',
      },
      {
        campo: 'status_projeto_atual',
        label: 'Situação do projeto agora',
        tipo: 'select',
        opcoes: [
          'Ainda não tenho projeto',
          'Tenho anteprojeto em andamento',
          'Projeto aprovado · em revisão',
          'Projeto aprovado · em obra',
        ],
      },
      {
        campo: 'meta_custo_obra_rs',
        label: 'Meta de custo da obra (R$)',
        tipo: 'number',
        placeholder: 'Ex: 800000',
      },
    ],
    temFerramenta: false,
  },
  {
    topicoId: 'proj-02',
    resumo: [
      'Sequência correta: sondagem + topografia → arquitetônico → estrutural + interiores → hidráulico + elétrico → obra',
      'Soltar todos os projetos ao mesmo tempo gera conflitos não resolvidos e projetos que não batem entre si na obra',
      'Projeto de interiores deve vir ANTES do elétrico e hidráulico · sem ele, posições de tomadas e pontos de água são chutados',
      'Projeto estrutural deve preceder o hidráulico · vigas e colunas disputam as mesmas posições que tubos de esgoto e chuva',
      'Em paralelo corre o circuito de documentação: alvará → obra → habite-se → CND → averbação em cartório',
      'Alguém precisa ser o maestro da compatibilização · arquiteto, construtora ou gerenciador · para resolver os conflitos entre disciplinas',
    ],
    dicasDeOuro: [
      {
        icone: '🎯',
        texto:
          'Defina quem vai compatibilizar os projetos antes de contratar o segundo projetista · conflito descoberto na obra custa muito mais do que resolver no papel',
      },
      {
        icone: '🏠',
        texto:
          'Faça o projeto de interiores antes do elétrico: cada tomada terá a posição correta para o eletrodoméstico que vai realmente usá-la',
      },
      {
        icone: '📋',
        texto:
          'Inicie a aprovação do alvará assim que o arquitetônico ficar pronto · em cidades como BH o processo pode levar até 2 anos',
      },
      {
        icone: '🔗',
        texto:
          'Trate cada projeto como input do próximo: estrutural finalizado libera hidráulico; interiores finalizado libera elétrico',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Projetos não compatibilizados chegam na obra com conflitos reais: coluna invade armário, viga corta pé-direito, tubo bate em fundação',
      },
      {
        icone: '📅',
        texto:
          'Aprovação do alvará pode levar meses a anos dependendo da cidade · não calcule prazo de início da obra sem considerar isso',
      },
      {
        icone: '🔄',
        texto:
          'Alterar elétrico ou hidráulico depois de contratados (por mudança no interiores) gera retrabalho, quebra-quebra e custo extra',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'proj02-cl1',
        texto: 'Contratei sondagem e levantamento topográfico antes de qualquer projeto',
      },
      {
        id: 'proj02-cl2',
        texto: 'Defini quem será o maestro de compatibilização entre os projetos',
      },
      {
        id: 'proj02-cl3',
        texto:
          'Garantei que o projeto de interiores será feito antes de contratar elétrico e hidráulico',
      },
      {
        id: 'proj02-cl4',
        texto: 'Iniciei o processo de aprovação do alvará assim que o arquitetônico ficou pronto',
      },
      {
        id: 'proj02-cl5',
        texto: 'Confirmei a sequência estrutural → hidráulico com o engenheiro responsável',
      },
    ],
    metadados: [
      {
        campo: 'maestro_compatibilizacao',
        label: 'Quem fará a compatibilização dos projetos',
        tipo: 'select',
        opcoes: [
          'Arquiteto autor do projeto',
          'Construtora contratada',
          'Gerenciador independente',
          'Ainda não definido',
        ],
      },
      {
        campo: 'status_alvara_obra',
        label: 'Status do alvará de construção',
        tipo: 'select',
        opcoes: [
          'Não iniciado',
          'Em análise na prefeitura',
          'Aprovado',
          'Não necessário (área rural)',
        ],
      },
      {
        campo: 'prazo_estimado_alvara_dias',
        label: 'Prazo estimado para aprovação do alvará (dias)',
        tipo: 'number',
        placeholder: 'Ex: 180',
      },
    ],
    temFerramenta: true,
  },
  {
    topicoId: 'proj-03',
    resumo: [
      'O projeto arquitetônico tem dois clientes: você (programa, estilo, layout) e a prefeitura (regularização urbanística)',
      'É o projeto mais visual · define forma e função da casa, e toda mudança de forma impacta diretamente o custo',
      'Entrega mínima: layout com mobiliário, planta baixa técnica, cortes e fachadas · mas não é suficiente para executar a obra',
      'Sem detalhamento adicional, o canteiro opera por tentativa e erro: constrói, quebra e reconstrói a mesma coisa',
      'Quatro eixos encarecedores: metragem, geometria da casa, fator casca (envelope externo) e componentes internos',
    ],
    dicasDeOuro: [
      {
        icone: '📐',
        texto:
          'Exija ao menos planta baixa + cortes + fachadas antes de encerrar o contrato · sem esses itens o projeto não pode ir para execução',
      },
      {
        icone: '🏛️',
        texto:
          'Avalie cada eixo encarecedor antes de aprovar o projeto: metragem, geometria, casca e componentes internos determinam o orçamento final',
      },
      {
        icone: '🔍',
        texto:
          'Peça o layout com mobiliário antes da planta técnica · é a forma mais fácil de visualizar se a casa funciona como você imagina',
      },
      {
        icone: '🏙️',
        texto:
          'Inicie o processo de aprovação na prefeitura em paralelo com os projetos complementares para não perder tempo',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Projeto com apenas planta básica (sem interiores nem detalhamento) leva a improvisos no canteiro · o pedreiro decide o que deveria ser decidido em projeto',
      },
      {
        icone: '🔐',
        texto:
          'Construir com alvará na hora sem aprovação prévia pode resultar em construção irregular ou demolição compulsória se não atender recuos ou índices urbanísticos',
      },
      {
        icone: '📏',
        texto:
          'Os quatro eixos encarecedores (metragem, geometria, casca, componentes) podem dobrar o custo de obras com a mesma área · analise cada um antes de aprovar',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'proj03-cl1',
        texto:
          'Revisei o layout com mobiliário e confirmai que os ambientes funcionam para o meu programa de necessidades',
      },
      {
        id: 'proj03-cl2',
        texto:
          'Verifiquei se a planta baixa inclui cortes e fachadas suficientes para visualizar a casa tridimensionalmente',
      },
      {
        id: 'proj03-cl3',
        texto: 'Identifiquei os quatro eixos encarecedores no meu projeto e avaliei cada um',
      },
      {
        id: 'proj03-cl4',
        texto:
          'Confirmei que o projeto tem detalhamento suficiente para execução ou planejei contratar interiores antes de iniciar a obra',
      },
    ],
    metadados: [
      {
        campo: 'pavimentos_projeto',
        label: 'Número de pavimentos do projeto',
        tipo: 'select',
        opcoes: ['Térreo', 'Sobrado (2 pavimentos)', '3 ou mais pavimentos'],
      },
      {
        campo: 'status_detalhamento_arq',
        label: 'Grau de detalhamento do projeto',
        tipo: 'select',
        opcoes: [
          'Apenas planta baixa, cortes e fachadas',
          'Com projeto de interiores básico',
          'Detalhamento completo (paginação, forro, iluminação)',
        ],
      },
    ],
    temFerramenta: false,
  },
  {
    topicoId: 'proj-04',
    resumo: [
      'Projetos arquitetônicos variam de R$ 8 mil a R$ 100 mil · não dá para comparar pelo preço sem entender o que está incluído',
      'Seis pontos a conferir antes de contratar: visitas à obra, seleção de fornecedores, visitas à loja, comissões (5–20%), alvará e habite-se',
      'Comissões de fornecedores podem chegar a 20% · arquitetos com honorários baixos às vezes ganham muito mais em comissão',
      'Grau de detalhamento varia muito: paginação, forro, luminotécnico, marcenaria, esquadrias e bancadas podem ou não estar incluídos',
      'Arquiteto com renome pode valorizar o imóvel em 10–20% na revenda com um projeto que custou apenas 2% a mais',
      'Quanto menos detalhamento, mais improviso na obra · decisões técnicas migram para o canteiro e saem mais caras e erradas',
    ],
    dicasDeOuro: [
      {
        icone: '📋',
        texto:
          'Peça ao arquiteto uma lista de entregas detalhada antes de assinar · projetos com o mesmo preço podem ter escopos radicalmente diferentes',
      },
      {
        icone: '💰',
        texto:
          'Pergunte diretamente sobre comissões de fornecedores · arquiteto que ganha comissão pode não ter incentivo para buscar o menor preço para você',
      },
      {
        icone: '🔍',
        texto:
          'Verifique se paginação, forro, luminotécnico e bancadas estão incluídos · são os itens mais comuns de estar faltando em projetos mais baratos',
      },
      {
        icone: '🏆',
        texto:
          'Se o imóvel for para venda, avalie se um arquiteto com renome local compensa: a valorização pode superar em muito o custo extra do projeto',
      },
    ],
    atencao: [
      {
        icone: '💸',
        texto:
          'Projeto barato que entrega pouco deixa o cliente desguarnecido na obra: cada detalhe não projetado vira improviso que custa caro',
      },
      {
        icone: '🔄',
        texto:
          'Projeto sem limite de revisões pode se tornar um ciclo infinito de mudanças · confirme quantas revisões e renderizações estão incluídas',
      },
      {
        icone: '👥',
        texto:
          'Decidir acabamentos sem projeto de interiores pronto significa depender de sugestão de fornecedores, parentes e pedreiro · as piores fontes de decisão de obra',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'proj04-cl1',
        texto: 'Solicitei lista completa de entregas de cada arquiteto antes de comparar preços',
      },
      {
        id: 'proj04-cl2',
        texto:
          'Perguntei sobre comissões de fornecedores e como isso impacta a independência das recomendações',
      },
      {
        id: 'proj04-cl3',
        texto:
          'Confirmei se paginação, forro, luminotécnico, marcenaria, esquadrias e bancadas estão incluídos',
      },
      {
        id: 'proj04-cl4',
        texto:
          'Verifiquei se o arquiteto incluiu visitas à obra e participação no processo de aprovação do alvará e habite-se',
      },
      {
        id: 'proj04-cl5',
        texto:
          'Avaliei o renome do arquiteto no mercado local e o impacto potencial no valor de revenda do imóvel',
      },
    ],
    metadados: [
      {
        campo: 'orcamento_projeto_arq_rs',
        label: 'Orçamento do projeto arquitetônico (R$)',
        tipo: 'number',
        placeholder: 'Ex: 25000',
      },
      {
        campo: 'inclui_interiores_executivo',
        label: 'Projeto inclui interiores / executivo',
        tipo: 'select',
        opcoes: ['Sim · completo', 'Sim · parcial (paginação e forro)', 'Não · só planta básica'],
      },
      {
        campo: 'arquiteto_compatibiliza',
        label: 'Arquiteto assume compatibilização dos projetos',
        tipo: 'select',
        opcoes: ['Sim', 'Não', 'Parcialmente'],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...PROJ_CONTENT)

const PROJ_CONTENT_2: TopicoContent[] = [
  {
    topicoId: 'proj-05',
    resumo: [
      'Seu orçamento define um "poder de metragem" · a faixa exata de m² que você pode construir com o dinheiro disponível',
      'Ultrapassar esse limite não tem solução: acabamento simples, mão de obra barata ou sistema diferente não compensam metros extras',
      'Custo por m² é impreciso para orçamento detalhado, mas indispensável na etapa 1 para calibrar o tamanho da obra',
      'Padrão Médio (~R$ 3.500/m²): básico bem feito, sem sofisticação; Nobre (~R$ 5.500/m²): upgrades de fachada e itens visuais',
      'Padrão Alto: alto padrão real com esquadrias, revestimentos e bancadas premium; AAA (~R$ 11.000/m²): estado da arte completo',
      'A metragem de Alvará (área coberta aprovada) é o número-base para calcular o custo · piscinas e beirais são refinamentos posteriores',
    ],
    dicasDeOuro: [
      {
        icone: '📐',
        texto:
          'Calcule seu poder de metragem dividindo o orçamento pelo custo/m² do seu padrão · esse número é o teto inegociável do projeto',
      },
      {
        icone: '🎯',
        texto:
          'Preencha a tabela de padrões colorindo cada item (reboco, esquadrias, revestimentos) para identificar em qual padrão você realmente está',
      },
      {
        icone: '⬆️',
        texto:
          'Se suas escolhas ficarem entre dois padrões, adote o custo do padrão superior · errar para cima no custo é sempre mais seguro',
      },
      {
        icone: '✂️',
        texto:
          'Ajuste a metragem antes de ajustar o padrão: cortar 20 m² de projeto custa menos esforço do que rebaixar todo o padrão de acabamento',
      },
    ],
    atencao: [
      {
        icone: '💸',
        texto:
          'Projetar além do poder de metragem inviabiliza a obra · não existe estratégia de custo que compense metros a mais no projeto',
      },
      {
        icone: '📊',
        texto:
          'Usar só o custo por m² para planejar o orçamento completo é erro grave · ele só serve para calibrar o tamanho na etapa inicial',
      },
      {
        icone: '🏷️',
        texto:
          'Padrão "nobre de condomínio" ≠ alto padrão real · a diferença de custo entre nobre e alto pode ser 40–60% a mais por m²',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'proj05-cl1',
        texto: 'Defini o orçamento total disponível para a obra, incluindo reserva de contingência',
      },
      {
        id: 'proj05-cl2',
        texto:
          'Identifiquei meu padrão de construção preenchendo a tabela de escolhas (reboco, esquadrias, revestimentos)',
      },
      {
        id: 'proj05-cl3',
        texto: 'Calculei meu poder de metragem: orçamento total ÷ custo/m² do padrão identificado',
      },
      {
        id: 'proj05-cl4',
        texto:
          'Confirmei que o projeto arquitetônico está dentro ou abaixo do poder de metragem calculado',
      },
      {
        id: 'proj05-cl5',
        texto:
          'Registrei a metragem de Alvará como referência base para os próximos cálculos de custo',
      },
    ],
    metadados: [
      {
        campo: 'padrao_construcao',
        label: 'Padrão de Construção',
        tipo: 'select',
        opcoes: [
          'Médio (~R$ 3.500/m²)',
          'Nobre (~R$ 5.500/m²)',
          'Alto (~R$ 8.000/m²)',
          'AAA (~R$ 11.000/m²)',
        ],
      },
      {
        campo: 'custo_m2_estimado_rs',
        label: 'Custo estimado por m² (R$)',
        tipo: 'number',
        placeholder: 'Ex: 5500',
      },
      {
        campo: 'poder_metragem_m2',
        label: 'Poder de metragem calculado (m²)',
        tipo: 'number',
        placeholder: 'Ex: 280',
      },
    ],
    temFerramenta: true,
  },
]

TOPICOS_CONTENT.push(...PROJ_CONTENT_2)

const PROJ_CONTENT_3: TopicoContent[] = [
  {
    topicoId: 'proj-07',
    resumo: [
      'Áreas molhadas (banheiros, cozinha, gourmet, piscina, sauna) custam de 2x a 5x mais por m² do que áreas secas como quartos e garagem',
      'Quarto: ~R$ 2.800/m²; banheiro: ~R$ 9.000+/m²; cozinha com marcenaria: ~R$ 15.000/m² · a mesma planta com custos radicalmente diferentes',
      'O custo médio por m² de um projeto só é válido quando os ambientes estão em proporção equilibrada entre si',
      'Acumular banheiros extras, duas cozinhas ou piscina distorce o custo médio para cima mesmo mantendo o padrão de acabamento',
      'Ao enxugar metragem para caber no orçamento, corte áreas molhadas primeiro · o impacto financeiro é desproporcional ao espaço eliminado',
    ],
    dicasDeOuro: [
      {
        icone: '🚿',
        texto:
          'Use a proporção ~1 banheiro por 70–80 m² de área total como referência para não distorcer o custo médio do projeto',
      },
      {
        icone: '🍳',
        texto:
          'Cozinha gourmet separada pode custar mais por m² do que dois quartos inteiros · avalie se unificar com a cozinha principal resolve a função',
      },
      {
        icone: '✂️',
        texto:
          'Ao cortar metragem para encaixar no orçamento, elimine áreas molhadas antes de áreas secas · o ganho de custo é muito maior',
      },
      {
        icone: '📊',
        texto:
          'Simule o custo real somando cada tipo de ambiente separadamente antes de fechar o projeto com o arquiteto',
      },
    ],
    atencao: [
      {
        icone: '💦',
        texto:
          'Casa com proporção alta de áreas molhadas pode ter custo real 30–50% acima do custo médio esperado para o padrão escolhido',
      },
      {
        icone: '🧮',
        texto:
          'Comparar projetos pelo custo total por m² sem considerar o mix de ambientes leva a orçamentos irreais e obras inacabadas',
      },
      {
        icone: '🏊',
        texto:
          'Piscina e sauna têm o maior custo por m² da obra · inclua-as no escopo somente com orçamento calculado separadamente',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'proj07-cl1',
        texto:
          'Listei todos os ambientes da planta e classifiquei cada um como área seca ou molhada',
      },
      {
        id: 'proj07-cl2',
        texto: 'Contei os banheiros e verifiquei a proporção: máximo ~1 por 70 m² da área total',
      },
      {
        id: 'proj07-cl3',
        texto:
          'Avaliei o impacto financeiro de banheiros extras e segundo espaço gourmet sobre o orçamento total',
      },
      {
        id: 'proj07-cl4',
        texto:
          'Decidi se piscina ou sauna entram no escopo e separei o custo delas do custo da casa principal',
      },
      {
        id: 'proj07-cl5',
        texto:
          'Comparei o custo estimado com o poder de metragem antes de fechar a planta com o arquiteto',
      },
    ],
    metadados: [
      {
        campo: 'qtd_banheiros_projeto',
        label: 'Quantidade de banheiros no projeto',
        tipo: 'number',
        placeholder: 'Ex: 4',
      },
      {
        campo: 'tem_cozinha_gourmet',
        label: 'Inclui cozinha gourmet separada',
        tipo: 'select',
        opcoes: ['Sim', 'Não'],
      },
      {
        campo: 'tem_piscina_projeto',
        label: 'Inclui piscina no projeto',
        tipo: 'select',
        opcoes: ['Sim', 'Não'],
      },
    ],
    temFerramenta: true,
  },
]

TOPICOS_CONTENT.push(...PROJ_CONTENT_3)

const PROJ_CONTENT_4: TopicoContent[] = [
  {
    topicoId: 'proj-09',
    resumo: [
      'Vãos até 5 metros são a faixa econômica · acima disso a estrutura exige peças mais robustas, mais aço e fundações mais profundas',
      'A análise de vão é sempre 2D: um corredor de 15×1m não é grande vão; uma sala de 8×8m sim · o menor lado determina o risco estrutural',
      'Cada coluna eliminada redistribui seu peso para as vizinhas, exigindo pilares maiores, vigas mais altas e fundações reforçadas',
      'Regra da viga: altura ≈ 10% do vão · vão de 12m exige viga de 1,20m, que reduz diretamente o pé-direito útil do ambiente',
      'Os maiores vãos típicos são garagem para 3 carros (~9m), sala-cozinha integrada e espaço gourmet aberto',
      'Inserir uma coluna central no vão pode reduzir drasticamente o consumo de aço e concreto, ao custo de um impacto estético controlável',
    ],
    dicasDeOuro: [
      {
        icone: '📏',
        texto:
          'Mantenha vãos abaixo de 5m em ambos os sentidos sempre que possível · esse é o limiar onde o custo estrutural dispara',
      },
      {
        icone: '🏛️',
        texto:
          'Avalie se uma coluna central resolve o problema de vão sem comprometer a função do espaço · o ganho de custo pode ser expressivo',
      },
      {
        icone: '🚗',
        texto:
          'Garagem para 3 carros lado a lado já exige vão de ~9m · acione o calculista antes de fechar a planta para estimar o impacto',
      },
      {
        icone: '🔗',
        texto:
          'Em todos os sistemas construtivos (concreto, steel frame, madeira), vãos grandes penalizam o custo igualmente · a lógica é universal',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Vão de 12m requer viga de ~1,20m de altura, que compete com o pé-direito e pode forçar aumento de toda a laje de teto',
      },
      {
        icone: '🏗️',
        texto:
          'Fundações dos pilares em vãos grandes precisam resistir ao esforço de tombamento · custo de fundação sobe junto com o vão',
      },
      {
        icone: '💸',
        texto:
          'Projetos com vãos livres amplos são arquitetonicamente arrojados, mas o custo extra em aço e concreto pode chegar a 20–40% na estrutura',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'proj09-cl1',
        texto: 'Identifiquei todos os vãos do projeto e medi os dois lados de cada ambiente',
      },
      {
        id: 'proj09-cl2',
        texto:
          'Verifiquei que nenhum vão ultrapassa 5m em ambas as dimensões sem justificativa orçamentária clara',
      },
      {
        id: 'proj09-cl3',
        texto:
          'Calculei a altura estimada das vigas para os maiores vãos (10% do vão) e confirmei que não compromete o pé-direito',
      },
      {
        id: 'proj09-cl4',
        texto:
          'Decidi conscientemente sobre colunas em garagem e ambientes integrados, pesando custo versus estética',
      },
      {
        id: 'proj09-cl5',
        texto:
          'Solicitei ao calculista estimativa comparativa de custo com e sem colunas nos vãos críticos',
      },
    ],
    metadados: [
      {
        campo: 'maior_vao_metros',
        label: 'Maior vão do projeto (m)',
        tipo: 'number',
        placeholder: 'Ex: 8.0',
      },
      {
        campo: 'garagem_3_carros',
        label: 'Garagem para 3+ carros (vão ~9m)',
        tipo: 'select',
        opcoes: ['Sim', 'Não'],
      },
      {
        campo: 'sala_cozinha_integrada',
        label: 'Sala e cozinha integradas',
        tipo: 'select',
        opcoes: ['Sim', 'Não'],
      },
    ],
    temFerramenta: true,
  },
]

TOPICOS_CONTENT.push(...PROJ_CONTENT_4)

const PROJ_CONTENT_5: TopicoContent[] = [
  {
    topicoId: 'proj-10',
    resumo: [
      '"Paredes sobre paredes" criam colunas diretas do chão ao topo · estrutura enxuta, consumo de aço reduzido e pé-direito preservado',
      'Parede sobre vazio exige vigas de transição que aparecem no teto e podem baixar o pé-direito de 2,80m para 2,40m após o forro',
      'O forro esconde vigas e tubulações mas consome mais altura · cada centímetro de assimetria cobra seu preço no ambiente final',
      'A configuração preferida no Brasil (térreo social aberto + pavimentos privados compartimentados) é a mais assimétrica e a mais cara',
      'Ajustes de 30cm nas paredes entre andares podem economizar toneladas de aço sem mudar a experiência real do morador',
      'Projetos com 3 andares sofrem o problema de forma multiplicada · cada pavimento adicional amplifica o custo da assimetria',
    ],
    dicasDeOuro: [
      {
        icone: '🧱',
        texto:
          'Peça ao arquiteto a sobreposição dos pavimentos antes de fechar o projeto · toda parede sobre vazio deve ser justificada e precificada',
      },
      {
        icone: '📐',
        texto:
          'Mova paredes até 30cm para coincidir com as do andar abaixo: a experiência do morador é a mesma, o custo estrutural cai expressivamente',
      },
      {
        icone: '🪜',
        texto:
          'Verifique o impacto da altura de laje no número de degraus · cada 5cm a mais pode exigir um degrau extra que não cabe no layout',
      },
      {
        icone: '🏗️',
        texto:
          'Em projetos de 3 pavimentos, exija revisão estrutural obrigatória entre andares · a assimetria se multiplica a cada nível',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Projetos desenhados sem consciência estrutural frequentemente entregam pé-direito 30–40cm abaixo do prometido após vigas e forro',
      },
      {
        icone: '🔄',
        texto:
          'Vigas de transição são caras e inevitáveis em plantas assimétricas · encomende o cálculo estrutural antes de aprovar o projeto',
      },
      {
        icone: '📏',
        texto:
          'Pé-direito baixo é permanente: causa calor, sensação de clausura e não tem conserto após a obra concluída',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'proj10-cl1',
        texto:
          'Solicitei ao arquiteto a sobreposição dos pavimentos para identificar paredes sobre vazio',
      },
      {
        id: 'proj10-cl2',
        texto:
          'Identifiquei todos os pontos onde paredes superiores não coincidem com paredes ou colunas inferiores',
      },
      {
        id: 'proj10-cl3',
        texto:
          'Avaliei com o calculista o custo das vigas de transição necessárias para cada ponto assimétrico',
      },
      {
        id: 'proj10-cl4',
        texto:
          'Confirmei o pé-direito final pós-viga e pós-forro em cada ambiente antes de assinar o projeto',
      },
      {
        id: 'proj10-cl5',
        texto:
          'Verifiquei se o número de degraus da escada comporta possíveis ajustes de altura de laje sem conflito de layout',
      },
    ],
    metadados: [
      {
        campo: 'qtd_pavimentos_projeto',
        label: 'Quantidade de pavimentos',
        tipo: 'number',
        placeholder: 'Ex: 2',
      },
      {
        campo: 'sobreposicao_revisada',
        label: 'Sobreposição de andares revisada',
        tipo: 'select',
        opcoes: ['Sim · sem parede sobre vazio', 'Sim · com ajustes pendentes', 'Não · pendente'],
      },
      {
        campo: 'pe_direito_social_cm',
        label: 'Pé-direito previsto no andar social (cm)',
        tipo: 'number',
        placeholder: 'Ex: 280',
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...PROJ_CONTENT_5)

const PROJ_CONTENT_6: TopicoContent[] = [
  {
    topicoId: 'proj-12',
    resumo: [
      'Geometria complexa impõe 5 transições de execução que elevam o custo: esqueleto primeiro, aço no local, escoramento pesado, mão de obra especializada e madeirite no lugar de tábua',
      'Na construção simples a alvenaria sobe junto com a estrutura e serve de apoio · na complexa o esqueleto avança sozinho exigindo escoramento a cada 50cm',
      'Peças de vergalhão em geometria complexa chegam a 500 kg e não podem ser pré-montadas · o armador monta tudo dentro das formas no canteiro',
      'Obra desafiadora exige carpinteiro e armador no lugar do pedreiro · mão de obra mais rara, mais especializada e significativamente mais cara',
      'O sinal visível de alerta é o madeirite plastificado: quando ele aparece no canteiro, a geometria já empurrou o custo para outro patamar',
    ],
    dicasDeOuro: [
      {
        icone: '🏗️',
        texto:
          'Observe o canteiro: formas de madeirite preto, escoramento denso e armadores são sinais de que a geometria já encareceu a execução',
      },
      {
        icone: '📦',
        texto:
          'Confirme com o calculista se o aço pode chegar pré-montado · quando não pode, o custo de armação sobe 30–50% em mão de obra',
      },
      {
        icone: '🔄',
        texto:
          'Avalie elementos de geometria complexa antes da aprovação estrutural · ajustar no projeto custa zero; ajustar em obra pode custar dezenas de milhares',
      },
      {
        icone: '💰',
        texto:
          'Compare orçamentos com e sem geometria complexa: geometria simples = pedreiro; complexa = carpinteiro + armador + projeto de forma',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Geometria desafiadora não só encarece o aço · ela muda toda a equipe e o método de execução, elevando o custo total em 25–60%',
      },
      {
        icone: '🧱',
        texto:
          'Estruturas muito pesadas não podem ser apoiadas em alvenaria · o tijolo cede e trinca, forçando o esqueleto primeiro e multiplicando o escoramento',
      },
      {
        icone: '🏊',
        texto:
          'Piscina suspensa sobre garagem de 3 carros converge os piores fatores: grande vão + carga de água + estrutura flutuante = custo máximo',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'proj12-cl1',
        texto:
          'Identifiquei na planta todos os elementos de geometria complexa (balanços, vãos >5m, áreas suspensas)',
      },
      {
        id: 'proj12-cl2',
        texto:
          'Perguntei ao calculista se o aço pode ser entregue pré-montado ou exige montagem no local',
      },
      {
        id: 'proj12-cl3',
        texto:
          'Verifiquei se o projeto exige carpinteiro e armador ou pode ser executado por pedreiro',
      },
      {
        id: 'proj12-cl4',
        texto: 'Obtive orçamento de escoramento para os vãos e balanços críticos do projeto',
      },
      {
        id: 'proj12-cl5',
        texto:
          'Decidi se elementos de geometria complexa valem o custo adicional ou podem ser simplificados sem impacto na experiência',
      },
    ],
    metadados: [
      {
        campo: 'tem_estrutura_suspensa',
        label: 'Possui estrutura suspensa (piscina, balanço)',
        tipo: 'select',
        opcoes: ['Sim', 'Não'],
      },
      {
        campo: 'metodo_execucao_estrutura',
        label: 'Método de execução previsto',
        tipo: 'select',
        opcoes: ['Alvenaria antes (simples)', 'Esqueleto primeiro (complexo)', 'A definir'],
      },
      {
        campo: 'tipo_forma_prevista',
        label: 'Tipo de forma estrutural prevista',
        tipo: 'select',
        opcoes: ['Tábua (simples)', 'Madeirite plastificado (complexo)', 'Mista'],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...PROJ_CONTENT_6)

const PROJ_CONTENT_7: TopicoContent[] = [
  {
    topicoId: 'proj-13',
    resumo: [
      '"Fator casca" são elementos estéticos no envólucro da casa sem função estrutural · podem consumir 10–15% do orçamento sem melhorar nenhum espaço interno',
      'Detalhes decorativos em concreto (pórticos, molduras, reentrâncias) podem custar R$ 100 mil isoladamente sem alterar nada no interior da obra',
      'Plano de vidro custa 10x mais que alvenaria: parede com reboco = R$ 100–120/m²; vidro + caixilho = R$ 1.100–1.200/m²',
      'Brises ripadas e pergolados sem função de sombreamento custam R$ 1.200–1.500/m² · presença crescente em projetos sem avaliação de retorno real',
      'Fachadas com ângulos ou curvas criam zonas mortas internas · casas de 500m² de alvará podem ter apenas 400m² realmente utilizáveis',
      'Vidro de composição coberto com cortina resulta em fechamento de R$ 2.000/m² sem nenhum benefício prático de luz, vista ou ventilação',
    ],
    dicasDeOuro: [
      {
        icone: '📋',
        texto:
          'Peça ao arquiteto que liste cada elemento de fachada com sua função · o que não for estrutural, térmico ou de iluminação é fator casca a questionar',
      },
      {
        icone: '🪟',
        texto:
          'Antes de confirmar um plano de vidro, pergunte: ele traz luz, vista ou ventilação real? Se for coberto por cortina ou sem vista, substitua por alvenaria pintada',
      },
      {
        icone: '🌿',
        texto:
          'Brise e pergolado só fazem sentido financeiro quando funcionam como sombreamento real · o pergolado estético custa o mesmo mas entrega zero conforto',
      },
      {
        icone: '💡',
        texto:
          'Decida o percentual do orçamento dedicado à fachada antes de aprovar o projeto · você pode ter casca bonita e custo controlado se a escolha for consciente',
      },
    ],
    atencao: [
      {
        icone: '💸',
        texto:
          'Elementos de fachada sem função podem representar 10–15% do orçamento total · grana que poderia estar no conforto interno e na qualidade da construção',
      },
      {
        icone: '🔲',
        texto:
          'Fachadas com ângulos e curvas geram zonas mortas internas · espaços construídos, pagos e que não cabem móvel nem têm utilidade prática',
      },
      {
        icone: '🌡️',
        texto:
          'Vidro exposto ao sol da tarde cria efeito estufa · o custo de resfriamento recorrente (ar-condicionado, persianas) pode superar o custo da própria esquadria',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'proj13-cl1',
        texto:
          'Listei todos os elementos de fachada e classifiquei cada um como estrutural, funcional ou estritamente estético',
      },
      {
        id: 'proj13-cl2',
        texto:
          'Calculei quanto do orçamento total está sendo destinado ao fator casca (elementos estritamente estéticos)',
      },
      {
        id: 'proj13-cl3',
        texto:
          'Avaliei cada plano de vidro: ele traz luz, ventilação ou vista real? Se não, comparei o custo com alvenaria pintada',
      },
      {
        id: 'proj13-cl4',
        texto:
          'Verifiquei se brises ou pergolados projetados têm função real de sombreamento ou são apenas composição estética',
      },
      {
        id: 'proj13-cl5',
        texto:
          'Confirmei que fachadas com ângulos ou curvas não criam zonas mortas internas que reduzem a área utilizável',
      },
    ],
    metadados: [
      {
        campo: 'perc_orcamento_casca',
        label: 'Estimativa de fator casca no orçamento (%)',
        tipo: 'number',
        placeholder: 'Ex: 12',
      },
      {
        campo: 'tem_planos_de_vidro',
        label: 'Inclui planos de vidro na fachada',
        tipo: 'select',
        opcoes: ['Sim', 'Não'],
      },
      {
        campo: 'tem_brises_pergolados',
        label: 'Inclui brises ou pergolados',
        tipo: 'select',
        opcoes: ['Sim · com função de sombreamento', 'Sim · estético', 'Não'],
      },
    ],
    temFerramenta: true,
  },
]

TOPICOS_CONTENT.push(...PROJ_CONTENT_7)

const PROJ_CONTENT_8: TopicoContent[] = [
  {
    topicoId: 'proj-14',
    resumo: [
      'Os 4 componentes internos mais sensíveis ao custo são: tipo de escada, portas internas, marcenaria como acabamento e teto de madeira',
      'Escadas têm amplitude absurda: escada simples custa R$ 2–3k em estrutura; L-coidal pode chegar a R$ 150k · apenas em estrutura, sem acabamento',
      'Portas internas variam de R$ 1.000 (simples) a R$ 7–8 mil (marcenaria ou piso-teto) · com 12 portas, a escolha multiplica o impacto em R$ 80k+',
      'Marcenaria como acabamento (divisórias, painéis, portas) torna a obra dependente dela para ser concluída e cresce invisível no orçamento',
      'Teto de madeira custa em média 8x mais que o teto de gesso branco e comanda toda a paleta da obra (esquadrias, madeiras, cores)',
      'Componentes internos sofisticados têm impacto sistêmico: porta piso-teto exige forro reforçado; escada plissada exige fundação especial',
    ],
    dicasDeOuro: [
      {
        icone: '📐',
        texto:
          'Avalie o tipo de escada antes de fechar o projeto · a decisão é irreversível e pode variar em até R$ 150k somente em estrutura',
      },
      {
        icone: '🚪',
        texto:
          'Multiplique o custo de uma porta pelo total da planta antes de aprovar o projeto: com 12 portas, diferença entre simples e marcenaria ultrapassa R$ 80k',
      },
      {
        icone: '🪵',
        texto:
          'Teto de madeira define toda a paleta da obra · só confirme se já tiver escolhido esquadrias e marcenaria compatíveis, para evitar retrabalho tardio',
      },
      {
        icone: '🔧',
        texto:
          'Pergunte ao arquiteto quais componentes exigem reforço estrutural na fase de obra · mude antes de concretar, nunca depois',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Escada plissada pode consumir 9 toneladas de aço (~R$ 90k só em vergalhão) · um elemento decorativo que compromete o orçamento da obra inteira',
      },
      {
        icone: '🔗',
        texto:
          'Porta piso-teto exige forro reforçado; escada flutuante exige fundação especial · componentes internos caros têm desdobramentos estruturais invisíveis',
      },
      {
        icone: '💸',
        texto:
          'Decisões de componentes internos tomadas tarde geram retrabalho em forro, vãos e estrutura · o custo de corrigir supera o custo de decidir certo no projeto',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'proj14-cl1',
        texto:
          'Defini o tipo de escada e obtive orçamento de estrutura comparativo entre os modelos disponíveis',
      },
      {
        id: 'proj14-cl2',
        texto:
          'Calculei o custo total das portas internas multiplicando o custo unitário pelo número de portas da planta',
      },
      {
        id: 'proj14-cl3',
        texto:
          'Avaliei o escopo da marcenaria: somente armários ou também painéis de parede e divisórias',
      },
      {
        id: 'proj14-cl4',
        texto:
          'Decidi o tipo de teto (gesso ou madeira) antes de fechar esquadrias e paleta de acabamentos',
      },
      {
        id: 'proj14-cl5',
        texto:
          'Confirmei com o calculista quais escolhas de componentes internos exigem reforços estruturais na fase de obra',
      },
    ],
    metadados: [
      {
        campo: 'tipo_escada_interna',
        label: 'Tipo de escada interna',
        tipo: 'select',
        opcoes: [
          'Simples (laje reta)',
          'Espinha de peixe (viga central)',
          'Plissada / cascata',
          'L-coidal (helicoidal)',
        ],
      },
      {
        campo: 'tipo_teto_principal',
        label: 'Tipo de teto no pavimento social',
        tipo: 'select',
        opcoes: ['Gesso (padrão)', 'Madeira (8x mais caro)', 'Misto'],
      },
      {
        campo: 'escopo_marcenaria_interna',
        label: 'Escopo da marcenaria interna',
        tipo: 'select',
        opcoes: ['Só armários', 'Armários + painéis de parede', 'Armários + divisórias + portas'],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...PROJ_CONTENT_8)

const PROJ_CONTENT_9: TopicoContent[] = [
  {
    topicoId: 'proj-15',
    resumo: [
      'O projeto estrutural transforma o projeto arquitetônico em estrutura viável · o engenheiro define pilares, vigas e laje para manter a casa de pé sem vibrar além do aceitável',
      'Em 90% dos casos, o engenheiro estrutural pedirá ajustes no projeto arquitetônico · esse embate é normal e esperado no processo de compatibilização',
      'O projeto estrutural tem 3 objetivos: evitar colapso, controlar vibração (que causa trincas) e confrontar decisões estéticas antes da obra começar',
      'Trincas por falta de projeto estrutural quebram a impermeabilização · goteiras e mofo frequentemente têm origem estrutural, não no sistema de vedação',
      'Construir sem projeto estrutural pode gerar excesso de aço (custo) ou escassez (risco) · o projeto calibra os dois extremos com segurança',
      'A pessoa que conduz a compatibilização deve ser neutra e alinhada com as prioridades do dono · não puxar para estética ou para custo isoladamente',
    ],
    dicasDeOuro: [
      {
        icone: '🏗️',
        texto:
          'Quando a estrutura "passar liso" sem nenhum ajuste, desconfie · o embate entre arquiteto e engenheiro é sinal de projeto sendo bem revisado',
      },
      {
        icone: '🔍',
        texto:
          'Peça para ver o modelo 3D estrutural: ele mostra visualmente onde a laje vibra e onde está estável · é uma ferramenta de decisão, não só de cálculo',
      },
      {
        icone: '🧑‍⚖️',
        texto:
          'Defina antecipadamente quem conduz a compatibilização e com quais prioridades (estética vs. custo vs. prazo) · sem alinhamento, o processo deriva',
      },
      {
        icone: '💧',
        texto:
          'Antes de trocar impermeabilização em goteiras recorrentes, verifique fissuração estrutural · mudar a manta sem corrigir a estrutura nunca resolve',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Projeto estrutural ausente não é só risco de colapso · vibração excessiva causa fissuras que destroem a impermeabilização e geram goteiras permanentes',
      },
      {
        icone: '🔩',
        texto:
          '"Caprichar no vergalhão" sem projeto pode resultar em consumo 2x maior que o necessário · projeto estrutural otimiza custo e segurança simultaneamente',
      },
      {
        icone: '🪟',
        texto:
          'Conflitos entre pilares e janelas ou vigas e pé-direito devem ser resolvidos no papel · ajustes em obra são 5–10x mais caros que ajustes em projeto',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'proj15-cl1',
        texto:
          'Contratei um engenheiro estrutural de escritório (não o mestre de obra) para elaborar o projeto estrutural',
      },
      {
        id: 'proj15-cl2',
        texto:
          'Alinhei com o engenheiro estrutural as prioridades: custo, estética ou performance estrutural',
      },
      {
        id: 'proj15-cl3',
        texto:
          'Defini quem será responsável pela compatibilização entre projeto arquitetônico e estrutural',
      },
      {
        id: 'proj15-cl4',
        texto:
          'Revisei o modelo 3D estrutural para verificar vigas que interferem com janelas e colunas que interrompem vãos',
      },
      {
        id: 'proj15-cl5',
        texto:
          'Confirmei que lajes e vigas estão dimensionadas para controlar vibração dentro dos parâmetros normativos',
      },
    ],
    metadados: [
      {
        campo: 'engenheiro_estrutural_status',
        label: 'Engenheiro estrutural contratado',
        tipo: 'select',
        opcoes: ['Sim', 'Não · pendente', 'Em seleção'],
      },
      {
        campo: 'compatibilizacao_responsavel',
        label: 'Responsável pela compatibilização',
        tipo: 'select',
        opcoes: [
          'Escritório de arquitetura',
          'Escritório de estrutura',
          'Construtora',
          'A definir',
        ],
      },
      {
        campo: 'modelo_3d_estrutural_revisado',
        label: 'Modelo 3D estrutural já revisado',
        tipo: 'select',
        opcoes: ['Sim', 'Não · pendente'],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...PROJ_CONTENT_9)

const PROJ_CONTENT_10: TopicoContent[] = [
  {
    topicoId: 'proj-16',
    resumo: [
      'Existem 3 perfis de consumo estrutural que permitem estimar o custo de aço antes mesmo do projeto estar pronto',
      'Perfil 1 (geometria simples): ~13 kg de aço/m² e 0,30 m³ de concreto/m² · vãos pequenos, arquitetura de "caixinha" simétrica',
      'Perfil 2 (padrão condomínio): ~22 kg de aço/m² e 0,45 m³ de concreto/m² · saliências moderadas, lajes com apoio reduzido',
      'Perfil 3 (geometria arrojada): ~30 kg de aço/m² e 0,55 m³ de concreto/m² · estruturas flutuantes, balanços, pé-direito duplo, assimetria',
      'Perfil 3 consome 3x mais aço que o Perfil 1 para a mesma metragem · geometria multiplica o custo estrutural sem aumentar espaço interno',
      'Calculista inexperiente pode "socar aço" no projeto · use os perfis para questionar se o consumo previsto está compatível com a geometria real da casa',
    ],
    dicasDeOuro: [
      {
        icone: '📊',
        texto:
          'Identifique o perfil da sua casa nos primeiros 3D do arquiteto: "caixinha" = Perfil 1, saliências = Perfil 2, estruturas flutuantes = Perfil 3',
      },
      {
        icone: '🔑',
        texto:
          'O calculista "tem a chave do cofre da obra" · um calculista experiente e econômico pode reduzir o aço em 30–50% sem comprometer a segurança',
      },
      {
        icone: '📑',
        texto:
          'Quando o projeto estrutural chegar, some os quilos de aço de todas as páginas · você saberá exatamente quanto valerá o vergalhão na obra',
      },
      {
        icone: '🚩',
        texto:
          'Se a casa é de Perfil 1 e o projeto prevê >20 kg/m², peça revisão · o calculista provavelmente superdimensionou por insegurança',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Calculista inseguro pode superdimensionar o projeto em 50%+ · é comum encontrar Perfil 1 com consumo de Perfil 3 em escritórios menos experientes',
      },
      {
        icone: '🏔️',
        texto:
          'Terrenos com muro de arrimo ou fundação especial elevam o consumo de aço além dos perfis normais · separe esse custo na estimativa',
      },
      {
        icone: '💸',
        texto:
          'Geometria arrojada (Perfil 3 vs Perfil 1) pode representar R$ 130–170k adicionais em vergalhão numa obra de 200m² ao preço de R$ 10/kg',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'proj16-cl1',
        texto:
          'Classifiquei meu projeto em Perfil 1, 2 ou 3 olhando para as imagens 3D do arquiteto',
      },
      {
        id: 'proj16-cl2',
        texto:
          'Calculei o consumo estimado de aço: metragem de alvará × kg/m² do perfil identificado',
      },
      {
        id: 'proj16-cl3',
        texto:
          'Multipliquei o peso pelo preço do kg de vergalhão na minha região para estimar o custo do aço',
      },
      {
        id: 'proj16-cl4',
        texto:
          'Quando o projeto estrutural chegou, somei os kg de todas as páginas para confrontar com a estimativa de perfil',
      },
      {
        id: 'proj16-cl5',
        texto:
          'Questionei o calculista se o consumo previsto está compatível com o perfil de geometria do projeto',
      },
    ],
    metadados: [
      {
        campo: 'perfil_consumo_estrutural',
        label: 'Perfil de consumo estrutural identificado',
        tipo: 'select',
        opcoes: [
          'Perfil 1 · ~13 kg/m² (simples)',
          'Perfil 2 · ~22 kg/m² (condomínio)',
          'Perfil 3 · ~30 kg/m² (arrojado)',
        ],
      },
      {
        campo: 'consumo_aco_estimado_kg',
        label: 'Consumo estimado de aço (kg)',
        tipo: 'number',
        placeholder: 'Ex: 3250',
      },
      {
        campo: 'preco_aco_kg_rs',
        label: 'Preço do kg de vergalhão na região (R$)',
        tipo: 'number',
        placeholder: 'Ex: 10',
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...PROJ_CONTENT_10)

const PROJ_CONTENT_11: TopicoContent[] = [
  {
    topicoId: 'proj-17',
    resumo: [
      'Projetos de instalações devem ser feitos após o projeto de interiores · assim tomadas, interruptores e pontos hidráulicos nascem alinhados com o mobiliário',
      'Na elétrica, o principal risco é a "entrada de energia" superdimensionada: chave e cabeamento da rua ao quadro interno podem custar R$ 20–30k a mais desnecessariamente',
      'O quadro elétrico interno deve ter ~50% de espaço livre para expansões futuras · ar-condicionado, circuitos novos e ampliações sempre chegam',
      'O projeto hidráulico é o mais abandonado · "o pedreiro sabe passar cano" resulta em problemas de pressão e mal cheiro recorrentes',
      'Mal cheiro de esgoto é quase sempre falha de projeto hidráulico mal calculado · o gás da rua entra pelos sifões secos por falta de ventilação (suspiro)',
      'O "fecho hídrico" (água nos sifões) é a barreira contra o gás de esgoto · sem suspiro adequado ele seca e o cheiro penetra em toda a casa',
    ],
    dicasDeOuro: [
      {
        icone: '📐',
        texto:
          'Feche o projeto de interiores antes de solicitar instalações · tomadas e pontos hidráulicos na posição certa custam zero; mover depois custa caro',
      },
      {
        icone: '⚡',
        texto:
          'Questione o projetista elétrico o critério da entrada de energia · se a justificativa for "pico máximo simultâneo", peça revisão do cálculo',
      },
      {
        icone: '🔌',
        texto:
          'Reserve 50% de espaço vazio no quadro elétrico interno para expansões futuras · ar-condicionado, novas suítes e carregadores EV sempre chegam',
      },
      {
        icone: '🚿',
        texto:
          'Exija projeto hidráulico assinado por engenheiro e verifique se o sistema de suspiro está previsto em todos os banheiros e áreas molhadas',
      },
    ],
    atencao: [
      {
        icone: '🦨',
        texto:
          'Mal cheiro de esgoto é quase sempre problema de projeto hidráulico mal feito · o gás da rua entra pelos sifões secos por falta de ventilação adequada',
      },
      {
        icone: '⚡',
        texto:
          'Superdimensionar a entrada de energia pode custar R$ 20–30k a mais sem nenhum benefício real · questione antes de aprovar o projeto elétrico',
      },
      {
        icone: '🔧',
        texto:
          'Hidráulica feita pelo pedreiro resulta em pressões incorretas e reformas caras · o pedreiro não substitui o engenheiro de instalações hidráulicas',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'proj17-cl1',
        texto:
          'Fechei o projeto de interiores antes de solicitar os projetos elétrico e hidráulico',
      },
      {
        id: 'proj17-cl2',
        texto:
          'Revisei a memória de cálculo da entrada de energia e questionei o projetista sobre o critério de dimensionamento',
      },
      {
        id: 'proj17-cl3',
        texto:
          'Confirmei que o quadro elétrico interno tem pelo menos 50% de espaço livre para expansão futura',
      },
      {
        id: 'proj17-cl4',
        texto:
          'Verifiquei se o projeto hidráulico inclui sistema de ventilação (suspiro) para todos os pontos de esgoto',
      },
      {
        id: 'proj17-cl5',
        texto:
          'Confirmei que o projeto hidráulico foi elaborado por engenheiro, não delegado ao mestre de obra',
      },
    ],
    metadados: [
      {
        campo: 'projeto_eletrico_status',
        label: 'Status do projeto elétrico',
        tipo: 'select',
        opcoes: ['Contratado e aprovado', 'Em elaboração', 'Pendente'],
      },
      {
        campo: 'projeto_hidraulico_status',
        label: 'Status do projeto hidráulico',
        tipo: 'select',
        opcoes: ['Contratado e aprovado', 'Em elaboração', 'Pendente · risco'],
      },
      {
        campo: 'quadro_eletrico_folga_perc',
        label: 'Folga prevista no quadro elétrico (%)',
        tipo: 'number',
        placeholder: 'Ex: 50',
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...PROJ_CONTENT_11)

const PROJ_EXTRA_CONTENT: TopicoContent[] = [
  {
    topicoId: 'proj-06',
    resumo: [
      'Cada metro quadrado extra no projeto representa custo adicional em fundação, estrutura, cobertura e acabamento',
      'Calcular a área de piso por ambiente antes de comprar evita desperdício e viagens extras à loja',
      'Adicione sempre 10% ao total calculado para cobrir perdas no corte, quebras e rejunte',
      'Ambientes com formatos irregulares (L, U) geram mais perda · considere 12–15% nesses casos',
      'Definir os materiais de piso antes do contrapiso permite ajustar o nível sem retrabalho',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto:
          'Compre toda a cerâmica de um lote só · diferenças de tonalidade entre lotes são comuns e visíveis',
      },
      {
        icone: '💡',
        texto: 'Guarde caixas sobressalentes para trocar peças danificadas no futuro',
      },
      {
        icone: '💡',
        texto:
          'Porcelanatos de grande formato (90×90 ou 120×120) geram mais perda · peça ao fornecedor a porcentagem de desperdício padrão',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Nunca compre pelo mínimo · falta de material no meio da obra causa atrasos e diferenças de tonalidade',
      },
      {
        icone: '⚠️',
        texto: 'Peças cortadas em diagonal ou em diagonal dupla geram até 25% de desperdício',
      },
    ],
    checklistAplicabilidade: [
      { id: 'p06-cl1', texto: 'Medi a área de todos os ambientes que receberão piso' },
      { id: 'p06-cl2', texto: 'Adicionei a margem de perda (mínimo 10%)' },
      { id: 'p06-cl3', texto: 'Verifiquei e anotei o número do lote das peças' },
      { id: 'p06-cl4', texto: 'Guardei caixas sobressalentes para reposição futura' },
    ],
    metadados: [
      {
        campo: 'tipo_piso',
        label: 'Material de Piso Escolhido',
        tipo: 'select',
        opcoes: [
          'Porcelanato',
          'Cerâmica',
          'Piso vinílico',
          'Mármore / Granito',
          'Madeira',
          'Concreto polido',
          'Outro',
        ],
      },
      {
        campo: 'area_total',
        label: 'Área total calculada (m²)',
        tipo: 'number',
        placeholder: 'Resultado da calculadora',
      },
      {
        campo: 'qtd_compra',
        label: 'Quantidade a comprar (+10%) m²',
        tipo: 'number',
        placeholder: 'Total com perda',
      },
    ],
    temFerramenta: true,
  },
  {
    topicoId: 'proj-08',
    resumo: [
      'A área constante no alvará nem sempre corresponde à área real da construção para fins tributários',
      'Varandas cobertas, piscinas e terraços sobre laje entram no cálculo com fatores de equivalência',
      'O SERO (Cálculo de Aferição) usa a área equivalente para estimar o custo mínimo da obra e o INSS devido',
      'Subestimar a área equivalente expõe o proprietário a autuações e multas na averbação',
      'O fator de cada elemento varia: coberto = 100%, descoberto sobre laje = 50%, jardim em piso natural = 10%',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto:
          'Calcule a área equivalente antes de fechar o orçamento · ela impacta o INSS a recolher',
      },
      {
        icone: '💡',
        texto:
          'Documente cada área com foto e medição · facilita a vistoria da CEF e da prefeitura',
      },
      {
        icone: '💡',
        texto:
          'Use a calculadora para comparar cenários antes de definir o projeto arquitetônico final',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Divergência entre área real e área declarada pode gerar IR sobre ganho de capital elevado na venda',
      },
      {
        icone: '⚠️',
        texto:
          'Varandas fechadas com vidro ou veneziana são computadas como área coberta integral · 100%',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'p08-cl1',
        texto: 'Identifiquei todas as áreas adicionais (varandas, piscina, terraços)',
      },
      { id: 'p08-cl2', texto: 'Calculei a área equivalente total para o SERO' },
      { id: 'p08-cl3', texto: 'Confirmei os fatores com o engenheiro responsável' },
    ],
    metadados: [
      {
        campo: 'area_alvara',
        label: 'Área do Alvará (m²)',
        tipo: 'number',
        placeholder: 'Ex: 180',
      },
      {
        campo: 'area_equivalente',
        label: 'Área equivalente total (m²)',
        tipo: 'number',
        placeholder: 'Resultado da calculadora',
      },
    ],
    temFerramenta: true,
  },
  {
    topicoId: 'proj-11',
    resumo: [
      'O consumo de aço varia muito conforme a geometria do projeto · casas simples consomem muito menos que casas com balanços e vãos grandes',
      'Cada elemento estrutural fora do padrão cúbico básico adiciona de 10% a 25% no consumo de aço',
      'Vãos acima de 5 m são os maiores vilões: exigem vigas e pilares superdimensionados',
      'Assimetria entre andares (paredes sobre vazio) obriga vigas de transição · custo muito alto',
      'O engenheiro estrutural pode propor alternativas que reduzem o consumo sem mudar a estética',
    ],
    dicasDeOuro: [
      {
        icone: '💡',
        texto:
          'Discuta o impacto estrutural de cada elemento antes de aprovar o anteprojeto arquitetônico',
      },
      {
        icone: '💡',
        texto:
          'Uma pequena mudança de 50 cm no posicionamento de uma parede pode eliminar a necessidade de uma viga de transição cara',
      },
      {
        icone: '💡',
        texto:
          'Peça ao estrutural uma comparação de consumo de aço entre 2 alternativas de projeto',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Projetos com muitos elementos "especiais" podem ter custo estrutural 50–80% maior que uma planta simples de mesma área',
      },
      {
        icone: '⚠️',
        texto:
          'Não altere paredes estruturais após concretagem · modificações exigem projeto de reforço e são caras',
      },
    ],
    checklistAplicabilidade: [
      { id: 'p11-cl1', texto: 'Identifiquei todos os elementos de geometria complexa no projeto' },
      {
        id: 'p11-cl2',
        texto: 'Discuti o impacto estrutural com o arquiteto antes de aprovar o anteprojeto',
      },
      { id: 'p11-cl3', texto: 'Obtive estimativa de consumo de aço do engenheiro estrutural' },
      { id: 'p11-cl4', texto: 'Comparei custo estrutural entre alternativas de projeto' },
    ],
    metadados: [
      {
        campo: 'aco_base_kg',
        label: 'Consumo base de aço (kg)',
        tipo: 'number',
        placeholder: 'Ex: 8000',
      },
      {
        campo: 'aco_final_kg',
        label: 'Estimativa com a geometria (kg)',
        tipo: 'number',
        placeholder: 'Resultado da calculadora',
      },
    ],
    temFerramenta: true,
  },
]

TOPICOS_CONTENT.push(...PROJ_EXTRA_CONTENT)

// ─── Módulo 5 · Mão de Obra ───────────────────────────────────────────────
const MDO_CONTENT_01: TopicoContent[] = [
  {
    topicoId: 'mdo-01',
    resumo: [
      'Mão de obra é a 5ª fase: só contrate após sistema construtivo e projetos fechados',
      'Todo reajuste contratual sobe · você nunca reduz o combinado proporcionalmente',
      'Contrato é tudo combinado: verbal, escrito ou digital · forma jurídica define custo e risco',
      'MEI, autônomo ou empreiteira: o arranjo jurídico impacta diretamente custo, risco e INSS',
      'Travas de pagamento por etapa evitam pagar indefinidamente sem contrapartida real',
      'Garantias pós-obra são críticas · elétrica, hidráulica e impermeabilização só se provam no uso',
      'Economizar R$ 15–100k em mão de obra não exige mudar a casa · só o arranjo do contrato',
    ],
    dicasDeOuro: [
      {
        icone: '🔒',
        texto:
          'Feche sistema construtivo e todos os projetos antes de negociar mão de obra · qualquer mudança depois sempre custa mais',
      },
      {
        icone: '📋',
        texto:
          'Inclua no combinado: pagamentos, entregas intermediárias e garantias · funciona até com trabalhador informal',
      },
      {
        icone: '⚖️',
        texto:
          'Avalie o arranjo jurídico (MEI, autônomo, empreiteira) antes de assinar · impacta custo, risco e INSS de forma significativa',
      },
      {
        icone: '🔐',
        texto:
          'Exija cláusulas de garantia pós-obra · sistemas novos só revelam falhas após meses de uso real',
      },
    ],
    atencao: [
      {
        icone: '💸',
        texto:
          'Orçar mão de obra com apenas o projeto arquitetônico pronto gera contrato defasado · estrutural e instalações mudam o valor final',
      },
      {
        icone: '🚫',
        texto:
          'Iniciar a obra antes de fechar o contrato completo expõe você a renegociações sempre a seu prejuízo',
      },
      {
        icone: '📉',
        texto:
          'Reduzir escopo após assinar o contrato nunca resulta em redução proporcional · o empreiteiro sempre fica com a margem',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'mdo-01-cl1',
        texto:
          'Confirmei que o sistema construtivo está definido antes de iniciar qualquer negociação de mão de obra',
      },
      {
        id: 'mdo-01-cl2',
        texto:
          'Confirmei que os projetos arquitetônico, estrutural e de instalações estão completos e aprovados',
      },
      {
        id: 'mdo-01-cl3',
        texto:
          'Calculei o orçamento máximo disponível para mão de obra antes de sentar à mesa de negociação',
      },
      {
        id: 'mdo-01-cl4',
        texto:
          'Pesquisei os arranjos jurídicos disponíveis na minha região (empreitada, administração, autônomos)',
      },
      {
        id: 'mdo-01-cl5',
        texto:
          'Incluí no combinado cláusulas de garantia pós-obra e entregas intermediárias verificáveis',
      },
      {
        id: 'mdo-01-cl6',
        texto: 'Estabeleci travas de pagamento vinculadas a marcos de obra mensuráveis',
      },
    ],
    metadados: [
      {
        campo: 'status_projetos_mdo',
        label: 'Status dos projetos antes de contratar MO',
        tipo: 'select',
        opcoes: [
          'Todos prontos e aprovados',
          'Estrutural pendente',
          'Instalações pendentes',
          'Apenas arquitetônico pronto',
        ],
      },
      {
        campo: 'tipo_contratacao_mdo',
        label: 'Tipo de contratação planejada',
        tipo: 'select',
        opcoes: ['Empreitada total', 'Empreitada parcial', 'Administração de obra', 'Misto'],
      },
      {
        campo: 'orcamento_mdo_rs',
        label: 'Orçamento máximo para mão de obra (R$)',
        tipo: 'number',
        placeholder: 'Ex: 85000',
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...MDO_CONTENT_01)

const MDO_CONTENT_02: TopicoContent[] = [
  {
    topicoId: 'mdo-02',
    resumo: [
      'Mão de obra representa ~40% do custo total · travar esse bloco antes da obra é a estratégia central',
      'Contratos estouram por dois motivos: escopo vago ou pagamento descolado do avanço real da obra',
      'Um contrato com lacunas será rediscutido na obra · sempre a seu prejuízo, nunca ao seu favor',
      'Escreva o que está incluído E o que não está · clareza elimina aditivos surpresa no futuro',
      'Alterações de escopo no meio da obra custam 5× mais do que se planejadas antes de começar',
      'Pagar além do entregue cria armadilha: no final haverá muita obra e pouco pagamento restante',
      'Contratos bem travados ficam em 5–10% de aditivos; contratos frouxos explodem em 47–65%',
    ],
    dicasDeOuro: [
      {
        icone: '🔒',
        texto:
          'Escreva o contrato em linguagem simples listando o que inclui E o que não inclui · zonas cinzentas viram aditivos caros',
      },
      {
        icone: '📊',
        texto:
          'Monitore ritmo de obra × pagamento semanalmente · não libere parcela além do percentual físico já entregue',
      },
      {
        icone: '🚫',
        texto:
          'Congele o escopo antes de assinar · cada mudança no meio da obra vira diária disfarçada de aditivo e eleva o custo de forma desproporcional',
      },
      {
        icone: '📝',
        texto:
          'Desconfie de contratos curtos · um bom contrato é detalhado, cobre todos os cenários e pode ter 8 ou mais páginas',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          '10% de serviços adicionais pode custar 50% a mais em dinheiro · o empreiteiro embute ineficiência e risco nas mudanças de rota',
      },
      {
        icone: '💸',
        texto:
          'Quando o pagamento avança mais do que a obra, você perde poder de negociação · no final ele tem mais serviço a fazer e você tem menos dinheiro disponível',
      },
      {
        icone: '🔄',
        texto:
          'Mudanças de acabamento durante a obra geram aditivos desproporcionais · trocar pastilha por pedra pode custar 65% a mais do contrato inicial',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'mdo-02-cl1',
        texto:
          'Calculei que mão de obra representa ~40% do orçamento e planejei travar esse valor antes de iniciar',
      },
      {
        id: 'mdo-02-cl2',
        texto:
          'Revisei o contrato para eliminar lacunas · inclui explicitamente o que está E o que não está no escopo',
      },
      {
        id: 'mdo-02-cl3',
        texto:
          'Fechei o escopo completo da obra antes de assinar · sem itens "a definir durante a construção"',
      },
      {
        id: 'mdo-02-cl4',
        texto:
          'Estabeleci cronograma de pagamentos vinculado a entregas verificáveis, não a datas fixas',
      },
      {
        id: 'mdo-02-cl5',
        texto:
          'Defini limite máximo de aditivos (ex: 5%) e incluí essa cláusula na negociação com o empreiteiro',
      },
      {
        id: 'mdo-02-cl6',
        texto: 'Monitorei semanalmente o percentual pago versus o avanço físico real da obra',
      },
    ],
    metadados: [
      {
        campo: 'valor_contrato_mo_rs',
        label: 'Valor do contrato de mão de obra (R$)',
        tipo: 'number',
        placeholder: 'Ex: 180000',
      },
      {
        campo: 'perc_mo_orcamento',
        label: 'MO como % do orçamento total (%)',
        tipo: 'number',
        placeholder: 'Ex: 40',
      },
      {
        campo: 'limite_aditivo_perc',
        label: 'Limite de aditivo acordado (%)',
        tipo: 'number',
        placeholder: 'Ex: 5',
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...MDO_CONTENT_02)

const MDO_CONTENT_03: TopicoContent[] = [
  {
    topicoId: 'mdo-03',
    resumo: [
      'O GPS da contratação é um mapa de decisão para escolher o modelo certo de contratar mão de obra',
      'Empreitada total: empreiteiro compra material e executa · uma nota só, mas o custo triangula',
      'Empreitada parcial: você compra o material (NF no seu nome) e o empreiteiro executa só a mão de obra',
      'Dinheiro que triangula encarece · cada intermediário adiciona sua margem sobre o custo real',
      'Empreitada parcial sai em média 20–25% mais barata que a total e com menos riscos embutidos',
      'Na empreitada total o INSS recai obrigatoriamente sobre a construtora; na parcial é negociável',
    ],
    dicasDeOuro: [
      {
        icone: '🗺️',
        texto:
          'Use o GPS de contratação para decidir o modelo antes de falar com qualquer empreiteiro · a escolha define custo, risco e INSS',
      },
      {
        icone: '🧾',
        texto:
          'Na empreitada parcial exija NF de material no seu nome · isso prova propriedade do material e elimina risco de desvio',
      },
      {
        icone: '💰',
        texto:
          'Quanto menos intermediários entre você e o custo real, mais enxuto fica o orçamento · empreitada parcial é sempre mais econômica',
      },
      {
        icone: '⚖️',
        texto:
          'Empreitada total vale a pena quando você não tem tempo para gerenciar múltiplos contratos · o conforto tem custo de 20–25% a mais',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Material com NF no nome do empreiteiro não é seu legalmente · se ele sumir antes de entregar, você perde o material',
      },
      {
        icone: '💸',
        texto:
          'Na empreitada total o empreiteiro cobra pelos subempreiteiros com sua margem por cima · o dinheiro triangula e encarece',
      },
      {
        icone: '📋',
        texto:
          'Na empreitada parcial não deixe o INSS em aberto · defina no contrato quem paga, ou você pode ser surpreendido na averbação',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'mdo-03-cl1',
        texto:
          'Rodei o GPS de contratação e defini o modelo (total, parcial, administração) antes de contatar empreiteiros',
      },
      {
        id: 'mdo-03-cl2',
        texto:
          'Calculei a diferença de custo estimada entre empreitada total e parcial para a minha obra',
      },
      {
        id: 'mdo-03-cl3',
        texto:
          'Avaliei se tenho disponibilidade para gerenciar múltiplos contratos (requisito da empreitada parcial)',
      },
      {
        id: 'mdo-03-cl4',
        texto: 'Confirmei que as NFs de material virão no meu nome na empreitada parcial',
      },
      {
        id: 'mdo-03-cl5',
        texto: 'Negociei explicitamente quem arca com o INSS e registrei isso no contrato',
      },
      {
        id: 'mdo-03-cl6',
        texto: 'Entendi o impacto do modelo escolhido no custo total e no risco jurídico da obra',
      },
    ],
    metadados: [
      {
        campo: 'modelo_contratacao_mdo',
        label: 'Modelo de contratação escolhido',
        tipo: 'select',
        opcoes: ['Empreitada total', 'Empreitada parcial', 'Administração de obra', 'Misto'],
      },
      {
        campo: 'custo_material_rs',
        label: 'Custo previsto de material (R$)',
        tipo: 'number',
        placeholder: 'Ex: 60000',
      },
      {
        campo: 'custo_mdo_contrato_rs',
        label: 'Custo do contrato de MO (R$)',
        tipo: 'number',
        placeholder: 'Ex: 70000',
      },
      {
        campo: 'responsavel_inss',
        label: 'Responsável pelo INSS',
        tipo: 'select',
        opcoes: ['Empreiteiro', 'Dono da obra', 'Dividido', 'A definir'],
      },
    ],
    temFerramenta: true,
  },
]

TOPICOS_CONTENT.push(...MDO_CONTENT_03)

const MDO_CONTENT_04: TopicoContent[] = [
  {
    topicoId: 'mdo-04',
    resumo: [
      'Empreitada total inclui material e mão de obra num único CNPJ · custo 60–70% acima do preço real',
      'Todo material comprado na empreitada total fica no nome do CNPJ · se ele falir, nada é seu',
      'O imposto incide sobre o valor total da nota (material + MO juntos) · não sobre o lucro do empreiteiro',
      'Margem abaixo de 30% indica empreiteiro estrangulado · risco de pirâmide e abandono no meio da obra',
      'O empreiteiro embute margem sobre material, reajustes futuros e riscos de quantidade na proposta',
      'CNPJ não consegue materiais mais baratos · com boa condição de pagamento você negocia o mesmo preço',
    ],
    dicasDeOuro: [
      {
        icone: '🏗️',
        texto:
          'Exija margem saudável do empreiteiro (~30%): pagar o preço justo evita que ele abandone a obra no meio para pagar dívidas de outros canteiros',
      },
      {
        icone: '🧾',
        texto:
          'Calcule o preço real (material + MO direto) e compare com o orçamento de empreitada total · diferença acima de 70% é sinal de conta inflada',
      },
      {
        icone: '🔍',
        texto:
          'Pesquise quantas obras o empreiteiro gerencia simultaneamente · mais de 3 simultâneas com margem baixa é sinal de pirâmide',
      },
      {
        icone: '📋',
        texto:
          'Se escolher empreitada total, inclua cláusula de auditoria periódica dos materiais comprados para confirmar que estão sendo adquiridos',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Material no nome do CNPJ não é seu · se a empresa falir ou a relação azedar, você perde tudo que está estocado no canteiro',
      },
      {
        icone: '💸',
        texto:
          'Empreiteiro estrangulado (margem < 20%) usa a entrada da sua obra para quitar dívidas de obras anteriores · pirâmide clássica',
      },
      {
        icone: '📊',
        texto:
          'O imposto incide sobre o valor total da NF (material + MO), não sobre o lucro · isso eleva drasticamente o custo final da empreitada total',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'mdo-04-cl1',
        texto:
          'Calculei o preço real da obra (material + MO direto) e comparei com o orçamento de empreitada total',
      },
      {
        id: 'mdo-04-cl2',
        texto:
          'Verifiquei que a margem do empreiteiro está em torno de 30% antes de fechar qualquer acordo',
      },
      {
        id: 'mdo-04-cl3',
        texto:
          'Pesquisei quantas obras o empreiteiro conduz simultaneamente · evitei quem está com muitas frentes abertas',
      },
      {
        id: 'mdo-04-cl4',
        texto:
          'Avaliei o risco jurídico de ter material em nome do CNPJ em caso de falência ou desentendimento',
      },
      {
        id: 'mdo-04-cl5',
        texto:
          'Comparei empreitada total com empreitada parcial e decidi se o conforto operacional justifica o custo extra',
      },
      {
        id: 'mdo-04-cl6',
        texto:
          'Confirmei que o empreiteiro consegue NF separada de material e de mão de obra se necessário',
      },
    ],
    metadados: [
      {
        campo: 'custo_real_obra_rs',
        label: 'Preço de custo real da obra (R$)',
        tipo: 'number',
        placeholder: 'Ex: 100000',
      },
      {
        campo: 'orcamento_empreitada_total_rs',
        label: 'Orçamento empreitada total recebido (R$)',
        tipo: 'number',
        placeholder: 'Ex: 170000',
      },
      {
        campo: 'margem_empreiteiro_perc',
        label: 'Margem estimada do empreiteiro (%)',
        tipo: 'number',
        placeholder: 'Ex: 30',
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...MDO_CONTENT_04)

const MDO_CONTENT_05: TopicoContent[] = [
  {
    topicoId: 'mdo-05',
    resumo: [
      'Empreitada parcial: você compra o material (NF no seu nome) e o empreiteiro executa só a mão de obra',
      'Pagar por diária ou mensalidade é o pior modelo · você assume 100% do risco sem garantia de entrega',
      'Divida em 4–5 contratos por especialidade · elétrica, hidráulica, pintura e pedreiro em duas etapas',
      'Nunca hiperfragmente (contrato por fase) nem faça um contratão · a lógica ideal fica no meio-termo',
      'Pague sempre por avanço de obra, nunca por período · isso alinha incentivos e trava o valor',
      'Retenha 3–5% no final do contrato para garantir que o empreiteiro volte resolver pendências',
      'INSS deve constar explicitamente no contrato · deixar em aberto gera surpresas de R$ 15–40k no final',
    ],
    dicasDeOuro: [
      {
        icone: '📋',
        texto:
          'Divida o contrato em especialidades (elétrica, hidráulica, pintura, pedreiro) · misturar tudo cria um monstro ingerenciável',
      },
      {
        icone: '🔒',
        texto:
          'Quebre o pedreiro em fase grossa e acabamento · isso cria um ponto natural para avaliar e, se necessário, trocar o profissional sem drama',
      },
      {
        icone: '💰',
        texto:
          'Retenha R$ 3–5k ao final de cada contrato · é o único incentivo que garante o retorno do empreiteiro para resolver os pendentes finais',
      },
      {
        icone: '📊',
        texto:
          'Marque checkpoints em 50%, 70% e 95%: no 70% programe a finalização, no 95% ative a retenção e alinhe os últimos entregáveis',
      },
    ],
    atencao: [
      {
        icone: '⏱️',
        texto:
          'Contratar por diária ou mensalidade é obra sem controle · o empreiteiro ganha mais quando a obra anda devagar',
      },
      {
        icone: '🔗',
        texto:
          'Empreiteiro que "dominou" a obra (fundação e estrutura feitas) cobra mais nas etapas seguintes porque sabe que você não vai trocá-lo',
      },
      {
        icone: '📋',
        texto:
          'INSS não mencionado no contrato vira litígio: R$ 15–40k em aberto ao final da obra, sem definição de responsabilidade',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'mdo-05-cl1',
        texto:
          'Defini o modelo de contratação como empreitada por escopo · descartei diária, mensalidade e CLT',
      },
      {
        id: 'mdo-05-cl2',
        texto:
          'Separei a obra em 4–5 contratos por especialidade (elétrica, hidráulica, pintura, pedreiro fase grossa, pedreiro acabamento)',
      },
      {
        id: 'mdo-05-cl3',
        texto:
          'Defini pagamentos por avanço com marcos verificáveis · sem datas fixas nem pagamento por tempo decorrido',
      },
      {
        id: 'mdo-05-cl4',
        texto:
          'Programei checkpoints em 50%, 70% e 95% da obra para revisão de ritmo e planejamento de finalização',
      },
      {
        id: 'mdo-05-cl5',
        texto:
          'Retive 3–5% do valor de cada contrato para quitação somente após conclusão completa dos pendentes',
      },
      {
        id: 'mdo-05-cl6',
        texto: 'Incluí explicitamente no contrato quem é responsável pelo pagamento do INSS',
      },
    ],
    metadados: [
      {
        campo: 'num_contratos_obra',
        label: 'Número de contratos por especialidade',
        tipo: 'number',
        placeholder: 'Ex: 4',
      },
      {
        campo: 'valor_retencao_final_rs',
        label: 'Valor de retenção final por contrato (R$)',
        tipo: 'number',
        placeholder: 'Ex: 5000',
      },
      {
        campo: 'inss_no_contrato',
        label: 'INSS está definido no contrato?',
        tipo: 'select',
        opcoes: [
          'Sim · responsabilidade do empreiteiro',
          'Sim · responsabilidade do dono',
          'Sim · dividido',
          'Não · pendente de definição',
        ],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...MDO_CONTENT_05)

const MDO_CONTENT_06: TopicoContent[] = [
  {
    topicoId: 'mdo-06',
    resumo: [
      'Obra por ADM separa material, mão de obra e gestão · ninguém apura margem sobre a sua construção',
      'O administrador cobra ~10% sobre o custo total como honorário fixo · não uma margem de lucro',
      'Custo comparado: empreitada total = 170%, parcial = 130%, administração = 110% do preço real',
      'Fixe o honorário como valor fechado (não % variável) · % variável incentiva o admin a gastar mais',
      'Ideal para obras de alto padrão e alta complexidade onde orçar com precisão é muito difícil',
      'Na garantia pós-obra você aciona o executor diretamente · o admin coordena sem custo adicional',
    ],
    dicasDeOuro: [
      {
        icone: '🏗️',
        texto:
          'Use obra por ADM em obras de médio-alto padrão · a economia versus empreitada total pode passar de R$ 200k em obras de R$ 1M',
      },
      {
        icone: '🔒',
        texto:
          'Combine o honorário como valor fixo fechado · honorário em % variável incentiva o administrador a aumentar o custo da obra para ganhar mais',
      },
      {
        icone: '📋',
        texto:
          'Defina explicitamente quais itens entram no cálculo do honorário · marcenaria de R$ 300k a 10% já representa R$ 30k só de gestão',
      },
      {
        icone: '📞',
        texto:
          'Na pós-obra acione diretamente o executor do serviço com defeito · o admin coordena a resolução sem custo adicional para você',
      },
    ],
    atencao: [
      {
        icone: '⚖️',
        texto:
          'Na obra por ADM você tem vínculo jurídico direto com cada trabalhador · qualquer problema trabalhista chega até você sem guarda-chuva corporativo',
      },
      {
        icone: '💡',
        texto:
          'Honorário como % do custo cria conflito de interesse real · o admin que ganha 10% de R$ 1M tem incentivo embutido para gastar esse R$ 1M',
      },
      {
        icone: '🏠',
        texto:
          'Obras simples de baixo padrão não se beneficiam da ADM · o overhead de gerenciar múltiplos contratos diretos não compensa a economia',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'mdo-06-cl1',
        texto:
          'Avaliei se minha obra tem complexidade e padrão suficientes para justificar obra por administração',
      },
      {
        id: 'mdo-06-cl2',
        texto:
          'Negociei o honorário do administrador como valor fixo fechado · não como percentual variável sobre o custo',
      },
      {
        id: 'mdo-06-cl3',
        texto:
          'Defini explicitamente quais categorias de custo entram no cálculo do honorário (marcenaria, automação, etc.)',
      },
      {
        id: 'mdo-06-cl4',
        texto:
          'Compreendi que terei vínculo jurídico direto com cada equipe especializada e avaliei o risco trabalhista',
      },
      {
        id: 'mdo-06-cl5',
        texto:
          'Confirmei que o administrador coordenará garantias e manutenções pós-obra como parte do serviço',
      },
      {
        id: 'mdo-06-cl6',
        texto:
          'Comparei o custo de ADM com empreitada parcial e verifiquei se a economia justifica a escolha',
      },
    ],
    metadados: [
      {
        campo: 'modelo_honorario_adm',
        label: 'Modelo de honorário do administrador',
        tipo: 'select',
        opcoes: [
          'Valor fixo fechado',
          '% sobre custo total',
          '% por fase diferenciado',
          'Mensalidade fixa',
        ],
      },
      {
        campo: 'percentual_honorario',
        label: 'Percentual de honorário acordado (%)',
        tipo: 'number',
        placeholder: 'Ex: 10',
      },
      {
        campo: 'valor_honorario_fixo_rs',
        label: 'Valor fixo do honorário (R$)',
        tipo: 'number',
        placeholder: 'Ex: 100000',
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...MDO_CONTENT_06)

const MDO_CONTENT_07: TopicoContent[] = [
  {
    topicoId: 'mdo-07',
    resumo: [
      'Cláusulas vagas são cheques em branco · 90% dos conflitos de obra têm origem em itens mal definidos',
      'Escopo sem medidas claras dá margem ao empreiteiro para cobrar como extra o que você considerava incluso',
      'INSS não mencionado no contrato é dívida silenciosa · pode chegar como surpresa de R$ 15–40k no final',
      'Expressões como "serviços correlatos" ou "inclusive" sem lista específica viram fonte de cobrança extra',
      'Contrato sem multa por atraso é prazo sem força · o empreiteiro não tem custo financeiro ao atrasar',
      'Retenção de garantia não definida elimina seu poder de exigir reparos pós-entrega da obra',
    ],
    dicasDeOuro: [
      {
        icone: '📝',
        texto:
          'Liste explicitamente o que ESTÁ e o que NÃO ESTÁ incluído · ambiguidade custa mais do que páginas a mais de contrato',
      },
      {
        icone: '🚫',
        texto:
          'Substitua "inclusive" e "serviços correlatos" por itens enumerados com medida · expressões genéricas valem o que o empreiteiro decidir',
      },
      {
        icone: '⏰',
        texto:
          'Inclua multa por atraso com valor fixo definido · sem custo financeiro, prazo é apenas uma sugestão',
      },
      {
        icone: '🔐',
        texto:
          'Defina retenção de garantia (valor + prazo em meses) antes de assinar · é o único seguro pós-entrega que você tem',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'INSS ausente do contrato = litígio garantido no final · pode chegar como guia de R$ 15–40k que você não sabia que existia',
      },
      {
        icone: '📋',
        texto:
          '"Conforme projeto" sem identificar a versão é perigoso · o empreiteiro pode usar uma revisão desatualizada como referência',
      },
      {
        icone: '💸',
        texto:
          'Pagamento adiantado sem marco de entrega vinculado elimina seu poder de negociação no meio da obra',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'mdo-07-cl1',
        texto:
          'Verifiquei que o escopo lista todos os serviços com medidas · sem "inclusive" nem "correlatos" genéricos',
      },
      {
        id: 'mdo-07-cl2',
        texto:
          'Confirmei que o INSS está explicitamente atribuído a uma das partes · sem deixar em aberto',
      },
      {
        id: 'mdo-07-cl3',
        texto: 'Incluí prazo definido com multa por atraso e valor específico de penalidade',
      },
      {
        id: 'mdo-07-cl4',
        texto: 'Defini o valor e o prazo de retenção de garantia pós-entrega antes de assinar',
      },
      {
        id: 'mdo-07-cl5',
        texto:
          'Especifiquei qual revisão do projeto é a referência · nenhum "conforme projeto" sem versão identificada',
      },
      {
        id: 'mdo-07-cl6',
        texto:
          'Revisei se há pagamentos antecipados sem marco de entrega vinculado e eliminei esse risco',
      },
    ],
    metadados: [
      {
        campo: 'status_revisao_contrato',
        label: 'Status de revisão do contrato',
        tipo: 'select',
        opcoes: [
          'Revisado e ajustado',
          'Em revisão',
          'Pendente de revisão',
          'Assinado sem revisão',
        ],
      },
      {
        campo: 'tem_multa_atraso',
        label: 'Contrato inclui multa por atraso?',
        tipo: 'select',
        opcoes: ['Sim · valor definido', 'Não · a incluir', 'A definir'],
      },
      {
        campo: 'prazo_garantia_meses',
        label: 'Prazo de garantia pós-entrega (meses)',
        tipo: 'number',
        placeholder: 'Ex: 12',
      },
    ],
    temFerramenta: true,
  },
]

TOPICOS_CONTENT.push(...MDO_CONTENT_07)

const MDO_CONTENT_08: TopicoContent[] = [
  {
    topicoId: 'mdo-08',
    resumo: [
      'Pagar 70% quando só 40% da obra está feita cria uma armadilha sem saída para ambos os lados',
      'Empreiteiro com pouco a receber e muita obra pendente abandona ou reduz a equipe ao mínimo',
      'O miolo da obra parece rápido (paredes subindo) mas é barato · é onde pagamentos se descolam',
      'Nunca vincule pagamento a datas fixas · vincule a marcos de entrega verificáveis e específicos',
      'Cada marco do contrato deve ter: nome da tarefa, percentual do contrato e valor em reais',
      'Empreiteiro que rejeita pagamento por avanço sinaliza que planeja receber antes de entregar',
    ],
    dicasDeOuro: [
      {
        icone: '📊',
        texto:
          'Desenhe com o empreiteiro a tabela de marcos: tarefa → % do contrato → valor em R$ · ele saberá exatamente o que entregar para receber cada parcela',
      },
      {
        icone: '🚫',
        texto:
          'Nunca combine datas fixas de pagamento · cronogramas são sempre otimistas e você acaba pagando antes do avanço real da obra',
      },
      {
        icone: '🔍',
        texto:
          'No meio da obra monitore semanalmente a relação % pago × % executado · é onde o descasamento acontece com mais frequência',
      },
      {
        icone: '🔎',
        texto:
          'Empreiteiro que recusa pagamento por marco é um filtro natural · o bom profissional aceita porque recebe mais rápido se entregar mais rápido',
      },
    ],
    atencao: [
      {
        icone: '💸',
        texto:
          'Quando o empreiteiro tem muita obra a fazer e pouco a receber, ele tem 3 saídas: abandonar, reduzir equipe ou pedir aditivo · todas prejudicam você',
      },
      {
        icone: '⏱️',
        texto:
          'Cronograma proposto pelo empreiteiro é sempre otimista · pagamento por data baseado nele vai gerar descasamento garantido ao longo da obra',
      },
      {
        icone: '📉',
        texto:
          'O miolo da obra cria ilusão de avanço: paredes e reboco parecem muito, mas financeiramente correspondem a poucas etapas do contrato',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'mdo-08-cl1',
        texto:
          'Estruturei o contrato com tabela de marcos: cada tarefa com seu percentual e valor total correspondente',
      },
      {
        id: 'mdo-08-cl2',
        texto:
          'Eliminei referências a datas de pagamento · troquei todas por marcos de entrega verificáveis',
      },
      {
        id: 'mdo-08-cl3',
        texto:
          'Estabeleci ponto de controle semanal para comparar % pago versus % fisicamente executado',
      },
      {
        id: 'mdo-08-cl4',
        texto:
          'Programei atenção redobrada no meio da obra (reboco/alvenaria), onde pagamentos tendem a se descolar',
      },
      {
        id: 'mdo-08-cl5',
        texto:
          'Programei retenção de 3–5% para quitação somente após conclusão total de todos os itens',
      },
      {
        id: 'mdo-08-cl6',
        texto:
          'Apresentei a tabela de marcos ao empreiteiro antes de assinar e usei a reação como filtro de qualidade',
      },
    ],
    metadados: [
      {
        campo: 'sistema_pagamento_mdo',
        label: 'Sistema de pagamento adotado',
        tipo: 'select',
        opcoes: ['Por marcos de entrega', 'Por data fixa', 'Por quinzena', 'Misto'],
      },
      {
        campo: 'perc_pago_atual',
        label: 'Percentual pago até agora (%)',
        tipo: 'number',
        placeholder: 'Ex: 40',
      },
      {
        campo: 'perc_executado_atual',
        label: 'Percentual executado fisicamente (%)',
        tipo: 'number',
        placeholder: 'Ex: 35',
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...MDO_CONTENT_08)

const MDO_CONTENT_09: TopicoContent[] = [
  {
    topicoId: 'mdo-09',
    resumo: [
      'Fase cinza = 55% do contrato; acabamento = 20%; elétrica e hidráulica = 7% cada; pintura = 8%',
      'A entrada do empreiteiro deve ser valor fixo pequeno (R$ 5–10k), nunca um percentual do contrato',
      'Divida a estrutura pelo número de lajes · 3 lajes = 20% por laje, criando marcos verificáveis',
      'Concentre mais percentual nos serviços finais de cada especialidade · a finalização é o incentivo',
      'Luminotécnica em contrato separado · compre as luminárias cedo para não negociar enfraquecido',
      'Pagar 10–30% de entrada é começar a obra devendo · a entrada justa cabe dentro dos 5% da fundação',
    ],
    dicasDeOuro: [
      {
        icone: '📊',
        texto:
          'Distribua os 55% da fase cinza por marcos de laje · isso evita adiantamento e cria checkpoints claros e verificáveis',
      },
      {
        icone: '🔒',
        texto:
          'A entrada do empreiteiro deve ser valor fixo simbólico (R$ 5–10k), nunca 10–30% do contrato · quem pede 30% de entrada quer começar te devendo',
      },
      {
        icone: '💡',
        texto:
          'Compre as luminárias no início da obra · o eletricista ainda tem muito a receber quando você for negociar a luminotécnica',
      },
      {
        icone: '🎯',
        texto:
          'Concentre o maior percentual na instalação de louças e metais na hidráulica · esse é o incentivo que mantém o bombeiro até a conclusão',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'O meio da obra (reboco e alvenaria) parece muito avanço mas é a fase de menor custo · é onde pagamentos se descolam por sensação de progresso',
      },
      {
        icone: '💸',
        texto:
          '15% de adiantamento num contrato de R$ 400k = R$ 60k pagos sem contrapartida · impossível recuperar esse equilíbrio depois no contrato',
      },
      {
        icone: '🔌',
        texto:
          'Luminotécnica no contrato principal de elétrica é uma armadilha · ela é imprevisível e deve ser negociada separadamente quando você tem poder',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'mdo-09-cl1',
        texto:
          'Estruturei o pagamento da fase cinza: 5% fundação, 60% estrutura (dividido por lajes) e restante em alvenaria/reboco',
      },
      {
        id: 'mdo-09-cl2',
        texto:
          'Defini a entrada como valor fixo em reais (R$ 5–10k) · não como percentual do contrato total',
      },
      {
        id: 'mdo-09-cl3',
        texto:
          'Dividi o contrato de estrutura pelo número de lajes da obra para criar marcos verificáveis',
      },
      {
        id: 'mdo-09-cl4',
        texto:
          'Excluí luminotécnica do contrato principal de elétrica e planejei negociá-la separadamente',
      },
      {
        id: 'mdo-09-cl5',
        texto:
          'Planejei comprar as luminárias cedo para manter poder de negociação com o eletricista',
      },
      {
        id: 'mdo-09-cl6',
        texto:
          'Concentrei o maior percentual do contrato hidráulico na instalação de louças e metais',
      },
    ],
    metadados: [
      {
        campo: 'entrada_empreiteiro_rs',
        label: 'Valor de entrada do empreiteiro (R$)',
        tipo: 'number',
        placeholder: 'Ex: 8000',
      },
      {
        campo: 'num_lajes_obra',
        label: 'Número de lajes da obra',
        tipo: 'number',
        placeholder: 'Ex: 2',
      },
      {
        campo: 'perc_fase_cinza_pago',
        label: 'Fase cinza paga até o momento (%)',
        tipo: 'number',
        placeholder: 'Ex: 45',
      },
    ],
    temFerramenta: true,
  },
]

TOPICOS_CONTENT.push(...MDO_CONTENT_09)

const MDO_CONTENT_10: TopicoContent[] = [
  {
    topicoId: 'mdo-10',
    resumo: [
      'O alvará gera dívida automática na Receita Federal · a obra existe, o INSS de obra também existe',
      'O valor do INSS é calculado pela metragem aprovada · não pela forma como você contratou a mão de obra',
      'Matrícula CNO: abra logo no início para acumular créditos de INSS ao longo da obra',
      'O que conta como crédito: CLT na obra e nota de concreto de caminhão. MEI e autônomos NÃO contam',
      'Sem CND da Receita você não averba · sem averbação a casa existe na prefeitura mas não no cartório',
      'A dívida prescreve em 5 anos, mas a Receita cobra no 4º ano com atualização · aguardar encarece',
    ],
    dicasDeOuro: [
      {
        icone: '📋',
        texto:
          'Abra a Matrícula CNO com contador especializado em INSS de obra antes de começar · contador de empresa comum não sabe fazer isso',
      },
      {
        icone: '🧾',
        texto:
          'Inclua o número da Matrícula CNO em todas as notas fiscais da obra · prepare um template e envie para cada fornecedor',
      },
      {
        icone: '🏗️',
        texto:
          'Prefira concreto usinado de caminhão sempre que possível · além de mais eficiente, a nota conta como crédito de INSS',
      },
      {
        icone: '❓',
        texto:
          'Pergunte à construtora: seus funcionários são CLT e estão alocados ao meu CNO? A resposta define se você acumula créditos',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'MEI e autônomos NÃO acumulam crédito de INSS na sua Matrícula CNO · mesmo que emitam nota fiscal para você',
      },
      {
        icone: '🏢',
        texto:
          'Construtora com CLT não é suficiente · os funcionários precisam estar alocados especificamente na SUA obra no CNO',
      },
      {
        icone: '💸',
        texto:
          'Esperar os 5 anos de prescrição é armadilha · a Receita vem antes com valores corrigidos e você não economiza nada',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'mdo-10-cl1',
        texto:
          'Abri a Matrícula CNO com contador especializado em INSS de obra antes do início da construção',
      },
      {
        id: 'mdo-10-cl2',
        texto:
          'Preparei um template com dados do CNO para enviar a todos os fornecedores que emitirem nota fiscal',
      },
      {
        id: 'mdo-10-cl3',
        texto:
          'Verifiquei com a construtora se os funcionários CLT estão alocados especificamente no meu CNO',
      },
      {
        id: 'mdo-10-cl4',
        texto:
          'Priorizei concreto usinado de caminhão para gerar crédito de INSS automaticamente nas notas',
      },
      {
        id: 'mdo-10-cl5',
        texto: 'Calculei o valor estimado do INSS baseado na metragem aprovada no alvará',
      },
      {
        id: 'mdo-10-cl6',
        texto:
          'Planejei o momento de quitação do INSS restante para obter a CND e averbar a construção',
      },
    ],
    metadados: [
      {
        campo: 'matricula_cno_aberta',
        label: 'Matrícula CNO foi aberta?',
        tipo: 'select',
        opcoes: [
          'Sim · aberta com contador especializado',
          'Não · a abrir',
          'Não aplicável (área rural)',
        ],
      },
      {
        campo: 'area_aprovada_m2',
        label: 'Área aprovada no alvará (m²)',
        tipo: 'number',
        placeholder: 'Ex: 200',
      },
      {
        campo: 'valor_inss_estimado_rs',
        label: 'Estimativa de INSS total (R$)',
        tipo: 'number',
        placeholder: 'Ex: 30000',
      },
      {
        campo: 'inss_acumulado_perc',
        label: 'INSS já acumulado no CNO (%)',
        tipo: 'number',
        placeholder: 'Ex: 40',
      },
    ],
    temFerramenta: true,
  },
]

TOPICOS_CONTENT.push(...MDO_CONTENT_10)

const MDO_CONTENT_11: TopicoContent[] = [
  {
    topicoId: 'mdo-11',
    resumo: [
      'Recolher metade do INSS ao longo da obra garante isenção dos 50% restantes · contabilidade regular',
      'INSS por faixa de 100 m²: cruzar de 299 para 301 m² pode custar R$ 30k a mais no imposto',
      'Registrar vigas metálicas ou steel frame no CNO gera desconto de até 25% no INSS de obra',
      '0.7 m² acima de 200 m² custaram R$ 14k a uma pessoa · verifique a metragem antes de aprovar o projeto',
      'Contador especializado em INSS de obra é indispensável · o contador empresarial comum não faz esse planejamento',
    ],
    dicasDeOuro: [
      {
        icone: '💰',
        texto:
          'Planeje recolher ao menos 50% do INSS durante a obra · a Receita isenta os 50% restantes como prêmio pela formalização',
      },
      {
        icone: '📐',
        texto:
          'Antes de aprovar o projeto, verifique se a metragem está próxima de uma fronteira de faixa (100/200/300 m²) · 1 m² a menos pode economizar R$ 14–30k',
      },
      {
        icone: '🏗️',
        texto:
          'Declare sistemas alternativos (vigas metálicas, steel frame) no CNO desde a abertura · cada nota fiscal com o CNO registra pontos para o desconto',
      },
      {
        icone: '🔍',
        texto:
          'Contrate um contador especializado em INSS de obra antes de iniciar · o desconto de 50% exige planejamento e documentação durante toda a construção',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Sem contabilidade regular você chega ao final da obra com o pote vazio e paga 100% do INSS sem nenhum desconto',
      },
      {
        icone: '📐',
        texto:
          'Um projeto de 201 m² paga o mesmo INSS que um de 299 m² · cruzar o limite de 200 m² desnecessariamente é jogar dinheiro fora',
      },
      {
        icone: '🏗️',
        texto:
          'Usar sistemas alternativos sem registrar no CNO não gera desconto · o benefício precisa ser comunicado desde a abertura da matrícula',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'mdo-11-cl1',
        texto:
          'Abri a Matrícula CNO informando o sistema construtivo correto (tradicional ou misto/alternativo)',
      },
      {
        id: 'mdo-11-cl2',
        texto:
          'Verifiquei se a metragem aprovada está próxima de um limite de faixa (100/200/300/400 m²) e avaliei ajuste',
      },
      {
        id: 'mdo-11-cl3',
        texto:
          'Contratei contador especializado em INSS de obra para planejar o recolhimento durante a construção',
      },
      {
        id: 'mdo-11-cl4',
        texto:
          'Organizei o recolhimento para atingir ao menos 50% do valor previsto durante a obra',
      },
      {
        id: 'mdo-11-cl5',
        texto:
          'Incluí o CNO em todas as notas de materiais alternativos (vigas metálicas, etc.) com registro fotográfico',
      },
      {
        id: 'mdo-11-cl6',
        texto:
          'Calculei a economia estimada com as três estratégias antes de fechar o projeto na prefeitura',
      },
    ],
    metadados: [
      {
        campo: 'sistema_construtivo_cno',
        label: 'Sistema construtivo declarado no CNO',
        tipo: 'select',
        opcoes: [
          'Tradicional (concreto/alvenaria)',
          'Misto (parte alternativa)',
          'Steel frame',
          'Estrutura metálica',
          'Outro alternativo',
        ],
      },
      {
        campo: 'metragem_aprovada_final_m2',
        label: 'Metragem aprovada no projeto (m²)',
        tipo: 'number',
        placeholder: 'Ex: 199',
      },
      {
        campo: 'economia_inss_estimada_rs',
        label: 'Economia estimada no INSS (R$)',
        tipo: 'number',
        placeholder: 'Ex: 20000',
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...MDO_CONTENT_11)

const EXE_CONTENT_01: TopicoContent[] = [
  {
    topicoId: 'exe-01',
    resumo: [
      'Queimar as 5 fases de planejamento e ir direto à execução é a receita do orçamento explodido',
      'A maior oportunidade de economia está nas cinco etapas de planejamento, não na execução',
      'Na execução ainda há escolhas impactantes de custo: telhado vs manta, retrabalhos e sequência',
      'Sequência errada de obra equivale a jogar dinheiro fora · timing de cada fase é tão crítico quanto o valor',
      'Gaps entre fases geram lacunas de execução que queimam recursos sem produção visível',
      'O cronograma de sequência define não só prazo, mas o momento certo de compras e contratações',
    ],
    dicasDeOuro: [
      {
        icone: '🏁',
        texto:
          'Confirme que as 5 etapas anteriores (terreno, sistemas, projetos, finanças, mão de obra) estão definidas antes de dar start · cada lacuna vira custo extra em obra',
      },
      {
        icone: '🗂️',
        texto:
          'Trate o cronograma como sequência, não como calendário · o que importa é a ordem correta das fases, não apenas o prazo de cada uma',
      },
      {
        icone: '💡',
        texto:
          'Mapeie as escolhas técnicas com impacto de custo antes de executar: telhado vs manta, revestimento, fachada · cada decisão tem um delta de custo de manutenção',
      },
      {
        icone: '🔗',
        texto:
          'Concatene atividades sem gaps · cada lacuna entre fases representa equipe parada ou retrabalho, ambos com custo direto no orçamento',
      },
    ],
    atencao: [
      {
        icone: '💸',
        texto:
          'Iniciar a execução sem os módulos anteriores concluídos é a causa número 1 de estouro de orçamento · você toma decisões caras na hora errada',
      },
      {
        icone: '🔄',
        texto:
          'Pular etapas de sequência (colocar o carro na frente dos bois) gera retrabalho cujo custo pode dobrar o valor original da etapa',
      },
      {
        icone: '⏳',
        texto:
          'Gaps de execução entre fases queimam recursos sem produção visível · equipe mobilizada sem frente de trabalho é prejuízo diário',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'exe-01-cl1',
        texto:
          'Confirmei que as cinco etapas de planejamento (terreno, sistemas, projetos, finanças e mão de obra) estão concluídas antes de iniciar a execução',
      },
      {
        id: 'exe-01-cl2',
        texto: 'Mapeei as escolhas técnicas de execução com maior impacto no custo da minha obra',
      },
      {
        id: 'exe-01-cl3',
        texto:
          'Defini o cronograma de sequência de fases (não só de prazos) antes de iniciar a obra',
      },
      {
        id: 'exe-01-cl4',
        texto: 'Planejei o timing de compras e contratações alinhado ao cronograma de sequência',
      },
      {
        id: 'exe-01-cl5',
        texto:
          'Identifiquei os pontos críticos de transição entre fases onde gaps de execução costumam ocorrer',
      },
      {
        id: 'exe-01-cl6',
        texto:
          'Estabeleci marcos de verificação ao final de cada fase antes de liberar o início da próxima',
      },
    ],
    metadados: [
      {
        campo: 'fases_pert_concluidas',
        label: 'Planejamento concluído antes da execução',
        tipo: 'select',
        opcoes: [
          'Todas as 5 fases concluídas',
          '4 de 5 concluídas',
          '3 de 5 concluídas',
          'Menos de 3 · revisar antes de iniciar',
        ],
      },
      {
        campo: 'status_inicio_execucao',
        label: 'Status de início da execução',
        tipo: 'select',
        opcoes: [
          'Ainda não iniciou',
          'Iniciando em breve',
          'Em andamento · fase cinza',
          'Em andamento · acabamento',
        ],
      },
      {
        campo: 'principal_risco_exec',
        label: 'Principal risco de execução identificado',
        tipo: 'text',
        placeholder: 'Ex: sequência de revestimentos não definida',
      },
    ],
    temFerramenta: true,
  },
]

TOPICOS_CONTENT.push(...EXE_CONTENT_01)

const EXE_CONTENT_02: TopicoContent[] = [
  {
    topicoId: 'exe-02',
    resumo: [
      'Ser engolido pelo ritmo da obra leva a compras sem negociação e decisões inseguras e caras',
      'Decidir na sequência errada cria conflitos no canteiro · materiais incompatíveis e retrabalho',
      'O guia organiza a obra em 8 etapas com o momento certo de decidir, comprar e contratar',
      'Estar 2–3 etapas à frente da obra elimina a pressão que gera más decisões de custo',
      'Quem decide atrás da obra paga mais caro · negocia pouco, pesquisa menos e compra errado',
      'O método define o que pagar ao empreiteiro em cada etapa, evitando descompassos de fluxo',
    ],
    dicasDeOuro: [
      {
        icone: '🎯',
        texto:
          'Sempre esteja 2–3 decisões à frente da obra · quem decide pressionado pelo ritmo da construtora paga até 15–20% a mais em compras sem negociação',
      },
      {
        icone: '🗂️',
        texto:
          'Siga a sequência das 8 etapas sem pular · cada etapa tem decisões de projeto e fornecedores a confirmar no tempo certo',
      },
      {
        icone: '🛒',
        texto:
          'Pesquise e feche fornecedor com ao menos 3 semanas de antecedência por etapa · a urgência da obra elimina seu poder de negociação',
      },
      {
        icone: '💬',
        texto:
          'Não deixe a construtora pautar o ritmo das suas decisões de acabamento · defina iluminação, revestimento e fachada antes que a obra chegue até eles',
      },
    ],
    atencao: [
      {
        icone: '🚨',
        texto:
          'Ser surpreendido pelo ritmo da obra gera compras sem pesquisa de preço · perda direta de 10–20% no valor de cada insumo comprado às pressas',
      },
      {
        icone: '🔨',
        texto:
          'Sequência errada de materiais obriga a quebrar elementos já executados · retrabalho que pode dobrar o custo da etapa afetada',
      },
      {
        icone: '😰',
        texto:
          'Decisões de acabamento tomadas sob pressão resultam em escolhas que você não gosta · custo emocional e financeiro de refazer itens já instalados',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'exe-02-cl1',
        texto: 'Mapeei as 8 etapas da sequência da obra e identifiquei em qual delas estou agora',
      },
      {
        id: 'exe-02-cl2',
        texto:
          'Listei as decisões críticas de projeto (iluminação, acabamento, fachada) com a etapa-limite para cada uma',
      },
      {
        id: 'exe-02-cl3',
        texto:
          'Pesquisei fornecedores e preços das próximas 2 etapas com antecedência mínima de 3 semanas',
      },
      {
        id: 'exe-02-cl4',
        texto:
          'Confirmei que nenhuma decisão de acabamento depende do ritmo da construtora para ser tomada',
      },
      {
        id: 'exe-02-cl5',
        texto:
          'Alinhei o cronograma de pagamento ao empreiteiro com a sequência de etapas e entregas',
      },
      {
        id: 'exe-02-cl6',
        texto:
          'Identifiquei os insumos de prazo longo (esquadrias, luminárias, marmoraria) e adiantei o pedido',
      },
    ],
    metadados: [
      {
        campo: 'etapa_atual_manual',
        label: 'Etapa atual na sequência da obra',
        tipo: 'select',
        opcoes: [
          'Etapa 1 · Fundação',
          'Etapa 2 · Estrutura',
          'Etapa 3 · Cobertura',
          'Etapa 4 · Alvenaria/Reboco',
          'Etapa 5 · Instalações',
          'Etapa 6 · Contrapiso/Revestimento',
          'Etapa 7 · Acabamento',
          'Etapa 8 · Finalização',
        ],
      },
      {
        campo: 'semanas_antecipacao_compras',
        label: 'Semanas de antecedência nas compras',
        tipo: 'number',
        placeholder: 'Ex: 3',
      },
      {
        campo: 'decisoes_pendentes_criticas',
        label: 'Decisões críticas ainda não tomadas',
        tipo: 'textarea',
        placeholder: 'Ex: iluminação sala de estar, revestimento fachada',
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...EXE_CONTENT_02)

const EXE_CONTENT_03: TopicoContent[] = [
  {
    topicoId: 'exe-03',
    resumo: [
      'A obra tem 3 terços: ~35% de custo no início, ~15% no meio e ~50% na reta final',
      'O meio parece rápido visualmente (reboco, alvenaria) mas custa pouco · não pague proporcionalmente',
      'Na reta final tudo é interdependente: forro trava eletricista, eletricista trava pintura, pintura trava porta',
      'Chegar na reta final sem reserva financeira estira a obra de 3 meses para 8 ou 9 meses',
      'O que mais atrasa obra não é falta de dinheiro · é falta de definições de projeto e acabamento',
      'Antecipar decisões equilibra energia, prazo, retrabalho e fluxo de caixa ao mesmo tempo',
    ],
    dicasDeOuro: [
      {
        icone: '💰',
        texto:
          'Reserve financeiramente o último terço (≈50% do custo total) sem tocá-lo nas fases anteriores · chegar saudável na reta final é a única forma de não parar a obra',
      },
      {
        icone: '🗓️',
        texto:
          'Antecipe decisões de acabamento (revestimento, iluminação, marcenaria, vaso sanitário) para o meio da obra · decidir na hora sob pressão atrasa semanas e gera escolhas ruins',
      },
      {
        icone: '⚖️',
        texto:
          'No meio da obra, calibre pagamentos ao empreiteiro pelo percentual real executado, não pela velocidade visual · reboco parece rápido mas vale pouco no custo total',
      },
      {
        icone: '📅',
        texto:
          'Planeje o desembolso nivelado mês a mês · picos de R$ 300k inesperados num mês indicam que as decisões de acabamento não foram antecipadas',
      },
    ],
    atencao: [
      {
        icone: '🚨',
        texto:
          'Pagar 70% ao empreiteiro com 50% executado no meio da obra é o erro mais comum · gera descompasso que se transforma em conflito e abandono na reta final',
      },
      {
        icone: '🔗',
        texto:
          'Reta final com caixa vazio paralisa a obra por interdependência: sem dinheiro para forro, elétrica, pintura e porta ao mesmo tempo, nenhuma termina',
      },
      {
        icone: '⏰',
        texto:
          'Deixar revestimento, iluminação e marcenaria para decidir "quando chegar a hora" garante atraso e decisões sob pressão · custo de arrependimento é sempre alto',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'exe-03-cl1',
        texto:
          'Calculei a distribuição de custo por terço da minha obra (35% início / 15% meio / 50% final)',
      },
      {
        id: 'exe-03-cl2',
        texto:
          'Separei e protegi a reserva financeira para o terceiro terço sem comprometê-la nas fases anteriores',
      },
      {
        id: 'exe-03-cl3',
        texto:
          'Antecipei todas as decisões de acabamento (revestimento, iluminação, marcenaria, fachada) para antes do meio da obra',
      },
      {
        id: 'exe-03-cl4',
        texto:
          'Calibrei pagamentos ao empreiteiro no meio da obra com o percentual real executado, não pela velocidade visual',
      },
      {
        id: 'exe-03-cl5',
        texto:
          'Mapeei as interdependências da reta final (forro → elétrica → pintura → portas → rodapé) e planejei a mobilização simultânea',
      },
      {
        id: 'exe-03-cl6',
        texto:
          'Calculei o desembolso nivelado por mês para evitar picos financeiros inesperados na reta final',
      },
    ],
    metadados: [
      {
        campo: 'reserva_terceiro_terco_rs',
        label: 'Reserva separada para o último terço (R$)',
        tipo: 'number',
        placeholder: 'Ex: 150000',
      },
      {
        campo: 'decisoes_acabamento_antecipadas',
        label: 'Decisões de acabamento antecipadas',
        tipo: 'select',
        opcoes: [
          'Todas antecipadas · nada pendente',
          'Maioria antecipada · alguns itens pendentes',
          'Poucas antecipadas · maioria ainda pendente',
          'Nenhuma · tudo para decidir na hora',
        ],
      },
      {
        campo: 'semanas_para_reta_final',
        label: 'Semanas estimadas até a reta final',
        tipo: 'number',
        placeholder: 'Ex: 8',
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...EXE_CONTENT_03)

const EXE_CONTENT_04: TopicoContent[] = [
  {
    topicoId: 'exe-04',
    resumo: [
      'Atrasos em obra acrescentam em média 12% ao custo total · R$ 100k extras numa obra de R$ 1 milhão',
      'Obra lenta perde prioridade com empreiteiros · qualquer ajuste extra é cobrado porque "a obra não colabora"',
      'Custos fixos (betoneira, andaime, aluguel de moradia) sangram orçamento a cada dia de atraso',
      'Comprando de última hora você fica refém de frete · 1 dia de atraso paralisa a equipe',
      'Em obra rápida o empreiteiro absorve ambiguidades; em obra lenta ele cobra excedente em tudo',
      '70% dos problemas de obra podem ser eliminados antecipando decisões e compras',
    ],
    dicasDeOuro: [
      {
        icone: '⏩',
        texto:
          'Calcule o custo fixo diário da sua obra (betoneira, andaime, aluguel) · cada dia de atraso tem um valor concreto a evitar',
      },
      {
        icone: '🛒',
        texto:
          'Compre insumos com 2–3 semanas de antecedência para nunca ser refém de fretes atrasados · o material que chega tarde paralisa equipe mobilizada',
      },
      {
        icone: '✅',
        texto:
          'Em obras bem planejadas e rápidas o empreiteiro absorve as ambiguidades do contrato · mantenha frente de serviço sempre liberada para manter essa boa vontade',
      },
      {
        icone: '📋',
        texto:
          'Decisões antecipadas eliminam o projeto vivo · o que já está decidido e comprado não gera custo de alteração nem de retrabalho',
      },
    ],
    atencao: [
      {
        icone: '💸',
        texto:
          'A mesma casa com o mesmo padrão de acabamento custa 10–12% a mais se a obra arrastar · o produto é idêntico, mas o custo não é',
      },
      {
        icone: '🔻',
        texto:
          'Empreiteiro em obra lenta sai da fila de prioridade e começa a cobrar excedente em qualquer item não previsto em contrato',
      },
      {
        icone: '🚚',
        texto:
          'Comprar material em cima da hora torna você refém de qualquer freteista · 1 dia de atraso na entrega pode afastar a equipe para outra obra',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'exe-04-cl1',
        texto:
          'Calculei o custo de atraso da minha obra (12% do orçamento total) para ter clareza do que está em jogo',
      },
      {
        id: 'exe-04-cl2',
        texto:
          'Listei todos os custos fixos mensais da obra (betoneira, andaime, aluguel, equipe fixa) para quantificar o risco diário',
      },
      {
        id: 'exe-04-cl3',
        texto:
          'Defini prazo mínimo de antecipação de compras (mínimo 14 dias) para cada insumo crítico da próxima fase',
      },
      {
        id: 'exe-04-cl4',
        texto:
          'Confirmei que as 5 principais causas de atraso (planejamento, financeiro, material, projeto, comunicação) estão mitigadas',
      },
      {
        id: 'exe-04-cl5',
        texto:
          'Mantive os empreiteiros com frente de serviço liberada para não perder prioridade nas agendas deles',
      },
      {
        id: 'exe-04-cl6',
        texto:
          'Documentei todas as decisões tomadas para eliminar ambiguidades que geram cobranças extras no decorrer da obra',
      },
    ],
    metadados: [
      {
        campo: 'custo_fixo_mensal_obra_rs',
        label: 'Custo fixo mensal da obra (R$)',
        tipo: 'number',
        placeholder: 'Ex: 8000',
      },
      {
        campo: 'custo_estimado_atraso_perc',
        label: 'Custo estimado de atraso (% do orçamento)',
        tipo: 'number',
        placeholder: 'Ex: 10',
      },
      {
        campo: 'antecipacao_compras_dias',
        label: 'Antecedência média nas compras (dias)',
        tipo: 'number',
        placeholder: 'Ex: 21',
      },
    ],
    temFerramenta: true,
  },
]

TOPICOS_CONTENT.push(...EXE_CONTENT_04)

const EXE_CONTENT_05: TopicoContent[] = [
  {
    topicoId: 'exe-05',
    resumo: [
      'Pré-obra bem feito vale tanto quanto a execução · não queime essa etapa por ansiedade de construir',
      'Bloco 1: Regularização · alvará, ART de execução e projeto, licenças ambientais e especiais',
      'Bloco 2: Documentação · projetos compatibilizados e contratos vinculando entrega física a pagamento',
      'Bloco 3: Custos · planilha de desembolso e aprovação de crédito antecipada mesmo sem precisar',
      'Bloco 4: Obra · pasta de documentos no canteiro e pedido imediato de água e luz (demora 3–5 meses)',
      'Vistoria de água/luz pode ser reprovada por número torto · peça assim que o alvará sair',
    ],
    dicasDeOuro: [
      {
        icone: '💧',
        texto:
          'Peça a ligação de água e luz logo que o alvará sair · o processo pode demorar 3 a 5 meses e vistorias são reprovadas por motivos absurdos (número torto, problema cadastral)',
      },
      {
        icone: '📁',
        texto:
          'Monte a pasta de documentos no canteiro antes do primeiro dia de obra e oriente toda a equipe sobre o protocolo · multa de R$ 30k+ chegou em obra 100% regular cujos documentos não estavam no local',
      },
      {
        icone: '🏦',
        texto:
          'Aprove crédito com instituição financeira no pré-obra mesmo sem intenção de financiar · dá uma baliza de custo independente e agiliza caso precise de capital durante a obra',
      },
      {
        icone: '📋',
        texto:
          'Não inicie a obra sem contratos de mão de obra vinculando pagamentos a percentuais de execução física · contrato por data é contrato sem controle',
      },
    ],
    atencao: [
      {
        icone: '🚔',
        texto:
          'CREA fiscaliza obras ativas: sem ART no local a multa é pesada e praticamente irreversível · R$ 30k+ foi pago por obra regular cujos documentos estavam em casa, não no canteiro',
      },
      {
        icone: '💧',
        texto:
          'Vistoria de água e luz pode ser reprovada por número torto ou problema cadastral da concessionária · reenviar o pedido acrescenta 20–30 dias por tentativa',
      },
      {
        icone: '📊',
        texto:
          'Iniciar a obra sem planilha de desembolso é perder a referência de custo · você gasta sem saber se está dentro do orçamento e descobre o problema tarde demais',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'exe-05-cl1',
        texto: 'Obtive o alvará de construção da prefeitura antes de iniciar qualquer serviço',
      },
      {
        id: 'exe-05-cl2',
        texto:
          'Coletei todas as ARTs (projeto arquitetônico, estrutural, elétrico, hidráulico e execução) e mantive originais no canteiro',
      },
      {
        id: 'exe-05-cl3',
        texto:
          'Montei pasta física de documentos no canteiro e orientei toda a equipe sobre como agir em caso de fiscalização',
      },
      {
        id: 'exe-05-cl4',
        texto: 'Solicitei a ligação de água e luz imediatamente após a liberação do alvará',
      },
      {
        id: 'exe-05-cl5',
        texto:
          'Confirmei que os projetos estão compatibilizados (arquitetônico, estrutural, elétrico, hidráulico)',
      },
      {
        id: 'exe-05-cl6',
        texto:
          'Assinei contratos de mão de obra vinculando pagamentos a percentuais de execução física, não a datas',
      },
      {
        id: 'exe-05-cl7',
        texto:
          'Finalizei a planilha de desembolso e consultei crédito com instituição financeira para ter baliza independente',
      },
    ],
    metadados: [
      {
        campo: 'status_regularizacao_preobra',
        label: 'Status de regularização do pré-obra',
        tipo: 'select',
        opcoes: [
          'Tudo regularizado · alvará, ARTs e licenças',
          'Alvará OK · ARTs pendentes',
          'Em processo na prefeitura',
          'Nada iniciado',
        ],
      },
      {
        campo: 'data_pedido_agua_luz',
        label: 'Data do pedido de água e luz',
        tipo: 'text',
        placeholder: 'Ex: 15/06/2026',
      },
      {
        campo: 'pasta_docs_no_canteiro',
        label: 'Pasta de documentos montada no canteiro?',
        tipo: 'select',
        opcoes: [
          'Sim · equipe orientada',
          'Montada · falta orientar equipe',
          'Em preparação',
          'Não montada ainda',
        ],
      },
    ],
    temFerramenta: true,
  },
]

TOPICOS_CONTENT.push(...EXE_CONTENT_05)

const EXE_CONTENT_06: TopicoContent[] = [
  {
    topicoId: 'exe-06',
    resumo: [
      'O cronograma tem 8 momentos: tarefas azuis (caminho crítico) e verdes (reconfiguráveis no prazo)',
      'Atrasar tarefa azul atrasa a obra inteira · tarefa verde pode ser realocada sem impacto no prazo',
      'Momento 1: ajuste de terreno + fundação · gasto enterrado, invisível ao olho mas pesado no orçamento',
      'Resolver desníveis na edificação (não no solo) é sempre mais econômico que terraplenagem e arrimos',
      'Momento 2: alvenaria + estrutura · começar pela estrutura pode custar até 40% a mais nessa fase',
      'Testar radier, sapata e estaca antes de aceitar o calculista pode gerar economia significativa na fundação',
    ],
    dicasDeOuro: [
      {
        icone: '🗺️',
        texto:
          'Identifique quais tarefas são do caminho crítico antes de iniciar · só as azuis determinam o prazo; as verdes podem ser movidas sem arrastar a obra',
      },
      {
        icone: '🏔️',
        texto:
          'Resolva desníveis e problemas de terreno na edificação · terraplenagem pesada queima orçamento sem retorno visual e cada m³ movido é dinheiro enterrado',
      },
      {
        icone: '🏗️',
        texto:
          'Peça orçamento para 3 tipos de fundação (radier, sapata, estaca) · radier pode ser 2–3x mais barato em terrenos firmes; não aceite só a primeira sugestão',
      },
      {
        icone: '🧱',
        texto:
          'Verifique com o arquiteto se o projeto permite começar pela alvenaria · projeto estrutura-primeiro acrescenta até 40% ao custo do momento 2 por excesso de escora e madeira',
      },
    ],
    atencao: [
      {
        icone: '💸',
        texto:
          'Momento 2 com estrutura antes da alvenaria custa até 40% a mais nessa fase · maior consumo de madeira, escoramento e mão de obra; confirme com o arquiteto se há alternativa',
      },
      {
        icone: '🔵',
        texto:
          'Qualquer atraso em tarefa do caminho crítico (azul) paralisa especialistas em cascata · até 1 semana de espera por decisão pode travar todo o momento seguinte',
      },
      {
        icone: '⛏️',
        texto:
          'Gastar em arrimos e terraplenagem o que seria investido na edificação é troca desfavorável · solucione no projeto, não escavando',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'exe-06-cl1',
        texto:
          'Identifiquei quais tarefas da minha obra são do caminho crítico (azul) e quais podem ser reconfiguradas (verde)',
      },
      {
        id: 'exe-06-cl2',
        texto:
          'Minimizei o ajuste de terreno no projeto para reduzir custo de terraplenagem e arrimos ao mínimo possível',
      },
      {
        id: 'exe-06-cl3',
        texto:
          'Solicitei orçamento para ao menos 2 tipos de fundação (radier, sapata ou estaca) antes de decidir',
      },
      {
        id: 'exe-06-cl4',
        texto:
          'Confirmei com o arquiteto se o projeto permite iniciar pelo momento 2 com alvenaria antes da estrutura',
      },
      {
        id: 'exe-06-cl5',
        texto:
          'Calculei e comparei o custo do momento 2 nas duas sequências possíveis (alvenaria primeiro vs estrutura primeiro)',
      },
      {
        id: 'exe-06-cl6',
        texto:
          'Planejei o início do momento 1 com margem para licenças (água, luz, CREA) já solicitadas no pré-obra',
      },
    ],
    metadados: [
      {
        campo: 'sequencia_momento2',
        label: 'Sequência do momento 2',
        tipo: 'select',
        opcoes: [
          'Alvenaria primeiro (mais econômico)',
          'Estrutura primeiro (projeto exige)',
          'Simultâneo · analisar com arquiteto',
          'Ainda não definido',
        ],
      },
      {
        campo: 'tipo_fundacao_escolhida',
        label: 'Tipo de fundação escolhida',
        tipo: 'select',
        opcoes: [
          'Radier',
          'Sapata isolada',
          'Sapata corrida',
          'Estaca',
          'Tubulão',
          'A definir após sondagem',
        ],
      },
      {
        campo: 'custo_ajuste_terreno_rs',
        label: 'Custo estimado de ajuste de terreno (R$)',
        tipo: 'number',
        placeholder: 'Ex: 25000',
      },
    ],
    temFerramenta: true,
  },
]

TOPICOS_CONTENT.push(...EXE_CONTENT_06)

const EXE_CONTENT_07: TopicoContent[] = [
  {
    topicoId: 'exe-07',
    resumo: [
      'Momento 3 divide o canteiro em 2 frentes: reboco externo (pedreiros) + operação anti-retrabalho (instalações)',
      'A maior parte dos quebra-quebras pode ser cortada no momento 3 · depois é retrabalho com custo duplicado',
      'Aquisições críticas do momento 2: esquadrias, piscina e automação · contratos fechados antes do momento 3',
      'Prazo justo: momento 1 = até 2 meses (sapatas), momento 2 = 1–1,5 mês por laje, momento 3 = 1–2 meses',
      'Dono da obra precisa estar presente no momento 3 para confirmar posições de tomadas, câmeras e pontos de gás',
      'Comprar eletrodoméstico por promoção sem checar voltagem e dimensões gera retrabalho imediato e certo',
    ],
    dicasDeOuro: [
      {
        icone: '📋',
        texto:
          'No momento 2, feche já os contratos de esquadrias, piscina e automação · fabricação é longa e a infraestrutura desses itens precisa estar passada no momento 3',
      },
      {
        icone: '🏠',
        texto:
          'Divida o canteiro no momento 3: pedreiros para fora (reboco externo) e instaladores para dentro · equipes simultâneas que não se atrapalham',
      },
      {
        icone: '👁️',
        texto:
          'Dono da obra deve visitar intensamente no momento 3 · é a última chance de mudar posição de tomadas, câmeras, gás e AC sem quebrar parede já rebocada',
      },
      {
        icone: '🛒',
        texto:
          'Nunca compre eletrodoméstico por promoção antes de definir o ponto · voltagem errada (110/220), modelo diferente ou dimensão divergente geram quebra de parede',
      },
    ],
    atencao: [
      {
        icone: '📅',
        texto:
          'Contratos de esquadria, piscina e automação fechados no momento 3 (tarde demais) deslocam toda a infraestrutura e geram atraso em cascata de 2 a 4 semanas ou mais',
      },
      {
        icone: '⏱️',
        texto:
          'Obra a 1 pavimento demorando mais de 6 semanas por laje tem problema de equipe ou sequência · prazo esticado é dinheiro perdido em custo fixo diário',
      },
      {
        icone: '🔨',
        texto:
          'Qualquer instalação não conferida no momento 3 que precisar mudar depois significa quebra de parede rebocada · custo que pode ser 3x o valor original da alteração',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'exe-07-cl1',
        texto:
          'Fechei o contrato de esquadrias (janelas e portas) ainda no momento 2 para garantir fabricação a tempo do momento 4',
      },
      {
        id: 'exe-07-cl2',
        texto:
          'Fechei o contrato de piscina (se aplicável) ainda no momento 2 para incluir tubulação na operação anti-retrabalho',
      },
      {
        id: 'exe-07-cl3',
        texto:
          'Fechei o contrato de automação no momento 2 para garantir infraestrutura passada junto das demais instalações internas',
      },
      {
        id: 'exe-07-cl4',
        texto:
          'Organizei 2 frentes simultâneas no momento 3: reboco externo e operação anti-retrabalho com equipes separadas',
      },
      {
        id: 'exe-07-cl5',
        texto:
          'Visitei a obra intensamente no momento 3 e confirmei posições de todos os pontos elétricos, hidráulicos, câmeras e gás',
      },
      {
        id: 'exe-07-cl6',
        texto:
          'Confirmei voltagem e dimensões de todos os eletrodomésticos antes de definir os pontos de instalação',
      },
    ],
    metadados: [
      {
        campo: 'contrato_esquadrias_momento',
        label: 'Contrato de esquadrias fechado em qual momento?',
        tipo: 'select',
        opcoes: [
          'Momento 2 · correto',
          'Momento 3 · risco de atraso',
          'Momento 4 ou depois · risco alto',
          'Não se aplica',
        ],
      },
      {
        campo: 'prazo_real_por_laje_meses',
        label: 'Prazo real por laje (meses)',
        tipo: 'number',
        placeholder: 'Ex: 1.5',
      },
      {
        campo: 'status_operacao_antirework',
        label: 'Status da operação anti-retrabalho',
        tipo: 'select',
        opcoes: [
          'Concluída · todas as instalações conferidas',
          'Em andamento',
          'Ainda não chegou nesse momento',
          'Momento 3 passou sem revisão',
        ],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...EXE_CONTENT_07)

const EXE_CONTENT_08: TopicoContent[] = [
  {
    topicoId: 'exe-08',
    resumo: [
      'Momento 4: cobertura + reboco interno + contramarcos de esquadria · prazo justo de 1 a 1,5 mês',
      'Contramarcos chumbados no reboco interno garantem vão exato para os vidros e bloqueiam infiltração',
      'Gesso interno é solução de baixo padrão · deteriora com umidade e revela defeitos com luminotécnica bem posicionada',
      'Momento 5: pintura externa + forro + revestimentos + impermeabilizações · prazo de 1,5 a 2 meses',
      'Revestimento de paredes antes do forro é regra: forro arremata nas paredes, não o contrário',
      '"Se está liberado, ataca agora" · lacunas entre fases significam equipe parada e custo fixo ativo',
    ],
    dicasDeOuro: [
      {
        icone: '🔲',
        texto:
          'Instale contramarcos de esquadria junto do reboco interno com massa anti-umidade · eles nivelam o vão exato e bloqueiam infiltração antes dos vidros chegarem',
      },
      {
        icone: '🛒',
        texto:
          'Compre revestimentos, louças e metais no momento 3, não no 5 · ter material em mãos quando a equipe chega elimina lacunas que travam a obra',
      },
      {
        icone: '🧱',
        texto:
          'No momento 5, revesta paredes antes de instalar forros · o forro arremata nas paredes e não pode ser invertido sem refazimento',
      },
      {
        icone: '⚡',
        texto:
          '"Está liberado, ataca" · assim que uma etapa é desbloqueada inicie imediatamente; nunca adie porque "ainda é cedo"; cada dia de lacuna é custo fixo sem produção',
      },
    ],
    atencao: [
      {
        icone: '💧',
        texto:
          'Gesso interno em paredes parece econômico mas deteriora em ambientes úmidos e expõe irregularidades com iluminação de baixo ângulo · use massa em casas de médio e alto padrão',
      },
      {
        icone: '🔲',
        texto:
          'Esquecer de instalar contramarcos antes dos vidros: vão com 3–4mm de diferença impede a janela de entrar · retrabalho de alvenaria com parede rebocada destruída',
      },
      {
        icone: '🎨',
        texto:
          'Revestimentos e sistema de fachada são aquisições críticas (roxo) que travam pela dificuldade de decisão · cliente precisa de tempo para decidir acabamento; inicie essa definição no momento 3',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'exe-08-cl1',
        texto:
          'Decidi o sistema de reboco interno (massa ou gesso) alinhado ao padrão de acabamento da obra',
      },
      {
        id: 'exe-08-cl2',
        texto:
          'Instalei contramarcos de esquadria junto do reboco interno com massa anti-umidade em todos os vãos',
      },
      {
        id: 'exe-08-cl3',
        texto:
          'Comprei revestimentos e porcelanatos no momento 3 para ter material em mãos quando o momento 5 chegar',
      },
      {
        id: 'exe-08-cl4',
        texto:
          'Defini e fechei o sistema de fachada (pintura, textura, cimento queimado ou pedra) ainda no momento 3',
      },
      {
        id: 'exe-08-cl5',
        texto:
          'Comprei louças e metais no momento 3 para não travar a instalação final no momento 5',
      },
      {
        id: 'exe-08-cl6',
        texto: 'No momento 5 revesti as paredes antes de iniciar o forro em todos os ambientes',
      },
      {
        id: 'exe-08-cl7',
        texto:
          'Apliquei impermeabilizações assim que o reboco interno liberou, sem aguardar o momento 6',
      },
    ],
    metadados: [
      {
        campo: 'tipo_reboco_interno',
        label: 'Tipo de reboco interno',
        tipo: 'select',
        opcoes: [
          'Massa · padrão médio/alto',
          'Gesso · padrão econômico',
          'Misto · massa em áreas úmidas, gesso nas secas',
          'A definir',
        ],
      },
      {
        campo: 'sistema_fachada_escolhido',
        label: 'Sistema de fachada escolhido',
        tipo: 'select',
        opcoes: [
          'Pintura lisa',
          'Textura',
          'Cimento queimado',
          'Pedra natural',
          'Revestimento porcelânico',
          'Misto · a detalhar',
          'A definir',
        ],
      },
      {
        campo: 'revestimentos_comprados',
        label: 'Revestimentos já comprados?',
        tipo: 'select',
        opcoes: [
          'Sim · todos comprados e entregues',
          'Parcialmente · alguns itens pendentes',
          'Não · a comprar no momento certo',
          'Compra atrasada · urgente',
        ],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...EXE_CONTENT_08)

const EXE_CONTENT_09: TopicoContent[] = [
  {
    topicoId: 'exe-09',
    resumo: [
      'Momento 6: revestimento de piso após forro, bancadas e piscina · 2 a 2,5 meses; maior ponto de travamento',
      'Pisos, bancadas e piscina do momento 6 são interdependentes e aguardam forro + paredes + impermeabilização',
      'Luminárias compradas no momento 4 permitem coordenar o forro · depois geram retrabalho na pintura',
      'Esquadrias instaladas APÓS o emassamento · pó de lixa invade borrachas e canais de alumínio permanentemente',
      'Momento 8: portas prontas, finalização elétrica, limpeza final e start da marcenaria · máximo 1 mês',
      'Primeira metade (momentos 1–4) é o momento de decisões · a execução roda sem exigir escolhas do dono',
    ],
    dicasDeOuro: [
      {
        icone: '🪟',
        texto:
          'Faça o forro antes do piso · andaimes e cavaletes dos instaladores de forro amassariam o porcelanato novo; invertendo, cubra com madeirite e aceite o risco',
      },
      {
        icone: '💡',
        texto:
          'Compre luminárias no momento 4, antes do forro · luminária embutida especial pode ter seu recorte e reforço previstos no forro antes de ser tarde demais',
      },
      {
        icone: '🚪',
        texto:
          'Instale esquadrias somente após o emassamento · pó de lixa invade borrachas e canais de alumínio e nunca sai; com piso de madeira, lavar é impossível',
      },
      {
        icone: '🏁',
        texto:
          'Na primeira metade da obra (momentos 1–4) a execução não exige suas decisões · use esse fôlego para fechar todas as aquisições críticas e garantir segunda metade fluida',
      },
    ],
    atencao: [
      {
        icone: '🔗',
        texto:
          'Momento 6 é o maior ponto de travamento: pisos, bancadas e piscina aguardam forro + paredes + impermeabilização · qualquer item pendente paralisa todos ao mesmo tempo',
      },
      {
        icone: '⏳',
        texto:
          'Revestimentos elaborados (pastilha 10x10, pedra natural, ladrinho hidráulico) dilam o prazo do momento 6 em semanas · considere no cronograma antes de escolher o material',
      },
      {
        icone: '🪵',
        texto:
          'Marcenaria contratada tarde demais: produção leva 2–3 meses · defina eletrodomésticos e feche o contrato antes do momento 5 para garantir start no momento 8',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'exe-09-cl1',
        texto:
          'Finalizei o forro antes de iniciar o revestimento de piso para proteger o porcelanato durante trabalhos com andaimes',
      },
      {
        id: 'exe-09-cl2',
        texto:
          'Finalizei o forro antes de instalar bancadas para eliminar o risco de operários usarem a bancada pronta como andaime',
      },
      {
        id: 'exe-09-cl3',
        texto:
          'Comprei as luminárias no momento 4 (antes do forro) para coordenar recortes e reforços necessários no forro de gesso',
      },
      {
        id: 'exe-09-cl4',
        texto:
          'Instalei as esquadrias (janelas e portas externas) somente após o emassamento e primeira demão de pintura',
      },
      {
        id: 'exe-09-cl5',
        texto:
          'Contratei a marcenaria com definição de eletrodomésticos antes do momento 5 para garantir produção a tempo',
      },
      {
        id: 'exe-09-cl6',
        texto:
          'Administrei todas as aquisições críticas na primeira metade da obra (momentos 1–4) para não travar a segunda metade',
      },
    ],
    metadados: [
      {
        campo: 'luminárias_compradas_momento',
        label: 'Luminárias compradas em qual momento?',
        tipo: 'select',
        opcoes: [
          'Momento 4 · correto',
          'Momento 5 · risco moderado',
          'Momento 6 ou depois · risco alto de retrabalho',
          'Ainda não compradas',
        ],
      },
      {
        campo: 'marcenaria_contrato_status',
        label: 'Status do contrato de marcenaria',
        tipo: 'select',
        opcoes: [
          'Contratada com projeto definido',
          'Em orçamento',
          'Eletrodomésticos ainda a definir',
          'Não se aplica',
        ],
      },
      {
        campo: 'prazo_estimado_momento6_meses',
        label: 'Prazo estimado para o momento 6 (meses)',
        tipo: 'number',
        placeholder: 'Ex: 2',
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...EXE_CONTENT_09)

const EXE_CONTENT_10: TopicoContent[] = [
  {
    topicoId: 'exe-10',
    resumo: [
      'A decisão de cobertura tem 4 impactos: manutenção, custo, arquitetura da fachada e layout interno',
      'Telhado embutido: principal vantagem é o bolsão térmico · sol bate na telha, não na laje, reduzindo calor interno',
      'Manutenção do telhado: fácil mas frequente · calha, rufos (PU dura 1–2 anos) e acesso constante à cobertura',
      'Fibrocimento satura e pinga por baixo · use telha metálica ou sanduíche (metal + isopor) para menor risco',
      'Múltiplos pontos de fragilidade: trespasse, calha, rufo, moreta encharcada e parafusos perfurando a telha',
      'Cobertura com fotovoltaica e AC exige acesso frequente · caminhar sobre telhas trinca e cria infiltrações',
    ],
    dicasDeOuro: [
      {
        icone: '🌊',
        texto:
          'Posicione o rufo na segunda onda de telhas (não na primeira) · dificulta a passagem de água empurrada por vento forte em chuvas oblíquas',
      },
      {
        icone: '🔩',
        texto:
          'Exija fixação dos parafusos na parte alta da onda da telha · a água flui pela parte baixa e parafuso no fundo vira ponto certo de infiltração',
      },
      {
        icone: '🏚️',
        texto:
          'Aplique manta líquida ou gramaça polimérica na platibanda · em 20 dias seguidos de chuva, a moreta encharca e infiltra mesmo em obra 100% regular',
      },
      {
        icone: '🏗️',
        texto:
          'Instale o telhado somente após todas as tubulações (hidráulica, AC, fotovoltaica) estarem passadas · depois do telhado nada deve passar lá',
      },
    ],
    atencao: [
      {
        icone: '☀️',
        texto:
          "Coberturas modernas com fotovoltaica, AC, boiler e caixa d'água exigem acesso frequente · transitar sobre telhas trinca e empena, criando novos pontos de infiltração a cada visita",
      },
      {
        icone: '🌧️',
        texto:
          'Calha transborda em temporais intensos: registros históricos de chuva são batidos a cada ano · dimensione com folga de vazão e inspecione antes de cada temporada',
      },
      {
        icone: '🔧',
        texto:
          'Cada parafuso que perfura a telha · para fixar a própria telha, painel solar ou suporte de AC · é um ponto de entrada de água; mais equipamentos = mais perfurações',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'exe-10-cl1',
        texto:
          'Avaliei os 4 impactos da cobertura (manutenção, custo, arquitetura e layout interno) antes de decidir entre telhado e manta',
      },
      {
        id: 'exe-10-cl2',
        texto:
          'Escolhi o tipo de telha (metálica ou sanduíche) considerando que fibrocimento satura e representa risco de infiltração',
      },
      {
        id: 'exe-10-cl3',
        texto:
          'Instalei todas as tubulações (hidráulica, AC, fotovoltaica) antes de iniciar o madeiramento e telha',
      },
      {
        id: 'exe-10-cl4',
        texto:
          'Exigi que os rufos fossem posicionados na segunda onda de telhas para maior resistência à chuva de vento',
      },
      {
        id: 'exe-10-cl5',
        texto:
          'Exigi fixação dos parafusos sempre na parte alta da onda (onde a água não flui), não na parte baixa',
      },
      {
        id: 'exe-10-cl6',
        texto:
          'Apliquei manta líquida ou gramaça polimérica na platibanda/moreta para proteger contra encharcamento prolongado',
      },
    ],
    metadados: [
      {
        campo: 'sistema_cobertura_escolhido',
        label: 'Sistema de cobertura escolhido',
        tipo: 'select',
        opcoes: [
          'Telhado embutido · telha metálica',
          'Telhado embutido · telha sanduíche',
          'Telhado embutido · fibrocimento (risco)',
          'Laje impermeabilizada (manta)',
          'Ainda a decidir',
        ],
      },
      {
        campo: 'equipamentos_cobertura',
        label: 'Equipamentos previstos na cobertura',
        tipo: 'select',
        opcoes: [
          'Nenhum · cobertura simples',
          'Fotovoltaica apenas',
          'AC + fotovoltaica',
          "AC + fotovoltaica + boiler + caixa d'água",
          'Outros · detalhar nos metadados',
        ],
      },
      {
        campo: 'caimento_telhado_perc',
        label: 'Caimento do telhado (%)',
        tipo: 'number',
        placeholder: 'Ex: 30 (mínimo recomendado)',
      },
    ],
    temFerramenta: true,
  },
]

TOPICOS_CONTENT.push(...EXE_CONTENT_10)

const EXE_CONTENT_11: TopicoContent[] = [
  {
    topicoId: 'exe-11',
    resumo: [
      'Laje impermeabilizada usa a mesma tecnologia de piscina · lâmina de 10cm por semanas sem vazar',
      'Manta exposta: 10–15 anos de durabilidade com rastreamento imediato de problemas sem destruir o piso',
      'Manta com proteção mecânica: 20–30+ anos mas vazamento exige remover o piso inteiro para encontrar o ponto',
      'Custo: telhado, manta com proteção e manta aluminizada são grandezas comparáveis · diferença máxima de 50%',
      'Laje dispensa moreta de 80cm e permite silhueta finissima · vantagem arquitetônica real sobre o telhado',
      'Na laje você escolhe onde ficam os ralos; no telhado as calhas ditam os pontos de descida de água',
    ],
    dicasDeOuro: [
      {
        icone: '🏢',
        texto:
          'Contrate empresa especializada para manta asfáltica · pedreiro não dá garantia; empresa especializada garante produto + mão de obra e pode ser acionada em caso de falha',
      },
      {
        icone: '🧪',
        texto:
          'Faça o teste de lâmina de água (10cm por ao menos 2 semanas) antes de cobrir a laje com proteção mecânica · valida a impermeabilização antes de enterrá-la sob o piso',
      },
      {
        icone: '🔍',
        texto:
          'Prefira sistema exposto se a cobertura terá fotovoltaica, AC ou boiler · problema é rastreado e retocado em minutos; sistema coberto exige remoção total do piso',
      },
      {
        icone: '🏚️',
        texto:
          'Suba a manta até a platibanda em toda a sua altura · a moreta encharca em períodos prolongados de chuva e infiltra pela alvenaria mesmo em obra regular',
      },
    ],
    atencao: [
      {
        icone: '❌',
        texto:
          'Manta líquida e argamaça polimérica não servem para laje externa · são produtos para interiores (banheiros); a laje dilata com o sol e rompe esses materiais prematuramente',
      },
      {
        icone: '⚖️',
        texto:
          'Manta sem proteção mecânica dura 10–15 anos; com proteção mecânica chega a 20–30 · pense no custo de refazer vs na facilidade de diagnóstico antes de escolher',
      },
      {
        icone: '🗂️',
        texto:
          'Telhado embutido limita posição dos tubos de chuva aos cantos e centro · em plantas abertas modernas pode não haver como esconder o tubo de descida, comprometendo a estética',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'exe-11-cl1',
        texto:
          'Descartei manta líquida e argamaça polimérica · optei por manta asfáltica, poliureia ou membrana de alto desempenho para a laje',
      },
      {
        id: 'exe-11-cl2',
        texto:
          'Contratei empresa especializada para a impermeabilização com garantia de produto e aplicação',
      },
      {
        id: 'exe-11-cl3',
        texto:
          'Decidi entre sistema com proteção mecânica (durabilidade 20–30 anos) ou exposto (rastreamento fácil, 10–15 anos)',
      },
      {
        id: 'exe-11-cl4',
        texto:
          'Realizei o teste de lâmina de água (10cm por ao menos 2 semanas) antes de cobrir ou finalizar a laje',
      },
      {
        id: 'exe-11-cl5',
        texto: 'Subi a manta até a platibanda/moreta para proteção contra encharcamento prolongado',
      },
      {
        id: 'exe-11-cl6',
        texto:
          'Defini a posição dos ralos e descidas de água com base no layout interno (closets, paredes), não nos cantos pré-definidos como no telhado',
      },
    ],
    metadados: [
      {
        campo: 'sistema_impermeabilizacao_laje',
        label: 'Sistema de impermeabilização da laje',
        tipo: 'select',
        opcoes: [
          'Manta asfáltica + proteção mecânica',
          'Manta asfáltica exposta',
          'Manta aluminizada (exposta)',
          'Manta ardoziada',
          'Poliureia (PU) exposta',
          'Membrana de alto desempenho',
          'Telhado · não se aplica',
        ],
      },
      {
        campo: 'manta_exposta_ou_coberta',
        label: 'Sistema exposto ou com proteção mecânica?',
        tipo: 'select',
        opcoes: [
          'Exposto · rastreamento fácil, 10–15 anos',
          'Coberto · maior durabilidade, 20–30 anos',
          'Aluminizado · exposto sem precisar de piso',
          'A definir com especialista',
        ],
      },
      {
        campo: 'teste_lamina_realizado',
        label: 'Teste de lâmina de água realizado?',
        tipo: 'select',
        opcoes: [
          'Sim · aprovado após 2+ semanas',
          'Sim · aprovado após 3 dias (norma)',
          'Não realizado · laje já coberta',
          'Previsto para realizar',
        ],
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...EXE_CONTENT_11)

const EXE_CONTENT_12: TopicoContent[] = [
  {
    topicoId: 'exe-12',
    resumo: [
      'O critério mais importante na fachada é o quão fácil é retocar depois',
      'Textura não aceita emenda · qualquer reparo exige refazer o pano todo de uma vez',
      'Pintura lisa não cobre imperfeições: reboco externo perfeito é pré-requisito obrigatório',
      'Cimento queimado: 3 camadas (massa acrílica → cimento → resina) com retoque localizado',
      'Resina do cimento queimado desgasta em ~2 anos nas faces que pegam sol da tarde',
      'Uma manutenção de fachada (andame + mão de obra + material) custa ~R$15–18 mil',
      'Diferença entre o sistema mais barato e o mais caro equivale a ~1% do custo da obra',
    ],
    dicasDeOuro: [
      {
        icone: '🏆',
        texto:
          'Ranking recomendado: pintura lisa 1º, cimento queimado 2º, textura 3º · decida sempre pela facilidade de manutenção, não pela economia inicial de execução',
      },
      {
        icone: '🧱',
        texto:
          'Invista num reboco externo impecável se for usar pintura lisa · ela revela cada imperfeição do substrato e não há como corrigir depois sem refazer a base',
      },
      {
        icone: '✂️',
        texto:
          'Projete frisos de dilatação nos panos de fachada para isolar setores: assim um retoque futuro dispensa montar andaime na fachada inteira',
      },
      {
        icone: '📊',
        texto:
          'Compare o custo de manutenção, não só o de execução · uma única manutenção de fachada (~R$15–18 mil) já cobre a diferença entre escolher o sistema mais barato ou o mais caro',
      },
      {
        icone: '☀️',
        texto:
          'Em faces de sol da tarde com cimento queimado, planeje reaplicação de resina a cada 2 anos · é rápido com rolinho, mas exige andaime montado em terreno muitas vezes irregular',
      },
    ],
    atencao: [
      {
        icone: '⚠️',
        texto:
          'Textura sem friso de dilatação obriga a refazer o pano inteiro em qualquer reparo · mão de obra de manutenção tende a ser mais cara que a de execução por mobilização mínima',
      },
      {
        icone: '💸',
        texto:
          'Cimento queimado é o sistema mais caro de todos · pode custar 2x mais que textura arenita em 400 m² de fachada, além de exigir mão de obra especializada para a aplicação',
      },
      {
        icone: '🏗️',
        texto:
          'Cerâmica nativa e pastilhas têm alto índice de eflorescência e manutenção cara no longo prazo · soluções que fogem da lógica de pintura têm durabilidade maior, mas custo de execução muito superior',
      },
    ],
    checklistAplicabilidade: [
      {
        id: 'exe-12-cl1',
        texto:
          'Defini o sistema de fachada usando o tripé: custo de execução, capacidade de cobrir imperfeições e facilidade de retoque',
      },
      {
        id: 'exe-12-cl2',
        texto:
          'Calculei a área de fachada líquida descontando vidros, pedras e revestimentos especiais já planejados',
      },
      {
        id: 'exe-12-cl3',
        texto:
          'Comparei o custo de manutenção futuro de cada sistema · não apenas o custo de execução inicial',
      },
      {
        id: 'exe-12-cl4',
        texto:
          'Verifiquei a qualidade do reboco externo antes de confirmar pintura lisa como sistema de fachada',
      },
      {
        id: 'exe-12-cl5',
        texto:
          'Projetei frisos de dilatação nos panos de fachada para isolar setores e permitir retoques localizados',
      },
      {
        id: 'exe-12-cl6',
        texto:
          'Identifiquei as faces expostas ao sol da tarde para programar manutenção bienal da resina (se cimento queimado)',
      },
      {
        id: 'exe-12-cl7',
        texto:
          'Contratei mão de obra especializada em cimento queimado com comprovação de obras executadas (se for o sistema escolhido)',
      },
      {
        id: 'exe-12-cl8',
        texto:
          'Planejei a execução da fachada em etapas para evitar mobilização completa de andaime em todas as faces ao mesmo tempo',
      },
    ],
    metadados: [
      {
        campo: 'sistema_fachada_escolhido',
        label: 'Sistema de fachada escolhido',
        tipo: 'select',
        opcoes: [
          'Pintura lisa',
          'Cimento queimado',
          'Textura arenita',
          'Textura rolada / grafiato',
          'Pedra natural',
          'ACM / Concreto aparente / Vidro',
          'Combinação de sistemas',
          'A definir',
        ],
      },
      {
        campo: 'area_fachada_liquida_m2',
        label: 'Área de fachada líquida (sem vidros/pedras)',
        tipo: 'number',
        placeholder: 'Ex: 280 m² (descontados vidros e revestimentos)',
      },
      {
        campo: 'frisos_dilatacao_planejados',
        label: 'Frisos de dilatação planejados nos panos?',
        tipo: 'select',
        opcoes: [
          'Sim · panos subdivididos com frisos visíveis',
          'Sim · frisos em junta discreta',
          'Não planejado',
          'Em análise com arquiteto',
        ],
      },
      {
        campo: 'custo_estimado_fachada_rs',
        label: 'Custo estimado da fachada (R$)',
        tipo: 'number',
        placeholder: 'Ex: 36000 (material + mão de obra)',
      },
    ],
    temFerramenta: false,
  },
]

TOPICOS_CONTENT.push(...EXE_CONTENT_12)

const CONTENT_MAP = new Map(TOPICOS_CONTENT.map((c) => [c.topicoId, c]))

export function getTopicoContent(topicoId: string): TopicoContent | null {
  return CONTENT_MAP.get(topicoId) ?? null
}
